export const areaCodeList = [{
  code: 0, name: "미선택", sub: [{
    code: 0, name: "미선택"
  }]
}, {
  code: 1, name: "서울특별시", sub: [{
    code: 1111000000, name: "종로구"
  }, {
    code: 1114000000, name: "중구"
  }, {
    code: 1117000000, name: "용산구"
  }, {
    code: 1120000000, name: "성동구"
  }, {
    code: 1121500000, name: "광진구"
  }, {
    code: 1123000000, name: "동대문구"
  }, {
    code: 1126000000, name: "중랑구"
  }, {
    code: 1129000000, name: "성북구"
  }, {
    code: 1130500000, name: "강북구"
  }, {
    code: 1132000000, name: "도봉구"
  }, {
    code: 1135000000, name: "노원구"
  }, {
    code: 1138000000, name: "은평구"
  }, {
    code: 1141000000, name: "서대문구"
  }, {
    code: 1144000000, name: "마포구"
  }, {
    code: 1147000000, name: "양천구"
  }, {
    code: 1150000000, name: "강서구"
  }, {
    code: 1153000000, name: "구로구"
  }, {
    code: 1154500000, name: "금천구"
  }, {
    code: 1156000000, name: "영등포구"
  }, {
    code: 1159000000, name: "동작구"
  }, {
    code: 1162000000, name: "관악구"
  }, {
    code: 1165000000, name: "서초구"
  }, {
    code: 1168000000, name: "강남구"
  }, {
    code: 1171000000, name: "송파구"
  }, {
    code: 1174000000, name: "강동구"
  }]
}, {
  code: 2, name: "부산광역시", sub: [{
    code: 2611000000, name: "중구"
  }, {
    code: 2614000000, name: "서구"
  }, {
    code: 2617000000, name: "동구"
  }, {
    code: 2620000000, name: "영도구"
  }, {
    code: 2623000000, name: "부산진구"
  }, {
    code: 2626000000, name: "동래구"
  }, {
    code: 2629000000, name: "남구"
  }, {
    code: 2632000000, name: "북구"
  }, {
    code: 2635000000, name: "해운대구"
  }, {
    code: 2638000000, name: "사하구"
  }, {
    code: 2641000000, name: "금정구"
  }, {
    code: 2644000000, name: "강서구"
  }, {
    code: 2647000000, name: "연제구"
  }, {
    code: 2650000000, name: "수영구"
  }, {
    code: 2653000000, name: "사상구"
  }, {
    code: 2671000000, name: "기장군"
  }]
}, {
  code: 3, name: "인천광역시", sub: [{
    code: 2811000000, name: "중구"
  }, {
    code: 2814000000, name: "동구"
  }, {
    code: 2817700000, name: "미추홀구"
  }, {
    code: 2818500000, name: "연수구"
  }, {
    code: 2820000000, name: "남동구"
  }, {
    code: 2823700000, name: "부평구"
  }, {
    code: 2824500000, name: "계양구"
  }, {
    code: 2826000000, name: "서구"
  }, {
    code: 2871000000, name: "강화군"
  }, {
    code: 2872000000, name: "옹진군"
  }]
}, {
  code: 4, name: "대구광역시", sub: [{
    code: 2711000000, name: "중구"
  }, {
    code: 2714000000, name: "동구"
  }, {
    code: 2717000000, name: "서구"
  }, {
    code: 2720000000, name: "남구"
  }, {
    code: 2723000000, name: "북구"
  }, {
    code: 2726000000, name: "수성구"
  }, {
    code: 2729000000, name: "달서구"
  }, {
    code: 2771000000, name: "달성군"
  }, {
    code: 2772000000, name: "군위군"
  }]
}, {
  code: 5, name: "대전광역시", sub: [{
    code: 3011000000, name: "동구"
  }, {
    code: 3014000000, name: "중구"
  }, {
    code: 3017000000, name: "서구"
  }, {
    code: 3020000000, name: "유성구"
  }, {
    code: 3023000000, name: "대덕구"
  }]
}, {
  code: 6, name: "광주광역시", sub: [{
    code: 2911000000, name: "동구"
  }, {
    code: 2914000000, name: "서구"
  }, {
    code: 2915500000, name: "남구"
  }, {
    code: 2917000000, name: "북구"
  }, {
    code: 2920000000, name: "광산구"
  }]
}, {
  code: 7, name: "울산광역시", sub: [{
    code: 3111000000, name: "중구"
  }, {
    code: 3114000000, name: "남구"
  }, {
    code: 3117000000, name: "동구"
  }, {
    code: 3120000000, name: "북구"
  }, {
    code: 3171000000, name: "울주군"
  }]
}, {
  code: 8, name: "세종특별자치시", sub: [{
    code: 3611000000, name: "세종특별자치시"
  }]
}, {
  code: 9, name: "경기도", sub: [{
    code: 4111000000, name: "수원시"
  }, {
    code: 4146000000, name: "용인시"
  }, {
    code: 4128000000, name: "고양시"
  }, {
    code: 4159000000, name: "화성시"
  }, {
    code: 4113000000, name: "성남시"
  }, {
    code: 4119000000, name: "부천시"
  }, {
    code: 4136000000, name: "남양주시"
  }, {
    code: 4127000000, name: "안산시"
  }, {
    code: 4122000000, name: "평택시"
  }, {
    code: 4117000000, name: "안양시"
  }, {
    code: 4139000000, name: "시흥시"
  }, {
    code: 4148000000, name: "파주시"
  }, {
    code: 4157000000, name: "김포시"
  }, {
    code: 4115000000, name: "의정부시"
  }, {
    code: 4161000000, name: "광주시"
  }, {
    code: 4145000000, name: "하남시"
  }, {
    code: 4121000000, name: "광명시"
  }, {
    code: 4141000000, name: "군포시"
  }, {
    code: 4163000000, name: "양주시"
  }, {
    code: 4137000000, name: "오산시"
  }, {
    code: 4150000000, name: "이천시"
  }, {
    code: 4155000000, name: "안성시"
  }, {
    code: 4131000000, name: "구리시"
  }, {
    code: 4143000000, name: "의왕시"
  }, {
    code: 4165000000, name: "포천시"
  }, {
    code: 4183000000, name: "양평군"
  }, {
    code: 4167000000, name: "여주시"
  }, {
    code: 4125000000, name: "동두천시"
  }, {
    code: 4129000000, name: "과천시"
  }, {
    code: 4182000000, name: "가평군"
  }, {
    code: 4180000000, name: "연천군"
  }]
}, {
  code: 10, name: "강원도", sub: [{
    code: 5111000000, name: "춘천시"
  }, {
    code: 5113000000, name: "원주시"
  }, {
    code: 5115000000, name: "강릉시"
  }, {
    code: 5117000000, name: "동해시"
  }, {
    code: 5119000000, name: "태백시"
  }, {
    code: 5121000000, name: "속초시"
  }, {
    code: 5123000000, name: "삼척시"
  }, {
    code: 5172000000, name: "홍천군"
  }, {
    code: 5173000000, name: "횡성군"
  }, {
    code: 5173000000, name: "영월군"
  }, {
    code: 5176000000, name: "평창군"
  }, {
    code: 5177000000, name: "정선군"
  }, {
    code: 5178000000, name: "철원군"
  }, {
    code: 5179000000, name: "화천군"
  }, {
    code: 5180000000, name: "양구군"
  }, {
    code: 5181000000, name: "인제군"
  }, {
    code: 5182000000, name: "고성군"
  }, {
    code: 5183000000, name: "양양군"
  }]
}, {
  code: 11, name: "충청북도", sub: [{
    code: 4311000000, name: "청주시"
  }, {
    code: 4313000000, name: "충주시"
  }, {
    code: 4315000000, name: "제천시"
  }, {
    code: 4372000000, name: "보은군"
  }, {
    code: 4373000000, name: "옥천군"
  }, {
    code: 4374000000, name: "영동군"
  }, {
    code: 4374500000, name: "증평군"
  }, {
    code: 4375000000, name: "진천군"
  }, {
    code: 4376000000, name: "괴산군"
  }, {
    code: 4377000000, name: "음성군"
  }, {
    code: 4380000000, name: "단양군"
  }]
}, {
  code: 12, name: "충청남도", sub: [{
    code: 4413000000, name: "천안시"
  }, {
    code: 4415000000, name: "공주시"
  }, {
    code: 4418000000, name: "보령시"
  }, {
    code: 4420000000, name: "아산시"
  }, {
    code: 4421000000, name: "서산시"
  }, {
    code: 4423000000, name: "논산시"
  }, {
    code: 4425000000, name: "계룡시"
  }, {
    code: 4427000000, name: "당진시"
  }, {
    code: 4471000000, name: "금산군"
  }, {
    code: 4476000000, name: "부여군"
  }, {
    code: 4477000000, name: "서천군"
  }, {
    code: 4479000000, name: "청양군"
  }, {
    code: 4480000000, name: "홍성군"
  }, {
    code: 4481000000, name: "예산군"
  }, {
    code: 4482500000, name: "태안군"
  }]
}, {
  code: 13, name: "전라북도", sub: [{
    code: 4511000000, name: "전주시"
  }, {
    code: 4513000000, name: "군산시"
  }, {
    code: 4514000000, name: "익산시"
  }, {
    code: 4518000000, name: "정읍시"
  }, {
    code: 4519000000, name: "남원시"
  }, {
    code: 4521000000, name: "김제시"
  }, {
    code: 4571000000, name: "완주군"
  }, {
    code: 4572000000, name: "진안군"
  }, {
    code: 4573000000, name: "무주군"
  }, {
    code: 4574000000, name: "장수군"
  }, {
    code: 4575000000, name: "임실군"
  }, {
    code: 4577000000, name: "순창군"
  }, {
    code: 4579000000, name: "고창군"
  }, {
    code: 4580000000, name: "부안군"
  }]
}, {
  code: 14, name: "전라남도", sub: [{
    code: 4611000000, name: "목포시"
  }, {
    code: 4613000000, name: "여수시"
  }, {
    code: 4615000000, name: "순천시"
  }, {
    code: 4617000000, name: "나주시"
  }, {
    code: 4623000000, name: "광양시"
  }, {
    code: 4671000000, name: "담양군"
  }, {
    code: 4672000000, name: "곡성군"
  }, {
    code: 4673000000, name: "구례군"
  }, {
    code: 4677000000, name: "고흥군"
  }, {
    code: 4678000000, name: "보성군"
  }, {
    code: 4679000000, name: "화순군"
  }, {
    code: 4680000000, name: "장흥군"
  }, {
    code: 4681000000, name: "강진군"
  }, {
    code: 4682000000, name: "해남군"
  }, {
    code: 4683000000, name: "영암군"
  }, {
    code: 4684000000, name: "무안군"
  }, {
    code: 4686000000, name: "함평군"
  }, {
    code: 4687000000, name: "영광군"
  }, {
    code: 4688000000, name: "장성군"
  }, {
    code: 4689000000, name: "완도군"
  }, {
    code: 4690000000, name: "진도군"
  }, {
    code: 4691000000, name: "신안군"
  }]
}, {
  code: 15, name: "경상북도", sub: [{
    code: 4711000000, name: "포항시"
  }, {
    code: 4713000000, name: "경주시"
  }, {
    code: 4715000000, name: "김천시"
  }, {
    code: 4717000000, name: "안동시"
  }, {
    code: 4719000000, name: "구미시"
  }, {
    code: 4721000000, name: "영주시"
  }, {
    code: 4723000000, name: "영천시"
  }, {
    code: 4725000000, name: "상주시"
  }, {
    code: 4728000000, name: "문경시"
  }, {
    code: 4729000000, name: "경산시"
  }, {
    code: 4773000000, name: "의성군"
  }, {
    code: 4775000000, name: "청송군"
  }, {
    code: 4776000000, name: "영양군"
  }, {
    code: 4777000000, name: "영덕군"
  }, {
    code: 4782000000, name: "청도군"
  }, {
    code: 4783000000, name: "고령군"
  }, {
    code: 4784000000, name: "성주군"
  }, {
    code: 4785000000, name: "칠곡군"
  }, {
    code: 4790000000, name: "예천군"
  }, {
    code: 4792000000, name: "봉화군"
  }, {
    code: 4793000000, name: "울진군"
  }, {
    code: 4794000000, name: "울릉군"
  }]
}, {
  code: 16, name: "경상남도", sub: [{
    code: 4812000000, name: "창원시"
  }, {
    code: 4817000000, name: "진주시"
  }, {
    code: 4822000000, name: "통영시"
  }, {
    code: 4824000000, name: "사천시"
  }, {
    code: 4825000000, name: "김해시"
  }, {
    code: 4827000000, name: "밀양시"
  }, {
    code: 4831000000, name: "거제시"
  }, {
    code: 4833000000, name: "양산시"
  }, {
    code: 4872000000, name: "의령군"
  }, {
    code: 4873000000, name: "함안군"
  }, {
    code: 4874000000, name: "창녕군"
  }, {
    code: 4882000000, name: "고성군"
  }, {
    code: 4884000000, name: "남해군"
  }, {
    code: 4885000000, name: "하동군"
  }, {
    code: 4886000000, name: "산청군"
  }, {
    code: 4887000000, name: "함양군"
  }, {
    code: 4888000000, name: "거창군"
  }, {
    code: 4889000000, name: "합천군"
  }]
}, {
  code: 17, name: "제주특별자치도", sub: [{
    code: 5011000000, name: "제주시"
  }, {
    code: 5013000000, name: "서귀포시"
  }]
}]

export const areaCodeList2 = [
  {
    "code": "0",
    "name": "미선택",
    "sub": [{
      "code": "0",
      "name": "미선택"
    }]
  },
  {
    "code": "11",
    "name": "서울특별시",
    "sub": [
      {
        "code": "11110",
        "name": "종로구",
        "sub": [
          {
            "code": "1111051500",
            "name": "청운효자동"
          },
          {
            "code": "1111053000",
            "name": "사직동"
          },
          {
            "code": "1111054000",
            "name": "삼청동"
          },
          {
            "code": "1111055000",
            "name": "부암동"
          },
          {
            "code": "1111056000",
            "name": "평창동"
          },
          {
            "code": "1111057000",
            "name": "무악동"
          },
          {
            "code": "1111058000",
            "name": "교남동"
          },
          {
            "code": "1111060000",
            "name": "가회동"
          },
          {
            "code": "1111061500",
            "name": "종로1.2.3.4가동"
          },
          {
            "code": "1111063000",
            "name": "종로5.6가동"
          },
          {
            "code": "1111064000",
            "name": "이화동"
          },
          {
            "code": "1111065000",
            "name": "혜화동"
          },
          {
            "code": "1111067000",
            "name": "창신제1동"
          },
          {
            "code": "1111068000",
            "name": "창신제2동"
          },
          {
            "code": "1111069000",
            "name": "창신제3동"
          },
          {
            "code": "1111070000",
            "name": "숭인제1동"
          },
          {
            "code": "1111071000",
            "name": "숭인제2동"
          }
        ]
      },
      {
        "code": "11140",
        "name": "중구",
        "sub": [
          {
            "code": "1114052000",
            "name": "소공동"
          },
          {
            "code": "1114054000",
            "name": "회현동"
          },
          {
            "code": "1114055000",
            "name": "명동"
          },
          {
            "code": "1114057000",
            "name": "필동"
          },
          {
            "code": "1114058000",
            "name": "장충동"
          },
          {
            "code": "1114059000",
            "name": "광희동"
          },
          {
            "code": "1114060500",
            "name": "을지로동"
          },
          {
            "code": "1114061500",
            "name": "신당동"
          },
          {
            "code": "1114062500",
            "name": "다산동"
          },
          {
            "code": "1114063500",
            "name": "약수동"
          },
          {
            "code": "1114064500",
            "name": "청구동"
          },
          {
            "code": "1114065000",
            "name": "신당제5동"
          },
          {
            "code": "1114066500",
            "name": "동화동"
          },
          {
            "code": "1114067000",
            "name": "황학동"
          },
          {
            "code": "1114068000",
            "name": "중림동"
          }
        ]
      },
      {
        "code": "11170",
        "name": "용산구",
        "sub": [
          {
            "code": "1117051000",
            "name": "후암동"
          },
          {
            "code": "1117052000",
            "name": "용산2가동"
          },
          {
            "code": "1117053000",
            "name": "남영동"
          },
          {
            "code": "1117055500",
            "name": "청파동"
          },
          {
            "code": "1117056000",
            "name": "원효로제1동"
          },
          {
            "code": "1117057000",
            "name": "원효로제2동"
          },
          {
            "code": "1117058000",
            "name": "효창동"
          },
          {
            "code": "1117059000",
            "name": "용문동"
          },
          {
            "code": "1117062500",
            "name": "한강로동"
          },
          {
            "code": "1117063000",
            "name": "이촌제1동"
          },
          {
            "code": "1117064000",
            "name": "이촌제2동"
          },
          {
            "code": "1117065000",
            "name": "이태원제1동"
          },
          {
            "code": "1117066000",
            "name": "이태원제2동"
          },
          {
            "code": "1117068500",
            "name": "한남동"
          },
          {
            "code": "1117069000",
            "name": "서빙고동"
          },
          {
            "code": "1117070000",
            "name": "보광동"
          }
        ]
      },
      {
        "code": "11200",
        "name": "성동구",
        "sub": [
          {
            "code": "1120052000",
            "name": "왕십리제2동"
          },
          {
            "code": "1120053500",
            "name": "왕십리도선동"
          },
          {
            "code": "1120054000",
            "name": "마장동"
          },
          {
            "code": "1120055000",
            "name": "사근동"
          },
          {
            "code": "1120056000",
            "name": "행당제1동"
          },
          {
            "code": "1120057000",
            "name": "행당제2동"
          },
          {
            "code": "1120058000",
            "name": "응봉동"
          },
          {
            "code": "1120059000",
            "name": "금호1가동"
          },
          {
            "code": "1120061500",
            "name": "금호2.3가동"
          },
          {
            "code": "1120062000",
            "name": "금호4가동"
          },
          {
            "code": "1120064500",
            "name": "옥수동"
          },
          {
            "code": "1120065000",
            "name": "성수1가제1동"
          },
          {
            "code": "1120066000",
            "name": "성수1가제2동"
          },
          {
            "code": "1120067000",
            "name": "성수2가제1동"
          },
          {
            "code": "1120069000",
            "name": "성수2가제3동"
          },
          {
            "code": "1120072000",
            "name": "송정동"
          },
          {
            "code": "1120079000",
            "name": "용답동"
          }
        ]
      },
      {
        "code": "11215",
        "name": "광진구",
        "sub": [
          {
            "code": "1121571000",
            "name": "화양동"
          },
          {
            "code": "1121573000",
            "name": "군자동"
          },
          {
            "code": "1121574000",
            "name": "중곡제1동"
          },
          {
            "code": "1121575000",
            "name": "중곡제2동"
          },
          {
            "code": "1121576000",
            "name": "중곡제3동"
          },
          {
            "code": "1121577000",
            "name": "중곡제4동"
          },
          {
            "code": "1121578000",
            "name": "능동"
          },
          {
            "code": "1121581000",
            "name": "광장동"
          },
          {
            "code": "1121582000",
            "name": "자양제1동"
          },
          {
            "code": "1121583000",
            "name": "자양제2동"
          },
          {
            "code": "1121584000",
            "name": "자양제3동"
          },
          {
            "code": "1121584700",
            "name": "자양제4동"
          },
          {
            "code": "1121585000",
            "name": "구의제1동"
          },
          {
            "code": "1121586000",
            "name": "구의제2동"
          },
          {
            "code": "1121587000",
            "name": "구의제3동"
          }
        ]
      },
      {
        "code": "11230",
        "name": "동대문구",
        "sub": [
          {
            "code": "1123053600",
            "name": "용신동"
          },
          {
            "code": "1123054500",
            "name": "제기동"
          },
          {
            "code": "1123056000",
            "name": "전농제1동"
          },
          {
            "code": "1123057000",
            "name": "전농제2동"
          },
          {
            "code": "1123060000",
            "name": "답십리제1동"
          },
          {
            "code": "1123061000",
            "name": "답십리제2동"
          },
          {
            "code": "1123065000",
            "name": "장안제1동"
          },
          {
            "code": "1123066000",
            "name": "장안제2동"
          },
          {
            "code": "1123070500",
            "name": "청량리동"
          },
          {
            "code": "1123071000",
            "name": "회기동"
          },
          {
            "code": "1123072000",
            "name": "휘경제1동"
          },
          {
            "code": "1123073000",
            "name": "휘경제2동"
          },
          {
            "code": "1123074000",
            "name": "이문제1동"
          },
          {
            "code": "1123075000",
            "name": "이문제2동"
          }
        ]
      },
      {
        "code": "11260",
        "name": "중랑구",
        "sub": [
          {
            "code": "1126052000",
            "name": "면목제2동"
          },
          {
            "code": "1126054000",
            "name": "면목제4동"
          },
          {
            "code": "1126055000",
            "name": "면목제5동"
          },
          {
            "code": "1126056500",
            "name": "면목본동"
          },
          {
            "code": "1126057000",
            "name": "면목제7동"
          },
          {
            "code": "1126057500",
            "name": "면목제3.8동"
          },
          {
            "code": "1126058000",
            "name": "상봉제1동"
          },
          {
            "code": "1126059000",
            "name": "상봉제2동"
          },
          {
            "code": "1126060000",
            "name": "중화제1동"
          },
          {
            "code": "1126061000",
            "name": "중화제2동"
          },
          {
            "code": "1126062000",
            "name": "묵제1동"
          },
          {
            "code": "1126063000",
            "name": "묵제2동"
          },
          {
            "code": "1126065500",
            "name": "망우본동"
          },
          {
            "code": "1126066000",
            "name": "망우제3동"
          },
          {
            "code": "1126068000",
            "name": "신내1동"
          },
          {
            "code": "1126069000",
            "name": "신내2동"
          }
        ]
      },
      {
        "code": "11290",
        "name": "성북구",
        "sub": [
          {
            "code": "1129052500",
            "name": "성북동"
          },
          {
            "code": "1129055500",
            "name": "삼선동"
          },
          {
            "code": "1129057500",
            "name": "동선동"
          },
          {
            "code": "1129058000",
            "name": "돈암제1동"
          },
          {
            "code": "1129059000",
            "name": "돈암제2동"
          },
          {
            "code": "1129060000",
            "name": "안암동"
          },
          {
            "code": "1129061000",
            "name": "보문동"
          },
          {
            "code": "1129062000",
            "name": "정릉제1동"
          },
          {
            "code": "1129063000",
            "name": "정릉제2동"
          },
          {
            "code": "1129064000",
            "name": "정릉제3동"
          },
          {
            "code": "1129065000",
            "name": "정릉제4동"
          },
          {
            "code": "1129066000",
            "name": "길음제1동"
          },
          {
            "code": "1129068500",
            "name": "길음제2동"
          },
          {
            "code": "1129070500",
            "name": "종암동"
          },
          {
            "code": "1129071500",
            "name": "월곡제1동"
          },
          {
            "code": "1129072500",
            "name": "월곡제2동"
          },
          {
            "code": "1129076000",
            "name": "장위제1동"
          },
          {
            "code": "1129077000",
            "name": "장위제2동"
          },
          {
            "code": "1129078000",
            "name": "장위제3동"
          },
          {
            "code": "1129081000",
            "name": "석관동"
          }
        ]
      },
      {
        "code": "11305",
        "name": "강북구",
        "sub": [
          {
            "code": "1130553400",
            "name": "삼양동"
          },
          {
            "code": "1130553500",
            "name": "미아동"
          },
          {
            "code": "1130554500",
            "name": "송중동"
          },
          {
            "code": "1130555500",
            "name": "송천동"
          },
          {
            "code": "1130557500",
            "name": "삼각산동"
          },
          {
            "code": "1130559500",
            "name": "번1동"
          },
          {
            "code": "1130560300",
            "name": "번2동"
          },
          {
            "code": "1130560800",
            "name": "번3동"
          },
          {
            "code": "1130561500",
            "name": "수유1동"
          },
          {
            "code": "1130562500",
            "name": "수유2동"
          },
          {
            "code": "1130563500",
            "name": "수유3동"
          },
          {
            "code": "1130564500",
            "name": "우이동"
          },
          {
            "code": "1130566000",
            "name": "인수동"
          }
        ]
      },
      {
        "code": "11320",
        "name": "도봉구",
        "sub": [
          {
            "code": "1132051100",
            "name": "창제1동"
          },
          {
            "code": "1132051200",
            "name": "창제2동"
          },
          {
            "code": "1132051300",
            "name": "창제3동"
          },
          {
            "code": "1132051400",
            "name": "창제4동"
          },
          {
            "code": "1132051500",
            "name": "창제5동"
          },
          {
            "code": "1132052100",
            "name": "도봉제1동"
          },
          {
            "code": "1132052200",
            "name": "도봉제2동"
          },
          {
            "code": "1132066000",
            "name": "쌍문제1동"
          },
          {
            "code": "1132067000",
            "name": "쌍문제2동"
          },
          {
            "code": "1132068000",
            "name": "쌍문제3동"
          },
          {
            "code": "1132068100",
            "name": "쌍문제4동"
          },
          {
            "code": "1132069000",
            "name": "방학제1동"
          },
          {
            "code": "1132070000",
            "name": "방학제2동"
          },
          {
            "code": "1132071000",
            "name": "방학제3동"
          }
        ]
      },
      {
        "code": "11350",
        "name": "노원구",
        "sub": [
          {
            "code": "1135056000",
            "name": "월계1동"
          },
          {
            "code": "1135057000",
            "name": "월계2동"
          },
          {
            "code": "1135058000",
            "name": "월계3동"
          },
          {
            "code": "1135059500",
            "name": "공릉1동"
          },
          {
            "code": "1135060000",
            "name": "공릉2동"
          },
          {
            "code": "1135061100",
            "name": "하계1동"
          },
          {
            "code": "1135061200",
            "name": "하계2동"
          },
          {
            "code": "1135061900",
            "name": "중계본동"
          },
          {
            "code": "1135062100",
            "name": "중계1동"
          },
          {
            "code": "1135062400",
            "name": "중계4동"
          },
          {
            "code": "1135062500",
            "name": "중계2.3동"
          },
          {
            "code": "1135063000",
            "name": "상계1동"
          },
          {
            "code": "1135064000",
            "name": "상계2동"
          },
          {
            "code": "1135066500",
            "name": "상계3.4동"
          },
          {
            "code": "1135067000",
            "name": "상계5동"
          },
          {
            "code": "1135069500",
            "name": "상계6.7동"
          },
          {
            "code": "1135070000",
            "name": "상계8동"
          },
          {
            "code": "1135071000",
            "name": "상계9동"
          },
          {
            "code": "1135072000",
            "name": "상계10동"
          }
        ]
      },
      {
        "code": "11380",
        "name": "은평구",
        "sub": [
          {
            "code": "1138051000",
            "name": "녹번동"
          },
          {
            "code": "1138052000",
            "name": "불광제1동"
          },
          {
            "code": "1138053000",
            "name": "불광제2동"
          },
          {
            "code": "1138055100",
            "name": "갈현제1동"
          },
          {
            "code": "1138055200",
            "name": "갈현제2동"
          },
          {
            "code": "1138056000",
            "name": "구산동"
          },
          {
            "code": "1138057000",
            "name": "대조동"
          },
          {
            "code": "1138058000",
            "name": "응암제1동"
          },
          {
            "code": "1138059000",
            "name": "응암제2동"
          },
          {
            "code": "1138060000",
            "name": "응암제3동"
          },
          {
            "code": "1138062500",
            "name": "역촌동"
          },
          {
            "code": "1138063100",
            "name": "신사제1동"
          },
          {
            "code": "1138063200",
            "name": "신사제2동"
          },
          {
            "code": "1138064000",
            "name": "증산동"
          },
          {
            "code": "1138065000",
            "name": "수색동"
          },
          {
            "code": "1138069000",
            "name": "진관동"
          }
        ]
      },
      {
        "code": "11410",
        "name": "서대문구",
        "sub": [
          {
            "code": "1141052000",
            "name": "천연동"
          },
          {
            "code": "1141055500",
            "name": "북아현동"
          },
          {
            "code": "1141056500",
            "name": "충현동"
          },
          {
            "code": "1141058500",
            "name": "신촌동"
          },
          {
            "code": "1141061500",
            "name": "연희동"
          },
          {
            "code": "1141062000",
            "name": "홍제제1동"
          },
          {
            "code": "1141064000",
            "name": "홍제제3동"
          },
          {
            "code": "1141065500",
            "name": "홍제제2동"
          },
          {
            "code": "1141066000",
            "name": "홍은제1동"
          },
          {
            "code": "1141068500",
            "name": "홍은제2동"
          },
          {
            "code": "1141069000",
            "name": "남가좌제1동"
          },
          {
            "code": "1141070000",
            "name": "남가좌제2동"
          },
          {
            "code": "1141071000",
            "name": "북가좌제1동"
          },
          {
            "code": "1141072000",
            "name": "북가좌제2동"
          }
        ]
      },
      {
        "code": "11440",
        "name": "마포구",
        "sub": [
          {
            "code": "1144055500",
            "name": "아현동"
          },
          {
            "code": "1144056500",
            "name": "공덕동"
          },
          {
            "code": "1144058500",
            "name": "도화동"
          },
          {
            "code": "1144059000",
            "name": "용강동"
          },
          {
            "code": "1144060000",
            "name": "대흥동"
          },
          {
            "code": "1144061000",
            "name": "염리동"
          },
          {
            "code": "1144063000",
            "name": "신수동"
          },
          {
            "code": "1144065500",
            "name": "서강동"
          },
          {
            "code": "1144066000",
            "name": "서교동"
          },
          {
            "code": "1144068000",
            "name": "합정동"
          },
          {
            "code": "1144069000",
            "name": "망원제1동"
          },
          {
            "code": "1144070000",
            "name": "망원제2동"
          },
          {
            "code": "1144071000",
            "name": "연남동"
          },
          {
            "code": "1144072000",
            "name": "성산제1동"
          },
          {
            "code": "1144073000",
            "name": "성산제2동"
          },
          {
            "code": "1144074000",
            "name": "상암동"
          }
        ]
      },
      {
        "code": "11470",
        "name": "양천구",
        "sub": [
          {
            "code": "1147051000",
            "name": "목1동"
          },
          {
            "code": "1147052000",
            "name": "목2동"
          },
          {
            "code": "1147053000",
            "name": "목3동"
          },
          {
            "code": "1147054000",
            "name": "목4동"
          },
          {
            "code": "1147055000",
            "name": "목5동"
          },
          {
            "code": "1147056000",
            "name": "신월1동"
          },
          {
            "code": "1147057000",
            "name": "신월2동"
          },
          {
            "code": "1147058000",
            "name": "신월3동"
          },
          {
            "code": "1147059000",
            "name": "신월4동"
          },
          {
            "code": "1147060000",
            "name": "신월5동"
          },
          {
            "code": "1147061000",
            "name": "신월6동"
          },
          {
            "code": "1147061100",
            "name": "신월7동"
          },
          {
            "code": "1147062000",
            "name": "신정1동"
          },
          {
            "code": "1147063000",
            "name": "신정2동"
          },
          {
            "code": "1147064000",
            "name": "신정3동"
          },
          {
            "code": "1147065000",
            "name": "신정4동"
          },
          {
            "code": "1147067000",
            "name": "신정6동"
          },
          {
            "code": "1147068000",
            "name": "신정7동"
          }
        ]
      },
      {
        "code": "11500",
        "name": "강서구",
        "sub": [
          {
            "code": "1150051000",
            "name": "염창동"
          },
          {
            "code": "1150052000",
            "name": "등촌제1동"
          },
          {
            "code": "1150053000",
            "name": "등촌제2동"
          },
          {
            "code": "1150053500",
            "name": "등촌제3동"
          },
          {
            "code": "1150054000",
            "name": "화곡제1동"
          },
          {
            "code": "1150055000",
            "name": "화곡제2동"
          },
          {
            "code": "1150056000",
            "name": "화곡제3동"
          },
          {
            "code": "1150057000",
            "name": "화곡제4동"
          },
          {
            "code": "1150059000",
            "name": "화곡본동"
          },
          {
            "code": "1150059100",
            "name": "화곡제6동"
          },
          {
            "code": "1150059300",
            "name": "화곡제8동"
          },
          {
            "code": "1150060300",
            "name": "가양제1동"
          },
          {
            "code": "1150060400",
            "name": "가양제2동"
          },
          {
            "code": "1150060500",
            "name": "가양제3동"
          },
          {
            "code": "1150061100",
            "name": "발산제1동"
          },
          {
            "code": "1150061500",
            "name": "우장산동"
          },
          {
            "code": "1150062000",
            "name": "공항동"
          },
          {
            "code": "1150063000",
            "name": "방화제1동"
          },
          {
            "code": "1150064000",
            "name": "방화제2동"
          },
          {
            "code": "1150064100",
            "name": "방화제3동"
          }
        ]
      },
      {
        "code": "11530",
        "name": "구로구",
        "sub": [
          {
            "code": "1153051000",
            "name": "신도림동"
          },
          {
            "code": "1153052000",
            "name": "구로제1동"
          },
          {
            "code": "1153053000",
            "name": "구로제2동"
          },
          {
            "code": "1153054000",
            "name": "구로제3동"
          },
          {
            "code": "1153055000",
            "name": "구로제4동"
          },
          {
            "code": "1153056000",
            "name": "구로제5동"
          },
          {
            "code": "1153059500",
            "name": "가리봉동"
          },
          {
            "code": "1153072000",
            "name": "고척제1동"
          },
          {
            "code": "1153073000",
            "name": "고척제2동"
          },
          {
            "code": "1153074000",
            "name": "개봉제1동"
          },
          {
            "code": "1153075000",
            "name": "개봉제2동"
          },
          {
            "code": "1153076000",
            "name": "개봉제3동"
          },
          {
            "code": "1153077000",
            "name": "오류제1동"
          },
          {
            "code": "1153078000",
            "name": "오류제2동"
          },
          {
            "code": "1153079000",
            "name": "수궁동"
          },
          {
            "code": "1153080000",
            "name": "항동"
          }
        ]
      },
      {
        "code": "11545",
        "name": "금천구",
        "sub": [
          {
            "code": "1154551000",
            "name": "가산동"
          },
          {
            "code": "1154561000",
            "name": "독산제1동"
          },
          {
            "code": "1154562000",
            "name": "독산제2동"
          },
          {
            "code": "1154563000",
            "name": "독산제3동"
          },
          {
            "code": "1154564000",
            "name": "독산제4동"
          },
          {
            "code": "1154567000",
            "name": "시흥제1동"
          },
          {
            "code": "1154568000",
            "name": "시흥제2동"
          },
          {
            "code": "1154569000",
            "name": "시흥제3동"
          },
          {
            "code": "1154570000",
            "name": "시흥제4동"
          },
          {
            "code": "1154571000",
            "name": "시흥제5동"
          }
        ]
      },
      {
        "code": "11560",
        "name": "영등포구",
        "sub": [
          {
            "code": "1156051500",
            "name": "영등포본동"
          },
          {
            "code": "1156053500",
            "name": "영등포동"
          },
          {
            "code": "1156054000",
            "name": "여의동"
          },
          {
            "code": "1156055000",
            "name": "당산제1동"
          },
          {
            "code": "1156056000",
            "name": "당산제2동"
          },
          {
            "code": "1156058500",
            "name": "도림동"
          },
          {
            "code": "1156060500",
            "name": "문래동"
          },
          {
            "code": "1156061000",
            "name": "양평제1동"
          },
          {
            "code": "1156062000",
            "name": "양평제2동"
          },
          {
            "code": "1156063000",
            "name": "신길제1동"
          },
          {
            "code": "1156065000",
            "name": "신길제3동"
          },
          {
            "code": "1156066000",
            "name": "신길제4동"
          },
          {
            "code": "1156067000",
            "name": "신길제5동"
          },
          {
            "code": "1156068000",
            "name": "신길제6동"
          },
          {
            "code": "1156069000",
            "name": "신길제7동"
          },
          {
            "code": "1156070000",
            "name": "대림제1동"
          },
          {
            "code": "1156071000",
            "name": "대림제2동"
          },
          {
            "code": "1156072000",
            "name": "대림제3동"
          }
        ]
      },
      {
        "code": "11590",
        "name": "동작구",
        "sub": [
          {
            "code": "1159051000",
            "name": "노량진제1동"
          },
          {
            "code": "1159052000",
            "name": "노량진제2동"
          },
          {
            "code": "1159053000",
            "name": "상도제1동"
          },
          {
            "code": "1159054000",
            "name": "상도제2동"
          },
          {
            "code": "1159055000",
            "name": "상도제3동"
          },
          {
            "code": "1159056000",
            "name": "상도제4동"
          },
          {
            "code": "1159060500",
            "name": "흑석동"
          },
          {
            "code": "1159062000",
            "name": "사당제1동"
          },
          {
            "code": "1159063000",
            "name": "사당제2동"
          },
          {
            "code": "1159064000",
            "name": "사당제3동"
          },
          {
            "code": "1159065000",
            "name": "사당제4동"
          },
          {
            "code": "1159065100",
            "name": "사당제5동"
          },
          {
            "code": "1159066000",
            "name": "대방동"
          },
          {
            "code": "1159067000",
            "name": "신대방제1동"
          },
          {
            "code": "1159068000",
            "name": "신대방제2동"
          }
        ]
      },
      {
        "code": "11620",
        "name": "관악구",
        "sub": [
          {
            "code": "1162052500",
            "name": "보라매동"
          },
          {
            "code": "1162054500",
            "name": "청림동"
          },
          {
            "code": "1162056500",
            "name": "성현동"
          },
          {
            "code": "1162057500",
            "name": "행운동"
          },
          {
            "code": "1162058500",
            "name": "낙성대동"
          },
          {
            "code": "1162059500",
            "name": "청룡동"
          },
          {
            "code": "1162060500",
            "name": "은천동"
          },
          {
            "code": "1162061500",
            "name": "중앙동"
          },
          {
            "code": "1162062500",
            "name": "인헌동"
          },
          {
            "code": "1162063000",
            "name": "남현동"
          },
          {
            "code": "1162064500",
            "name": "서원동"
          },
          {
            "code": "1162065500",
            "name": "신원동"
          },
          {
            "code": "1162066500",
            "name": "서림동"
          },
          {
            "code": "1162068500",
            "name": "신사동"
          },
          {
            "code": "1162069500",
            "name": "신림동"
          },
          {
            "code": "1162071500",
            "name": "난향동"
          },
          {
            "code": "1162072500",
            "name": "조원동"
          },
          {
            "code": "1162073500",
            "name": "대학동"
          },
          {
            "code": "1162074500",
            "name": "삼성동"
          },
          {
            "code": "1162076500",
            "name": "미성동"
          },
          {
            "code": "1162077500",
            "name": "난곡동"
          }
        ]
      },
      {
        "code": "11650",
        "name": "서초구",
        "sub": [
          {
            "code": "1165051000",
            "name": "서초1동"
          },
          {
            "code": "1165052000",
            "name": "서초2동"
          },
          {
            "code": "1165053000",
            "name": "서초3동"
          },
          {
            "code": "1165053100",
            "name": "서초4동"
          },
          {
            "code": "1165054000",
            "name": "잠원동"
          },
          {
            "code": "1165055000",
            "name": "반포본동"
          },
          {
            "code": "1165056000",
            "name": "반포1동"
          },
          {
            "code": "1165057000",
            "name": "반포2동"
          },
          {
            "code": "1165058000",
            "name": "반포3동"
          },
          {
            "code": "1165058100",
            "name": "반포4동"
          },
          {
            "code": "1165059000",
            "name": "방배본동"
          },
          {
            "code": "1165060000",
            "name": "방배1동"
          },
          {
            "code": "1165061000",
            "name": "방배2동"
          },
          {
            "code": "1165062000",
            "name": "방배3동"
          },
          {
            "code": "1165062100",
            "name": "방배4동"
          },
          {
            "code": "1165065100",
            "name": "양재1동"
          },
          {
            "code": "1165065200",
            "name": "양재2동"
          },
          {
            "code": "1165066000",
            "name": "내곡동"
          }
        ]
      },
      {
        "code": "11680",
        "name": "강남구",
        "sub": [
          {
            "code": "1168051000",
            "name": "신사동"
          },
          {
            "code": "1168052100",
            "name": "논현1동"
          },
          {
            "code": "1168053100",
            "name": "논현2동"
          },
          {
            "code": "1168054500",
            "name": "압구정동"
          },
          {
            "code": "1168056500",
            "name": "청담동"
          },
          {
            "code": "1168058000",
            "name": "삼성1동"
          },
          {
            "code": "1168059000",
            "name": "삼성2동"
          },
          {
            "code": "1168060000",
            "name": "대치1동"
          },
          {
            "code": "1168061000",
            "name": "대치2동"
          },
          {
            "code": "1168063000",
            "name": "대치4동"
          },
          {
            "code": "1168064000",
            "name": "역삼1동"
          },
          {
            "code": "1168065000",
            "name": "역삼2동"
          },
          {
            "code": "1168065500",
            "name": "도곡1동"
          },
          {
            "code": "1168065600",
            "name": "도곡2동"
          },
          {
            "code": "1168066000",
            "name": "개포1동"
          },
          {
            "code": "1168067000",
            "name": "개포2동"
          },
          {
            "code": "1168069000",
            "name": "개포4동"
          },
          {
            "code": "1168070000",
            "name": "세곡동"
          },
          {
            "code": "1168072000",
            "name": "일원본동"
          },
          {
            "code": "1168073000",
            "name": "일원1동"
          },
          {
            "code": "1168074000",
            "name": "일원2동"
          },
          {
            "code": "1168075000",
            "name": "수서동"
          }
        ]
      },
      {
        "code": "11710",
        "name": "송파구",
        "sub": [
          {
            "code": "1171051000",
            "name": "풍납1동"
          },
          {
            "code": "1171052000",
            "name": "풍납2동"
          },
          {
            "code": "1171053100",
            "name": "거여1동"
          },
          {
            "code": "1171053200",
            "name": "거여2동"
          },
          {
            "code": "1171054000",
            "name": "마천1동"
          },
          {
            "code": "1171055000",
            "name": "마천2동"
          },
          {
            "code": "1171056100",
            "name": "방이1동"
          },
          {
            "code": "1171056200",
            "name": "방이2동"
          },
          {
            "code": "1171056600",
            "name": "오륜동"
          },
          {
            "code": "1171057000",
            "name": "오금동"
          },
          {
            "code": "1171058000",
            "name": "송파1동"
          },
          {
            "code": "1171059000",
            "name": "송파2동"
          },
          {
            "code": "1171060000",
            "name": "석촌동"
          },
          {
            "code": "1171061000",
            "name": "삼전동"
          },
          {
            "code": "1171062000",
            "name": "가락본동"
          },
          {
            "code": "1171063100",
            "name": "가락1동"
          },
          {
            "code": "1171063200",
            "name": "가락2동"
          },
          {
            "code": "1171064100",
            "name": "문정1동"
          },
          {
            "code": "1171064200",
            "name": "문정2동"
          },
          {
            "code": "1171064600",
            "name": "장지동"
          },
          {
            "code": "1171064700",
            "name": "위례동"
          },
          {
            "code": "1171065000",
            "name": "잠실본동"
          },
          {
            "code": "1171067000",
            "name": "잠실2동"
          },
          {
            "code": "1171068000",
            "name": "잠실3동"
          },
          {
            "code": "1171069000",
            "name": "잠실4동"
          },
          {
            "code": "1171071000",
            "name": "잠실6동"
          },
          {
            "code": "1171072000",
            "name": "잠실7동"
          }
        ]
      },
      {
        "code": "11740",
        "name": "강동구",
        "sub": [
          {
            "code": "1174051500",
            "name": "강일동"
          },
          {
            "code": "1174052500",
            "name": "상일제1동"
          },
          {
            "code": "1174052600",
            "name": "상일제2동"
          },
          {
            "code": "1174053000",
            "name": "명일제1동"
          },
          {
            "code": "1174054000",
            "name": "명일제2동"
          },
          {
            "code": "1174055000",
            "name": "고덕제1동"
          },
          {
            "code": "1174056000",
            "name": "고덕제2동"
          },
          {
            "code": "1174057000",
            "name": "암사제1동"
          },
          {
            "code": "1174058000",
            "name": "암사제2동"
          },
          {
            "code": "1174059000",
            "name": "암사제3동"
          },
          {
            "code": "1174060000",
            "name": "천호제1동"
          },
          {
            "code": "1174061000",
            "name": "천호제2동"
          },
          {
            "code": "1174062000",
            "name": "천호제3동"
          },
          {
            "code": "1174064000",
            "name": "성내제1동"
          },
          {
            "code": "1174065000",
            "name": "성내제2동"
          },
          {
            "code": "1174066000",
            "name": "성내제3동"
          },
          {
            "code": "1174068500",
            "name": "길동"
          },
          {
            "code": "1174069000",
            "name": "둔촌제1동"
          },
          {
            "code": "1174070000",
            "name": "둔촌제2동"
          }
        ]
      }
    ]
  },
  {
    "code": "26",
    "name": "부산광역시",
    "sub": [
      {
        "code": "26110",
        "name": "중구",
        "sub": [
          {
            "code": "2611051000",
            "name": "중앙동"
          },
          {
            "code": "2611052000",
            "name": "동광동"
          },
          {
            "code": "2611053000",
            "name": "대청동"
          },
          {
            "code": "2611054500",
            "name": "보수동"
          },
          {
            "code": "2611056000",
            "name": "부평동"
          },
          {
            "code": "2611057000",
            "name": "광복동"
          },
          {
            "code": "2611058000",
            "name": "남포동"
          },
          {
            "code": "2611059000",
            "name": "영주제1동"
          },
          {
            "code": "2611060000",
            "name": "영주제2동"
          }
        ]
      },
      {
        "code": "26140",
        "name": "서구",
        "sub": [
          {
            "code": "2614051000",
            "name": "동대신제1동"
          },
          {
            "code": "2614052000",
            "name": "동대신제2동"
          },
          {
            "code": "2614053000",
            "name": "동대신제3동"
          },
          {
            "code": "2614054000",
            "name": "서대신제1동"
          },
          {
            "code": "2614056000",
            "name": "서대신제3동"
          },
          {
            "code": "2614057000",
            "name": "서대신제4동"
          },
          {
            "code": "2614059000",
            "name": "부민동"
          },
          {
            "code": "2614061500",
            "name": "아미동"
          },
          {
            "code": "2614063000",
            "name": "초장동"
          },
          {
            "code": "2614064000",
            "name": "충무동"
          },
          {
            "code": "2614065000",
            "name": "남부민제1동"
          },
          {
            "code": "2614066000",
            "name": "남부민제2동"
          },
          {
            "code": "2614068000",
            "name": "암남동"
          }
        ]
      },
      {
        "code": "26170",
        "name": "동구",
        "sub": [
          {
            "code": "2617051000",
            "name": "초량제1동"
          },
          {
            "code": "2617052000",
            "name": "초량제2동"
          },
          {
            "code": "2617053000",
            "name": "초량제3동"
          },
          {
            "code": "2617055000",
            "name": "초량제6동"
          },
          {
            "code": "2617056000",
            "name": "수정제1동"
          },
          {
            "code": "2617057000",
            "name": "수정제2동"
          },
          {
            "code": "2617059000",
            "name": "수정제4동"
          },
          {
            "code": "2617060000",
            "name": "수정제5동"
          },
          {
            "code": "2617064500",
            "name": "좌천동"
          },
          {
            "code": "2617065000",
            "name": "범일제1동"
          },
          {
            "code": "2617066000",
            "name": "범일제2동"
          },
          {
            "code": "2617068000",
            "name": "범일제5동"
          }
        ]
      },
      {
        "code": "26200",
        "name": "영도구",
        "sub": [
          {
            "code": "2620053000",
            "name": "남항동"
          },
          {
            "code": "2620054000",
            "name": "영선제1동"
          },
          {
            "code": "2620055000",
            "name": "영선제2동"
          },
          {
            "code": "2620058500",
            "name": "신선동"
          },
          {
            "code": "2620059000",
            "name": "봉래제1동"
          },
          {
            "code": "2620060500",
            "name": "봉래제2동"
          },
          {
            "code": "2620063000",
            "name": "청학제1동"
          },
          {
            "code": "2620064000",
            "name": "청학제2동"
          },
          {
            "code": "2620065000",
            "name": "동삼제1동"
          },
          {
            "code": "2620066000",
            "name": "동삼제2동"
          },
          {
            "code": "2620067000",
            "name": "동삼제3동"
          }
        ]
      },
      {
        "code": "26230",
        "name": "부산진구",
        "sub": [
          {
            "code": "2623051000",
            "name": "부전제1동"
          },
          {
            "code": "2623052000",
            "name": "부전제2동"
          },
          {
            "code": "2623054000",
            "name": "연지동"
          },
          {
            "code": "2623055000",
            "name": "초읍동"
          },
          {
            "code": "2623056000",
            "name": "양정제1동"
          },
          {
            "code": "2623057000",
            "name": "양정제2동"
          },
          {
            "code": "2623060000",
            "name": "전포제1동"
          },
          {
            "code": "2623061000",
            "name": "전포제2동"
          },
          {
            "code": "2623064000",
            "name": "부암제1동"
          },
          {
            "code": "2623066000",
            "name": "부암제3동"
          },
          {
            "code": "2623067000",
            "name": "당감제1동"
          },
          {
            "code": "2623068000",
            "name": "당감제2동"
          },
          {
            "code": "2623070000",
            "name": "당감제4동"
          },
          {
            "code": "2623071000",
            "name": "가야제1동"
          },
          {
            "code": "2623072000",
            "name": "가야제2동"
          },
          {
            "code": "2623074000",
            "name": "개금제1동"
          },
          {
            "code": "2623075000",
            "name": "개금제2동"
          },
          {
            "code": "2623076000",
            "name": "개금제3동"
          },
          {
            "code": "2623077000",
            "name": "범천제1동"
          },
          {
            "code": "2623078000",
            "name": "범천제2동"
          }
        ]
      },
      {
        "code": "26260",
        "name": "동래구",
        "sub": [
          {
            "code": "2626051000",
            "name": "수민동"
          },
          {
            "code": "2626052000",
            "name": "복산동"
          },
          {
            "code": "2626054500",
            "name": "명륜동"
          },
          {
            "code": "2626055000",
            "name": "온천제1동"
          },
          {
            "code": "2626056000",
            "name": "온천제2동"
          },
          {
            "code": "2626057000",
            "name": "온천제3동"
          },
          {
            "code": "2626058000",
            "name": "사직제1동"
          },
          {
            "code": "2626059000",
            "name": "사직제2동"
          },
          {
            "code": "2626060000",
            "name": "사직제3동"
          },
          {
            "code": "2626074000",
            "name": "안락제1동"
          },
          {
            "code": "2626075000",
            "name": "안락제2동"
          },
          {
            "code": "2626076100",
            "name": "명장제1동"
          },
          {
            "code": "2626076200",
            "name": "명장제2동"
          }
        ]
      },
      {
        "code": "26290",
        "name": "남구",
        "sub": [
          {
            "code": "2629051000",
            "name": "대연제1동"
          },
          {
            "code": "2629053000",
            "name": "대연제3동"
          },
          {
            "code": "2629054000",
            "name": "대연제4동"
          },
          {
            "code": "2629055000",
            "name": "대연제5동"
          },
          {
            "code": "2629056000",
            "name": "대연제6동"
          },
          {
            "code": "2629057000",
            "name": "용호제1동"
          },
          {
            "code": "2629058000",
            "name": "용호제2동"
          },
          {
            "code": "2629059000",
            "name": "용호제3동"
          },
          {
            "code": "2629060000",
            "name": "용호제4동"
          },
          {
            "code": "2629061000",
            "name": "용당동"
          },
          {
            "code": "2629062000",
            "name": "감만제1동"
          },
          {
            "code": "2629063000",
            "name": "감만제2동"
          },
          {
            "code": "2629064500",
            "name": "우암동"
          },
          {
            "code": "2629068000",
            "name": "문현제1동"
          },
          {
            "code": "2629069000",
            "name": "문현제2동"
          },
          {
            "code": "2629070000",
            "name": "문현제3동"
          },
          {
            "code": "2629071000",
            "name": "문현제4동"
          }
        ]
      },
      {
        "code": "26320",
        "name": "북구",
        "sub": [
          {
            "code": "2632051000",
            "name": "구포제1동"
          },
          {
            "code": "2632052000",
            "name": "구포제2동"
          },
          {
            "code": "2632052100",
            "name": "구포제3동"
          },
          {
            "code": "2632053000",
            "name": "금곡동"
          },
          {
            "code": "2632054100",
            "name": "화명제1동"
          },
          {
            "code": "2632054200",
            "name": "화명제2동"
          },
          {
            "code": "2632054300",
            "name": "화명제3동"
          },
          {
            "code": "2632055000",
            "name": "덕천제1동"
          },
          {
            "code": "2632056000",
            "name": "덕천제2동"
          },
          {
            "code": "2632056100",
            "name": "덕천제3동"
          },
          {
            "code": "2632057100",
            "name": "만덕제1동"
          },
          {
            "code": "2632057200",
            "name": "만덕제2동"
          },
          {
            "code": "2632057300",
            "name": "만덕제3동"
          }
        ]
      },
      {
        "code": "26350",
        "name": "해운대구",
        "sub": [
          {
            "code": "2635051000",
            "name": "우제1동"
          },
          {
            "code": "2635052000",
            "name": "우제2동"
          },
          {
            "code": "2635052500",
            "name": "우제3동"
          },
          {
            "code": "2635053000",
            "name": "중제1동"
          },
          {
            "code": "2635054000",
            "name": "중제2동"
          },
          {
            "code": "2635055100",
            "name": "좌제1동"
          },
          {
            "code": "2635055200",
            "name": "좌제2동"
          },
          {
            "code": "2635055300",
            "name": "좌제3동"
          },
          {
            "code": "2635055400",
            "name": "좌제4동"
          },
          {
            "code": "2635056000",
            "name": "송정동"
          },
          {
            "code": "2635057000",
            "name": "반여제1동"
          },
          {
            "code": "2635058000",
            "name": "반여제2동"
          },
          {
            "code": "2635059000",
            "name": "반여제3동"
          },
          {
            "code": "2635059500",
            "name": "반여제4동"
          },
          {
            "code": "2635061000",
            "name": "반송제1동"
          },
          {
            "code": "2635062000",
            "name": "반송제2동"
          },
          {
            "code": "2635065000",
            "name": "재송제1동"
          },
          {
            "code": "2635066000",
            "name": "재송제2동"
          }
        ]
      },
      {
        "code": "26380",
        "name": "사하구",
        "sub": [
          {
            "code": "2638051000",
            "name": "괴정제1동"
          },
          {
            "code": "2638052000",
            "name": "괴정제2동"
          },
          {
            "code": "2638053000",
            "name": "괴정제3동"
          },
          {
            "code": "2638054000",
            "name": "괴정제4동"
          },
          {
            "code": "2638055000",
            "name": "당리동"
          },
          {
            "code": "2638056100",
            "name": "하단제1동"
          },
          {
            "code": "2638056200",
            "name": "하단제2동"
          },
          {
            "code": "2638057100",
            "name": "신평제1동"
          },
          {
            "code": "2638057200",
            "name": "신평제2동"
          },
          {
            "code": "2638058000",
            "name": "장림제1동"
          },
          {
            "code": "2638059000",
            "name": "장림제2동"
          },
          {
            "code": "2638060100",
            "name": "다대제1동"
          },
          {
            "code": "2638060200",
            "name": "다대제2동"
          },
          {
            "code": "2638061000",
            "name": "구평동"
          },
          {
            "code": "2638062000",
            "name": "감천제1동"
          },
          {
            "code": "2638063000",
            "name": "감천제2동"
          }
        ]
      },
      {
        "code": "26410",
        "name": "금정구",
        "sub": [
          {
            "code": "2641051000",
            "name": "서제1동"
          },
          {
            "code": "2641052000",
            "name": "서제2동"
          },
          {
            "code": "2641053000",
            "name": "서제3동"
          },
          {
            "code": "2641055500",
            "name": "금사회동동"
          },
          {
            "code": "2641057000",
            "name": "부곡제1동"
          },
          {
            "code": "2641058000",
            "name": "부곡제2동"
          },
          {
            "code": "2641059000",
            "name": "부곡제3동"
          },
          {
            "code": "2641059100",
            "name": "부곡제4동"
          },
          {
            "code": "2641060000",
            "name": "장전제1동"
          },
          {
            "code": "2641061000",
            "name": "장전제2동"
          },
          {
            "code": "2641063500",
            "name": "선두구동"
          },
          {
            "code": "2641066500",
            "name": "청룡노포동"
          },
          {
            "code": "2641067000",
            "name": "남산동"
          },
          {
            "code": "2641068000",
            "name": "구서제1동"
          },
          {
            "code": "2641069000",
            "name": "구서제2동"
          },
          {
            "code": "2641070000",
            "name": "금성동"
          }
        ]
      },
      {
        "code": "26440",
        "name": "강서구",
        "sub": [
          {
            "code": "2644051000",
            "name": "대저1동"
          },
          {
            "code": "2644052000",
            "name": "대저2동"
          },
          {
            "code": "2644053000",
            "name": "강동동"
          },
          {
            "code": "2644053500",
            "name": "명지1동"
          },
          {
            "code": "2644054500",
            "name": "명지2동"
          },
          {
            "code": "2644055000",
            "name": "가락동"
          },
          {
            "code": "2644056000",
            "name": "녹산동"
          },
          {
            "code": "2644058000",
            "name": "가덕도동"
          }
        ]
      },
      {
        "code": "26470",
        "name": "연제구",
        "sub": [
          {
            "code": "2647061000",
            "name": "거제제1동"
          },
          {
            "code": "2647062000",
            "name": "거제제2동"
          },
          {
            "code": "2647063000",
            "name": "거제제3동"
          },
          {
            "code": "2647064000",
            "name": "거제제4동"
          },
          {
            "code": "2647065000",
            "name": "연산제1동"
          },
          {
            "code": "2647066000",
            "name": "연산제2동"
          },
          {
            "code": "2647067000",
            "name": "연산제3동"
          },
          {
            "code": "2647068000",
            "name": "연산제4동"
          },
          {
            "code": "2647069000",
            "name": "연산제5동"
          },
          {
            "code": "2647070000",
            "name": "연산제6동"
          },
          {
            "code": "2647072000",
            "name": "연산제8동"
          },
          {
            "code": "2647073000",
            "name": "연산제9동"
          }
        ]
      },
      {
        "code": "26500",
        "name": "수영구",
        "sub": [
          {
            "code": "2650066000",
            "name": "남천제1동"
          },
          {
            "code": "2650067000",
            "name": "남천제2동"
          },
          {
            "code": "2650073000",
            "name": "수영동"
          },
          {
            "code": "2650074000",
            "name": "망미제1동"
          },
          {
            "code": "2650075000",
            "name": "망미제2동"
          },
          {
            "code": "2650076000",
            "name": "광안제1동"
          },
          {
            "code": "2650077000",
            "name": "광안제2동"
          },
          {
            "code": "2650078000",
            "name": "광안제3동"
          },
          {
            "code": "2650079000",
            "name": "광안제4동"
          },
          {
            "code": "2650080000",
            "name": "민락동"
          }
        ]
      },
      {
        "code": "26530",
        "name": "사상구",
        "sub": [
          {
            "code": "2653058000",
            "name": "삼락동"
          },
          {
            "code": "2653059100",
            "name": "모라제1동"
          },
          {
            "code": "2653059300",
            "name": "모라제3동"
          },
          {
            "code": "2653060000",
            "name": "덕포제1동"
          },
          {
            "code": "2653061000",
            "name": "덕포제2동"
          },
          {
            "code": "2653062000",
            "name": "괘법동"
          },
          {
            "code": "2653064500",
            "name": "감전동"
          },
          {
            "code": "2653065000",
            "name": "주례제1동"
          },
          {
            "code": "2653066000",
            "name": "주례제2동"
          },
          {
            "code": "2653066100",
            "name": "주례제3동"
          },
          {
            "code": "2653067000",
            "name": "학장동"
          },
          {
            "code": "2653068000",
            "name": "엄궁동"
          }
        ]
      },
      {
        "code": "26710",
        "name": "기장군",
        "sub": [
          {
            "code": "2671025000",
            "name": "기장읍"
          },
          {
            "code": "2671025300",
            "name": "장안읍"
          },
          {
            "code": "2671025600",
            "name": "정관읍"
          },
          {
            "code": "2671025900",
            "name": "일광읍"
          },
          {
            "code": "2671033000",
            "name": "철마면"
          }
        ]
      }
    ]
  },
  {
    "code": "27",
    "name": "대구광역시",
    "sub": [
      {
        "code": "27110",
        "name": "중구",
        "sub": [
          {
            "code": "2711051700",
            "name": "동인동"
          },
          {
            "code": "2711054500",
            "name": "삼덕동"
          },
          {
            "code": "2711056500",
            "name": "성내1동"
          },
          {
            "code": "2711057500",
            "name": "성내2동"
          },
          {
            "code": "2711058500",
            "name": "성내3동"
          },
          {
            "code": "2711059500",
            "name": "대신동"
          },
          {
            "code": "2711064000",
            "name": "남산1동"
          },
          {
            "code": "2711065000",
            "name": "남산2동"
          },
          {
            "code": "2711066000",
            "name": "남산3동"
          },
          {
            "code": "2711067000",
            "name": "남산4동"
          },
          {
            "code": "2711068000",
            "name": "대봉1동"
          },
          {
            "code": "2711069000",
            "name": "대봉2동"
          }
        ]
      },
      {
        "code": "27140",
        "name": "동구",
        "sub": [
          {
            "code": "2714051000",
            "name": "신암1동"
          },
          {
            "code": "2714052000",
            "name": "신암2동"
          },
          {
            "code": "2714053000",
            "name": "신암3동"
          },
          {
            "code": "2714054000",
            "name": "신암4동"
          },
          {
            "code": "2714054100",
            "name": "신암5동"
          },
          {
            "code": "2714055500",
            "name": "신천1.2동"
          },
          {
            "code": "2714057000",
            "name": "신천3동"
          },
          {
            "code": "2714058000",
            "name": "신천4동"
          },
          {
            "code": "2714059000",
            "name": "효목1동"
          },
          {
            "code": "2714060000",
            "name": "효목2동"
          },
          {
            "code": "2714061500",
            "name": "도평동"
          },
          {
            "code": "2714062000",
            "name": "불로.봉무동"
          },
          {
            "code": "2714064000",
            "name": "지저동"
          },
          {
            "code": "2714065500",
            "name": "동촌동"
          },
          {
            "code": "2714067000",
            "name": "방촌동"
          },
          {
            "code": "2714068500",
            "name": "해안동"
          },
          {
            "code": "2714072000",
            "name": "안심1동"
          },
          {
            "code": "2714073000",
            "name": "안심2동"
          },
          {
            "code": "2714074200",
            "name": "안심3동"
          },
          {
            "code": "2714074700",
            "name": "안심4동"
          },
          {
            "code": "2714075500",
            "name": "혁신동"
          },
          {
            "code": "2714076000",
            "name": "공산동"
          }
        ]
      },
      {
        "code": "27170",
        "name": "서구",
        "sub": [
          {
            "code": "2717051000",
            "name": "내당1동"
          },
          {
            "code": "2717052500",
            "name": "내당2.3동"
          },
          {
            "code": "2717054000",
            "name": "내당4동"
          },
          {
            "code": "2717055000",
            "name": "비산1동"
          },
          {
            "code": "2717056500",
            "name": "비산2.3동"
          },
          {
            "code": "2717058000",
            "name": "비산4동"
          },
          {
            "code": "2717059000",
            "name": "비산5동"
          },
          {
            "code": "2717060000",
            "name": "비산6동"
          },
          {
            "code": "2717061000",
            "name": "비산7동"
          },
          {
            "code": "2717062000",
            "name": "평리1동"
          },
          {
            "code": "2717063000",
            "name": "평리2동"
          },
          {
            "code": "2717064000",
            "name": "평리3동"
          },
          {
            "code": "2717065000",
            "name": "평리4동"
          },
          {
            "code": "2717066000",
            "name": "평리5동"
          },
          {
            "code": "2717066100",
            "name": "평리6동"
          },
          {
            "code": "2717067500",
            "name": "상중이동"
          },
          {
            "code": "2717069500",
            "name": "원대동"
          }
        ]
      },
      {
        "code": "27200",
        "name": "남구",
        "sub": [
          {
            "code": "2720051500",
            "name": "이천동"
          },
          {
            "code": "2720053000",
            "name": "봉덕1동"
          },
          {
            "code": "2720054000",
            "name": "봉덕2동"
          },
          {
            "code": "2720055000",
            "name": "봉덕3동"
          },
          {
            "code": "2720056000",
            "name": "대명1동"
          },
          {
            "code": "2720057100",
            "name": "대명2동"
          },
          {
            "code": "2720058600",
            "name": "대명3동"
          },
          {
            "code": "2720059000",
            "name": "대명4동"
          },
          {
            "code": "2720060000",
            "name": "대명5동"
          },
          {
            "code": "2720061000",
            "name": "대명6동"
          },
          {
            "code": "2720064000",
            "name": "대명9동"
          },
          {
            "code": "2720065000",
            "name": "대명10동"
          },
          {
            "code": "2720066000",
            "name": "대명11동"
          }
        ]
      },
      {
        "code": "27230",
        "name": "북구",
        "sub": [
          {
            "code": "2723051000",
            "name": "고성동"
          },
          {
            "code": "2723052600",
            "name": "칠성동"
          },
          {
            "code": "2723055000",
            "name": "침산1동"
          },
          {
            "code": "2723056000",
            "name": "침산2동"
          },
          {
            "code": "2723057000",
            "name": "침산3동"
          },
          {
            "code": "2723061000",
            "name": "산격1동"
          },
          {
            "code": "2723062000",
            "name": "산격2동"
          },
          {
            "code": "2723063000",
            "name": "산격3동"
          },
          {
            "code": "2723063100",
            "name": "산격4동"
          },
          {
            "code": "2723064500",
            "name": "대현동"
          },
          {
            "code": "2723067100",
            "name": "복현1동"
          },
          {
            "code": "2723067200",
            "name": "복현2동"
          },
          {
            "code": "2723068000",
            "name": "검단동"
          },
          {
            "code": "2723069500",
            "name": "무태조야동"
          },
          {
            "code": "2723071500",
            "name": "관문동"
          },
          {
            "code": "2723072500",
            "name": "태전1동"
          },
          {
            "code": "2723073500",
            "name": "태전2동"
          },
          {
            "code": "2723074500",
            "name": "구암동"
          },
          {
            "code": "2723075000",
            "name": "관음동"
          },
          {
            "code": "2723077000",
            "name": "읍내동"
          },
          {
            "code": "2723078000",
            "name": "동천동"
          },
          {
            "code": "2723079000",
            "name": "노원동"
          },
          {
            "code": "2723080000",
            "name": "국우동"
          }
        ]
      },
      {
        "code": "27260",
        "name": "수성구",
        "sub": [
          {
            "code": "2726051000",
            "name": "범어1동"
          },
          {
            "code": "2726052000",
            "name": "범어2동"
          },
          {
            "code": "2726053000",
            "name": "범어3동"
          },
          {
            "code": "2726054000",
            "name": "범어4동"
          },
          {
            "code": "2726055000",
            "name": "만촌1동"
          },
          {
            "code": "2726056000",
            "name": "만촌2동"
          },
          {
            "code": "2726056100",
            "name": "만촌3동"
          },
          {
            "code": "2726057000",
            "name": "수성1가동"
          },
          {
            "code": "2726058000",
            "name": "수성2.3가동"
          },
          {
            "code": "2726059000",
            "name": "수성4가동"
          },
          {
            "code": "2726060100",
            "name": "황금1동"
          },
          {
            "code": "2726060200",
            "name": "황금2동"
          },
          {
            "code": "2726061000",
            "name": "중동"
          },
          {
            "code": "2726062000",
            "name": "상동"
          },
          {
            "code": "2726063000",
            "name": "파동"
          },
          {
            "code": "2726064000",
            "name": "두산동"
          },
          {
            "code": "2726065100",
            "name": "지산1동"
          },
          {
            "code": "2726065200",
            "name": "지산2동"
          },
          {
            "code": "2726066100",
            "name": "범물1동"
          },
          {
            "code": "2726066200",
            "name": "범물2동"
          },
          {
            "code": "2726067000",
            "name": "고산1동"
          },
          {
            "code": "2726068000",
            "name": "고산2동"
          },
          {
            "code": "2726069000",
            "name": "고산3동"
          }
        ]
      },
      {
        "code": "27290",
        "name": "달서구",
        "sub": [
          {
            "code": "2729051500",
            "name": "성당동"
          },
          {
            "code": "2729053500",
            "name": "두류1.2동"
          },
          {
            "code": "2729055000",
            "name": "두류3동"
          },
          {
            "code": "2729055500",
            "name": "감삼동"
          },
          {
            "code": "2729056300",
            "name": "죽전동"
          },
          {
            "code": "2729056800",
            "name": "장기동"
          },
          {
            "code": "2729057100",
            "name": "용산1동"
          },
          {
            "code": "2729057200",
            "name": "용산2동"
          },
          {
            "code": "2729057600",
            "name": "이곡1동"
          },
          {
            "code": "2729057700",
            "name": "이곡2동"
          },
          {
            "code": "2729058500",
            "name": "신당동"
          },
          {
            "code": "2729059000",
            "name": "본리동"
          },
          {
            "code": "2729060100",
            "name": "월성1동"
          },
          {
            "code": "2729060200",
            "name": "월성2동"
          },
          {
            "code": "2729061500",
            "name": "진천동"
          },
          {
            "code": "2729061700",
            "name": "유천동"
          },
          {
            "code": "2729062400",
            "name": "상인1동"
          },
          {
            "code": "2729062500",
            "name": "상인2동"
          },
          {
            "code": "2729062600",
            "name": "상인3동"
          },
          {
            "code": "2729062800",
            "name": "도원동"
          },
          {
            "code": "2729063000",
            "name": "송현1동"
          },
          {
            "code": "2729064000",
            "name": "송현2동"
          },
          {
            "code": "2729065000",
            "name": "본동"
          }
        ]
      },
      {
        "code": "27710",
        "name": "달성군",
        "sub": [
          {
            "code": "2771025000",
            "name": "화원읍"
          },
          {
            "code": "2771025300",
            "name": "논공읍"
          },
          {
            "code": "2771025400",
            "name": "논공읍공단출장소"
          },
          {
            "code": "2771025600",
            "name": "다사읍"
          },
          {
            "code": "2771025700",
            "name": "다사읍서재출장소"
          },
          {
            "code": "2771025900",
            "name": "유가읍"
          },
          {
            "code": "2771026200",
            "name": "옥포읍"
          },
          {
            "code": "2771026500",
            "name": "현풍읍"
          },
          {
            "code": "2771031000",
            "name": "가창면"
          },
          {
            "code": "2771033000",
            "name": "하빈면"
          },
          {
            "code": "2771038000",
            "name": "구지면"
          }
        ]
      }
    ]
  },
  {
    "code": "28",
    "name": "인천광역시",
    "sub": [
      {
        "code": "28110",
        "name": "중구",
        "sub": [
          {
            "code": "2811052000",
            "name": "연안동"
          },
          {
            "code": "2811053000",
            "name": "신포동"
          },
          {
            "code": "2811054000",
            "name": "신흥동"
          },
          {
            "code": "2811056000",
            "name": "도원동"
          },
          {
            "code": "2811057000",
            "name": "율목동"
          },
          {
            "code": "2811058500",
            "name": "동인천동"
          },
          {
            "code": "2811061500",
            "name": "개항동"
          },
          {
            "code": "2811062000",
            "name": "영종동"
          },
          {
            "code": "2811062200",
            "name": "영종1동"
          },
          {
            "code": "2811062800",
            "name": "운서동"
          },
          {
            "code": "2811063000",
            "name": "용유동"
          }
        ]
      },
      {
        "code": "28140",
        "name": "동구",
        "sub": [
          {
            "code": "2814051000",
            "name": "만석동"
          },
          {
            "code": "2814052500",
            "name": "화수1.화평동"
          },
          {
            "code": "2814053000",
            "name": "화수2동"
          },
          {
            "code": "2814055500",
            "name": "송현1.2동"
          },
          {
            "code": "2814057000",
            "name": "송현3동"
          },
          {
            "code": "2814058000",
            "name": "송림1동"
          },
          {
            "code": "2814059000",
            "name": "송림2동"
          },
          {
            "code": "2814060500",
            "name": "송림3.5동"
          },
          {
            "code": "2814061000",
            "name": "송림4동"
          },
          {
            "code": "2814063000",
            "name": "송림6동"
          },
          {
            "code": "2814064000",
            "name": "금창동"
          }
        ]
      },
      {
        "code": "28177",
        "name": "미추홀구",
        "sub": [
          {
            "code": "2817751000",
            "name": "숭의2동"
          },
          {
            "code": "2817752000",
            "name": "숭의1.3동"
          },
          {
            "code": "2817753000",
            "name": "숭의4동"
          },
          {
            "code": "2817754000",
            "name": "용현1.4동"
          },
          {
            "code": "2817755000",
            "name": "용현2동"
          },
          {
            "code": "2817756000",
            "name": "용현3동"
          },
          {
            "code": "2817757000",
            "name": "용현5동"
          },
          {
            "code": "2817758000",
            "name": "학익1동"
          },
          {
            "code": "2817759000",
            "name": "학익2동"
          },
          {
            "code": "2817760000",
            "name": "도화1동"
          },
          {
            "code": "2817761000",
            "name": "도화2.3동"
          },
          {
            "code": "2817762000",
            "name": "주안1동"
          },
          {
            "code": "2817763000",
            "name": "주안2동"
          },
          {
            "code": "2817764000",
            "name": "주안3동"
          },
          {
            "code": "2817765000",
            "name": "주안4동"
          },
          {
            "code": "2817766000",
            "name": "주안5동"
          },
          {
            "code": "2817767000",
            "name": "주안6동"
          },
          {
            "code": "2817768000",
            "name": "주안7동"
          },
          {
            "code": "2817769000",
            "name": "주안8동"
          },
          {
            "code": "2817770000",
            "name": "관교동"
          },
          {
            "code": "2817771000",
            "name": "문학동"
          }
        ]
      },
      {
        "code": "28185",
        "name": "연수구",
        "sub": [
          {
            "code": "2818563000",
            "name": "옥련1동"
          },
          {
            "code": "2818564000",
            "name": "옥련2동"
          },
          {
            "code": "2818575000",
            "name": "선학동"
          },
          {
            "code": "2818576100",
            "name": "연수1동"
          },
          {
            "code": "2818576200",
            "name": "연수2동"
          },
          {
            "code": "2818576300",
            "name": "연수3동"
          },
          {
            "code": "2818576600",
            "name": "청학동"
          },
          {
            "code": "2818578000",
            "name": "동춘1동"
          },
          {
            "code": "2818579000",
            "name": "동춘2동"
          },
          {
            "code": "2818579500",
            "name": "동춘3동"
          },
          {
            "code": "2818582000",
            "name": "송도1동"
          },
          {
            "code": "2818583000",
            "name": "송도2동"
          },
          {
            "code": "2818584000",
            "name": "송도3동"
          },
          {
            "code": "2818585000",
            "name": "송도4동"
          },
          {
            "code": "2818586000",
            "name": "송도5동"
          }
        ]
      },
      {
        "code": "28200",
        "name": "남동구",
        "sub": [
          {
            "code": "2820051000",
            "name": "구월1동"
          },
          {
            "code": "2820052000",
            "name": "구월2동"
          },
          {
            "code": "2820052100",
            "name": "구월3동"
          },
          {
            "code": "2820052200",
            "name": "구월4동"
          },
          {
            "code": "2820053000",
            "name": "간석1동"
          },
          {
            "code": "2820054000",
            "name": "간석2동"
          },
          {
            "code": "2820055000",
            "name": "간석3동"
          },
          {
            "code": "2820055100",
            "name": "간석4동"
          },
          {
            "code": "2820056000",
            "name": "만수1동"
          },
          {
            "code": "2820057000",
            "name": "만수2동"
          },
          {
            "code": "2820058000",
            "name": "만수3동"
          },
          {
            "code": "2820058100",
            "name": "만수4동"
          },
          {
            "code": "2820058200",
            "name": "만수5동"
          },
          {
            "code": "2820058300",
            "name": "만수6동"
          },
          {
            "code": "2820065000",
            "name": "장수서창동"
          },
          {
            "code": "2820065500",
            "name": "서창2동"
          },
          {
            "code": "2820066000",
            "name": "남촌도림동"
          },
          {
            "code": "2820069000",
            "name": "논현1동"
          },
          {
            "code": "2820070000",
            "name": "논현2동"
          },
          {
            "code": "2820071000",
            "name": "논현고잔동"
          }
        ]
      },
      {
        "code": "28237",
        "name": "부평구",
        "sub": [
          {
            "code": "2823751000",
            "name": "부평1동"
          },
          {
            "code": "2823752000",
            "name": "부평2동"
          },
          {
            "code": "2823753000",
            "name": "부평3동"
          },
          {
            "code": "2823754000",
            "name": "부평4동"
          },
          {
            "code": "2823755000",
            "name": "부평5동"
          },
          {
            "code": "2823756000",
            "name": "부평6동"
          },
          {
            "code": "2823757000",
            "name": "산곡1동"
          },
          {
            "code": "2823758000",
            "name": "산곡2동"
          },
          {
            "code": "2823758100",
            "name": "산곡3동"
          },
          {
            "code": "2823758200",
            "name": "산곡4동"
          },
          {
            "code": "2823759100",
            "name": "청천1동"
          },
          {
            "code": "2823759200",
            "name": "청천2동"
          },
          {
            "code": "2823764100",
            "name": "갈산1동"
          },
          {
            "code": "2823764200",
            "name": "갈산2동"
          },
          {
            "code": "2823764600",
            "name": "삼산1동"
          },
          {
            "code": "2823764800",
            "name": "삼산2동"
          },
          {
            "code": "2823765000",
            "name": "부개1동"
          },
          {
            "code": "2823766000",
            "name": "부개2동"
          },
          {
            "code": "2823766100",
            "name": "부개3동"
          },
          {
            "code": "2823767000",
            "name": "일신동"
          },
          {
            "code": "2823768000",
            "name": "십정1동"
          },
          {
            "code": "2823769000",
            "name": "십정2동"
          }
        ]
      },
      {
        "code": "28245",
        "name": "계양구",
        "sub": [
          {
            "code": "2824560100",
            "name": "효성1동"
          },
          {
            "code": "2824560200",
            "name": "효성2동"
          },
          {
            "code": "2824561100",
            "name": "계산1동"
          },
          {
            "code": "2824561200",
            "name": "계산2동"
          },
          {
            "code": "2824561300",
            "name": "계산3동"
          },
          {
            "code": "2824561400",
            "name": "계산4동"
          },
          {
            "code": "2824562100",
            "name": "작전1동"
          },
          {
            "code": "2824562200",
            "name": "작전2동"
          },
          {
            "code": "2824564000",
            "name": "작전서운동"
          },
          {
            "code": "2824571000",
            "name": "계양1동"
          },
          {
            "code": "2824572000",
            "name": "계양2동"
          },
          {
            "code": "2824573000",
            "name": "계양3동"
          }
        ]
      },
      {
        "code": "28260",
        "name": "서구",
        "sub": [
          {
            "code": "2826051500",
            "name": "검암경서동"
          },
          {
            "code": "2826053000",
            "name": "연희동"
          },
          {
            "code": "2826053600",
            "name": "청라1동"
          },
          {
            "code": "2826053700",
            "name": "청라2동"
          },
          {
            "code": "2826053900",
            "name": "청라3동"
          },
          {
            "code": "2826054200",
            "name": "가정1동"
          },
          {
            "code": "2826054300",
            "name": "가정2동"
          },
          {
            "code": "2826054400",
            "name": "가정3동"
          },
          {
            "code": "2826055000",
            "name": "석남1동"
          },
          {
            "code": "2826056000",
            "name": "석남2동"
          },
          {
            "code": "2826056100",
            "name": "석남3동"
          },
          {
            "code": "2826057500",
            "name": "신현원창동"
          },
          {
            "code": "2826058000",
            "name": "가좌1동"
          },
          {
            "code": "2826059000",
            "name": "가좌2동"
          },
          {
            "code": "2826060000",
            "name": "가좌3동"
          },
          {
            "code": "2826061000",
            "name": "가좌4동"
          },
          {
            "code": "2826068000",
            "name": "검단동"
          },
          {
            "code": "2826069000",
            "name": "불로대곡동"
          },
          {
            "code": "2826070000",
            "name": "원당동"
          },
          {
            "code": "2826071000",
            "name": "당하동"
          },
          {
            "code": "2826072000",
            "name": "오류왕길동"
          },
          {
            "code": "2826073000",
            "name": "마전동"
          },
          {
            "code": "2826074000",
            "name": "아라동"
          }
        ]
      },
      {
        "code": "28710",
        "name": "강화군",
        "sub": [
          {
            "code": "2871025000",
            "name": "강화읍"
          },
          {
            "code": "2871031000",
            "name": "선원면"
          },
          {
            "code": "2871032000",
            "name": "불은면"
          },
          {
            "code": "2871033000",
            "name": "길상면"
          },
          {
            "code": "2871034000",
            "name": "화도면"
          },
          {
            "code": "2871035000",
            "name": "양도면"
          },
          {
            "code": "2871036000",
            "name": "내가면"
          },
          {
            "code": "2871037000",
            "name": "하점면"
          },
          {
            "code": "2871038000",
            "name": "양사면"
          },
          {
            "code": "2871039000",
            "name": "송해면"
          },
          {
            "code": "2871040000",
            "name": "교동면"
          },
          {
            "code": "2871041000",
            "name": "삼산면"
          },
          {
            "code": "2871042000",
            "name": "서도면"
          },
          {
            "code": "2871042500",
            "name": "서도면볼음출장소"
          }
        ]
      },
      {
        "code": "28720",
        "name": "옹진군",
        "sub": [
          {
            "code": "2872031000",
            "name": "북도면"
          },
          {
            "code": "2872031500",
            "name": "북도면장봉출장소"
          },
          {
            "code": "2872033000",
            "name": "백령면"
          },
          {
            "code": "2872034000",
            "name": "대청면"
          },
          {
            "code": "2872034500",
            "name": "대청면소청출장소"
          },
          {
            "code": "2872035000",
            "name": "덕적면"
          },
          {
            "code": "2872036000",
            "name": "영흥면"
          },
          {
            "code": "2872037000",
            "name": "자월면"
          },
          {
            "code": "2872037500",
            "name": "자월면이작출장소"
          },
          {
            "code": "2872038000",
            "name": "연평면"
          }
        ]
      }
    ]
  },
  {
    "code": "29",
    "name": "광주광역시",
    "sub": [
      {
        "code": "29110",
        "name": "동구",
        "sub": [
          {
            "code": "2911052500",
            "name": "충장동"
          },
          {
            "code": "2911054500",
            "name": "동명동"
          },
          {
            "code": "2911056000",
            "name": "계림1동"
          },
          {
            "code": "2911057000",
            "name": "계림2동"
          },
          {
            "code": "2911059000",
            "name": "산수1동"
          },
          {
            "code": "2911060000",
            "name": "산수2동"
          },
          {
            "code": "2911062000",
            "name": "지산1동"
          },
          {
            "code": "2911063000",
            "name": "지산2동"
          },
          {
            "code": "2911065500",
            "name": "서남동"
          },
          {
            "code": "2911068500",
            "name": "학동"
          },
          {
            "code": "2911071000",
            "name": "학운동"
          },
          {
            "code": "2911073000",
            "name": "지원1동"
          },
          {
            "code": "2911074000",
            "name": "지원2동"
          }
        ]
      },
      {
        "code": "29140",
        "name": "서구",
        "sub": [
          {
            "code": "2914057500",
            "name": "양동"
          },
          {
            "code": "2914059000",
            "name": "양3동"
          },
          {
            "code": "2914065000",
            "name": "농성1동"
          },
          {
            "code": "2914066000",
            "name": "농성2동"
          },
          {
            "code": "2914073000",
            "name": "광천동"
          },
          {
            "code": "2914074000",
            "name": "유덕동"
          },
          {
            "code": "2914074500",
            "name": "치평동"
          },
          {
            "code": "2914075100",
            "name": "상무1동"
          },
          {
            "code": "2914075200",
            "name": "상무2동"
          },
          {
            "code": "2914076000",
            "name": "화정1동"
          },
          {
            "code": "2914077000",
            "name": "화정2동"
          },
          {
            "code": "2914078000",
            "name": "화정3동"
          },
          {
            "code": "2914079000",
            "name": "화정4동"
          },
          {
            "code": "2914080000",
            "name": "서창동"
          },
          {
            "code": "2914082100",
            "name": "금호1동"
          },
          {
            "code": "2914082400",
            "name": "금호2동"
          },
          {
            "code": "2914083000",
            "name": "풍암동"
          },
          {
            "code": "2914084000",
            "name": "동천동"
          }
        ]
      },
      {
        "code": "29155",
        "name": "남구",
        "sub": [
          {
            "code": "2915551000",
            "name": "양림동"
          },
          {
            "code": "2915552000",
            "name": "방림1동"
          },
          {
            "code": "2915553000",
            "name": "방림2동"
          },
          {
            "code": "2915553700",
            "name": "봉선1동"
          },
          {
            "code": "2915553800",
            "name": "봉선2동"
          },
          {
            "code": "2915554500",
            "name": "사직동"
          },
          {
            "code": "2915560500",
            "name": "월산동"
          },
          {
            "code": "2915563000",
            "name": "월산4동"
          },
          {
            "code": "2915564000",
            "name": "월산5동"
          },
          {
            "code": "2915567000",
            "name": "백운1동"
          },
          {
            "code": "2915568000",
            "name": "백운2동"
          },
          {
            "code": "2915569000",
            "name": "주월1동"
          },
          {
            "code": "2915570000",
            "name": "주월2동"
          },
          {
            "code": "2915570500",
            "name": "진월동"
          },
          {
            "code": "2915571000",
            "name": "효덕동"
          },
          {
            "code": "2915572000",
            "name": "송암동"
          },
          {
            "code": "2915573000",
            "name": "대촌동"
          }
        ]
      },
      {
        "code": "29170",
        "name": "북구",
        "sub": [
          {
            "code": "2917051000",
            "name": "중흥1동"
          },
          {
            "code": "2917052000",
            "name": "중흥2동"
          },
          {
            "code": "2917053000",
            "name": "중흥3동"
          },
          {
            "code": "2917055500",
            "name": "중앙동"
          },
          {
            "code": "2917057000",
            "name": "임동"
          },
          {
            "code": "2917058000",
            "name": "신안동"
          },
          {
            "code": "2917059000",
            "name": "용봉동"
          },
          {
            "code": "2917060100",
            "name": "운암1동"
          },
          {
            "code": "2917060200",
            "name": "운암2동"
          },
          {
            "code": "2917060300",
            "name": "운암3동"
          },
          {
            "code": "2917061500",
            "name": "동림동"
          },
          {
            "code": "2917062000",
            "name": "우산동"
          },
          {
            "code": "2917063500",
            "name": "풍향동"
          },
          {
            "code": "2917065000",
            "name": "문화동"
          },
          {
            "code": "2917065600",
            "name": "문흥1동"
          },
          {
            "code": "2917065700",
            "name": "문흥2동"
          },
          {
            "code": "2917066100",
            "name": "두암1동"
          },
          {
            "code": "2917066200",
            "name": "두암2동"
          },
          {
            "code": "2917066300",
            "name": "두암3동"
          },
          {
            "code": "2917066600",
            "name": "삼각동"
          },
          {
            "code": "2917066900",
            "name": "일곡동"
          },
          {
            "code": "2917067300",
            "name": "매곡동"
          },
          {
            "code": "2917067600",
            "name": "오치1동"
          },
          {
            "code": "2917067700",
            "name": "오치2동"
          },
          {
            "code": "2917068500",
            "name": "석곡동"
          },
          {
            "code": "2917069500",
            "name": "건국동"
          },
          {
            "code": "2917069600",
            "name": "양산동"
          },
          {
            "code": "2917069700",
            "name": "신용동"
          }
        ]
      },
      {
        "code": "29200",
        "name": "광산구",
        "sub": [
          {
            "code": "2920051500",
            "name": "송정1동"
          },
          {
            "code": "2920052500",
            "name": "송정2동"
          },
          {
            "code": "2920054000",
            "name": "도산동"
          },
          {
            "code": "2920055000",
            "name": "신흥동"
          },
          {
            "code": "2920056500",
            "name": "어룡동"
          },
          {
            "code": "2920058000",
            "name": "우산동"
          },
          {
            "code": "2920060000",
            "name": "월곡1동"
          },
          {
            "code": "2920061000",
            "name": "월곡2동"
          },
          {
            "code": "2920062000",
            "name": "비아동"
          },
          {
            "code": "2920062400",
            "name": "첨단1동"
          },
          {
            "code": "2920062600",
            "name": "첨단2동"
          },
          {
            "code": "2920063000",
            "name": "신가동"
          },
          {
            "code": "2920063500",
            "name": "운남동"
          },
          {
            "code": "2920063700",
            "name": "수완동"
          },
          {
            "code": "2920064000",
            "name": "하남동"
          },
          {
            "code": "2920065000",
            "name": "임곡동"
          },
          {
            "code": "2920066000",
            "name": "동곡동"
          },
          {
            "code": "2920067000",
            "name": "평동"
          },
          {
            "code": "2920068000",
            "name": "삼도동"
          },
          {
            "code": "2920069000",
            "name": "본량동"
          },
          {
            "code": "2920070000",
            "name": "신창동"
          }
        ]
      }
    ]
  },
  {
    "code": "30",
    "name": "대전광역시",
    "sub": [
      {
        "code": "30110",
        "name": "동구",
        "sub": [
          {
            "code": "3011051500",
            "name": "중앙동"
          },
          {
            "code": "3011053000",
            "name": "효동"
          },
          {
            "code": "3011054500",
            "name": "신인동"
          },
          {
            "code": "3011055100",
            "name": "판암1동"
          },
          {
            "code": "3011055200",
            "name": "판암2동"
          },
          {
            "code": "3011056000",
            "name": "용운동"
          },
          {
            "code": "3011058500",
            "name": "대동"
          },
          {
            "code": "3011059000",
            "name": "자양동"
          },
          {
            "code": "3011062000",
            "name": "가양1동"
          },
          {
            "code": "3011063000",
            "name": "가양2동"
          },
          {
            "code": "3011064000",
            "name": "용전동"
          },
          {
            "code": "3011066500",
            "name": "성남동"
          },
          {
            "code": "3011067000",
            "name": "홍도동"
          },
          {
            "code": "3011069500",
            "name": "삼성동"
          },
          {
            "code": "3011072500",
            "name": "대청동"
          },
          {
            "code": "3011074000",
            "name": "산내동"
          }
        ]
      },
      {
        "code": "30140",
        "name": "중구",
        "sub": [
          {
            "code": "3014053500",
            "name": "은행선화동"
          },
          {
            "code": "3014055000",
            "name": "목동"
          },
          {
            "code": "3014056000",
            "name": "중촌동"
          },
          {
            "code": "3014057500",
            "name": "대흥동"
          },
          {
            "code": "3014060500",
            "name": "문창동"
          },
          {
            "code": "3014062000",
            "name": "석교동"
          },
          {
            "code": "3014063000",
            "name": "대사동"
          },
          {
            "code": "3014064000",
            "name": "부사동"
          },
          {
            "code": "3014065500",
            "name": "용두동"
          },
          {
            "code": "3014067000",
            "name": "오류동"
          },
          {
            "code": "3014068000",
            "name": "태평1동"
          },
          {
            "code": "3014069000",
            "name": "태평2동"
          },
          {
            "code": "3014070000",
            "name": "유천1동"
          },
          {
            "code": "3014071000",
            "name": "유천2동"
          },
          {
            "code": "3014072000",
            "name": "문화1동"
          },
          {
            "code": "3014073000",
            "name": "문화2동"
          },
          {
            "code": "3014074000",
            "name": "산성동"
          }
        ]
      },
      {
        "code": "30170",
        "name": "서구",
        "sub": [
          {
            "code": "3017051000",
            "name": "복수동"
          },
          {
            "code": "3017052000",
            "name": "도마1동"
          },
          {
            "code": "3017053000",
            "name": "도마2동"
          },
          {
            "code": "3017053500",
            "name": "정림동"
          },
          {
            "code": "3017054000",
            "name": "변동"
          },
          {
            "code": "3017055000",
            "name": "용문동"
          },
          {
            "code": "3017055500",
            "name": "탄방동"
          },
          {
            "code": "3017056000",
            "name": "괴정동"
          },
          {
            "code": "3017057000",
            "name": "가장동"
          },
          {
            "code": "3017057500",
            "name": "내동"
          },
          {
            "code": "3017058100",
            "name": "갈마1동"
          },
          {
            "code": "3017058200",
            "name": "갈마2동"
          },
          {
            "code": "3017058600",
            "name": "월평1동"
          },
          {
            "code": "3017058700",
            "name": "월평2동"
          },
          {
            "code": "3017058800",
            "name": "월평3동"
          },
          {
            "code": "3017059000",
            "name": "가수원동"
          },
          {
            "code": "3017059300",
            "name": "도안동"
          },
          {
            "code": "3017059600",
            "name": "관저1동"
          },
          {
            "code": "3017059700",
            "name": "관저2동"
          },
          {
            "code": "3017060000",
            "name": "기성동"
          },
          {
            "code": "3017063000",
            "name": "둔산1동"
          },
          {
            "code": "3017064000",
            "name": "둔산2동"
          },
          {
            "code": "3017065000",
            "name": "만년동"
          },
          {
            "code": "3017066000",
            "name": "둔산3동"
          }
        ]
      },
      {
        "code": "30200",
        "name": "유성구",
        "sub": [
          {
            "code": "3020052000",
            "name": "진잠동"
          },
          {
            "code": "3020052600",
            "name": "학하동"
          },
          {
            "code": "3020052700",
            "name": "상대동"
          },
          {
            "code": "3020053000",
            "name": "온천1동"
          },
          {
            "code": "3020054000",
            "name": "온천2동"
          },
          {
            "code": "3020054600",
            "name": "노은1동"
          },
          {
            "code": "3020054700",
            "name": "노은2동"
          },
          {
            "code": "3020054800",
            "name": "노은3동"
          },
          {
            "code": "3020055000",
            "name": "신성동"
          },
          {
            "code": "3020057000",
            "name": "전민동"
          },
          {
            "code": "3020058000",
            "name": "구즉동"
          },
          {
            "code": "3020060000",
            "name": "관평동"
          },
          {
            "code": "3020061000",
            "name": "원신흥동"
          }
        ]
      },
      {
        "code": "30230",
        "name": "대덕구",
        "sub": [
          {
            "code": "3023051000",
            "name": "오정동"
          },
          {
            "code": "3023052000",
            "name": "대화동"
          },
          {
            "code": "3023052500",
            "name": "회덕동"
          },
          {
            "code": "3023053300",
            "name": "비래동"
          },
          {
            "code": "3023054300",
            "name": "송촌동"
          },
          {
            "code": "3023054600",
            "name": "중리동"
          },
          {
            "code": "3023055000",
            "name": "신탄진동"
          },
          {
            "code": "3023056000",
            "name": "석봉동"
          },
          {
            "code": "3023057000",
            "name": "덕암동"
          },
          {
            "code": "3023058000",
            "name": "목상동"
          },
          {
            "code": "3023060000",
            "name": "법1동"
          },
          {
            "code": "3023061000",
            "name": "법2동"
          }
        ]
      }
    ]
  },
  {
    "code": "31",
    "name": "울산광역시",
    "sub": [
      {
        "code": "31110",
        "name": "중구",
        "sub": [
          {
            "code": "3111051000",
            "name": "학성동"
          },
          {
            "code": "3111052000",
            "name": "반구1동"
          },
          {
            "code": "3111053000",
            "name": "반구2동"
          },
          {
            "code": "3111054000",
            "name": "복산1동"
          },
          {
            "code": "3111055000",
            "name": "복산2동"
          },
          {
            "code": "3111058500",
            "name": "중앙동"
          },
          {
            "code": "3111059000",
            "name": "우정동"
          },
          {
            "code": "3111060000",
            "name": "태화동"
          },
          {
            "code": "3111061000",
            "name": "다운동"
          },
          {
            "code": "3111062000",
            "name": "병영1동"
          },
          {
            "code": "3111063000",
            "name": "병영2동"
          },
          {
            "code": "3111064000",
            "name": "약사동"
          },
          {
            "code": "3111065000",
            "name": "성안동"
          }
        ]
      },
      {
        "code": "31140",
        "name": "남구",
        "sub": [
          {
            "code": "3114051000",
            "name": "신정1동"
          },
          {
            "code": "3114052000",
            "name": "신정2동"
          },
          {
            "code": "3114053000",
            "name": "신정3동"
          },
          {
            "code": "3114054000",
            "name": "신정4동"
          },
          {
            "code": "3114055000",
            "name": "신정5동"
          },
          {
            "code": "3114056000",
            "name": "달동"
          },
          {
            "code": "3114057000",
            "name": "삼산동"
          },
          {
            "code": "3114058500",
            "name": "삼호동"
          },
          {
            "code": "3114059500",
            "name": "무거동"
          },
          {
            "code": "3114060000",
            "name": "옥동"
          },
          {
            "code": "3114062500",
            "name": "대현동"
          },
          {
            "code": "3114063500",
            "name": "수암동"
          },
          {
            "code": "3114064000",
            "name": "선암동"
          },
          {
            "code": "3114067000",
            "name": "야음장생포동"
          }
        ]
      },
      {
        "code": "31170",
        "name": "동구",
        "sub": [
          {
            "code": "3117051000",
            "name": "방어동"
          },
          {
            "code": "3117052000",
            "name": "일산동"
          },
          {
            "code": "3117053000",
            "name": "화정동"
          },
          {
            "code": "3117054000",
            "name": "대송동"
          },
          {
            "code": "3117055000",
            "name": "전하1동"
          },
          {
            "code": "3117056000",
            "name": "전하2동"
          },
          {
            "code": "3117058000",
            "name": "남목1동"
          },
          {
            "code": "3117059000",
            "name": "남목2동"
          },
          {
            "code": "3117060000",
            "name": "남목3동"
          }
        ]
      },
      {
        "code": "31200",
        "name": "북구",
        "sub": [
          {
            "code": "3120051000",
            "name": "농소1동"
          },
          {
            "code": "3120052000",
            "name": "농소2동"
          },
          {
            "code": "3120053000",
            "name": "농소3동"
          },
          {
            "code": "3120054000",
            "name": "강동동"
          },
          {
            "code": "3120056000",
            "name": "효문동"
          },
          {
            "code": "3120057000",
            "name": "송정동"
          },
          {
            "code": "3120058000",
            "name": "양정동"
          },
          {
            "code": "3120059000",
            "name": "염포동"
          }
        ]
      },
      {
        "code": "31710",
        "name": "울주군",
        "sub": [
          {
            "code": "3171025000",
            "name": "온산읍"
          },
          {
            "code": "3171025300",
            "name": "언양읍"
          },
          {
            "code": "3171025600",
            "name": "온양읍"
          },
          {
            "code": "3171025900",
            "name": "범서읍"
          },
          {
            "code": "3171026200",
            "name": "청량읍"
          },
          {
            "code": "3171026500",
            "name": "삼남읍"
          },
          {
            "code": "3171031000",
            "name": "서생면"
          },
          {
            "code": "3171034000",
            "name": "웅촌면"
          },
          {
            "code": "3171036000",
            "name": "두동면"
          },
          {
            "code": "3171037000",
            "name": "두서면"
          },
          {
            "code": "3171038000",
            "name": "상북면"
          },
          {
            "code": "3171040000",
            "name": "삼동면"
          }
        ]
      }
    ]
  },
  {
    "code": "41",
    "name": "경기도",
    "sub": [
      {
        "code": "41111",
        "name": "수원시 장안구",
        "sub": [
          {
            "code": "4111156000",
            "name": "파장동"
          },
          {
            "code": "4111156600",
            "name": "율천동"
          },
          {
            "code": "4111157100",
            "name": "정자1동"
          },
          {
            "code": "4111157200",
            "name": "정자2동"
          },
          {
            "code": "4111157300",
            "name": "정자3동"
          },
          {
            "code": "4111158000",
            "name": "영화동"
          },
          {
            "code": "4111159100",
            "name": "송죽동"
          },
          {
            "code": "4111159700",
            "name": "조원1동"
          },
          {
            "code": "4111159800",
            "name": "조원2동"
          },
          {
            "code": "4111160000",
            "name": "연무동"
          }
        ]
      },
      {
        "code": "41113",
        "name": "수원시 권선구",
        "sub": [
          {
            "code": "4111352000",
            "name": "세류1동"
          },
          {
            "code": "4111353000",
            "name": "세류2동"
          },
          {
            "code": "4111354000",
            "name": "세류3동"
          },
          {
            "code": "4111355000",
            "name": "평동"
          },
          {
            "code": "4111356000",
            "name": "서둔동"
          },
          {
            "code": "4111365000",
            "name": "구운동"
          },
          {
            "code": "4111366200",
            "name": "금곡동"
          },
          {
            "code": "4111366400",
            "name": "호매실동"
          },
          {
            "code": "4111367000",
            "name": "권선1동"
          },
          {
            "code": "4111368000",
            "name": "권선2동"
          },
          {
            "code": "4111369000",
            "name": "곡선동"
          },
          {
            "code": "4111370000",
            "name": "입북동"
          }
        ]
      },
      {
        "code": "41115",
        "name": "수원시 팔달구",
        "sub": [
          {
            "code": "4111565000",
            "name": "매교동"
          },
          {
            "code": "4111566000",
            "name": "매산동"
          },
          {
            "code": "4111567000",
            "name": "고등동"
          },
          {
            "code": "4111568000",
            "name": "화서1동"
          },
          {
            "code": "4111569000",
            "name": "화서2동"
          },
          {
            "code": "4111570000",
            "name": "지동"
          },
          {
            "code": "4111571000",
            "name": "우만1동"
          },
          {
            "code": "4111572000",
            "name": "우만2동"
          },
          {
            "code": "4111573000",
            "name": "인계동"
          },
          {
            "code": "4111574000",
            "name": "행궁동"
          }
        ]
      },
      {
        "code": "41117",
        "name": "수원시 영통구",
        "sub": [
          {
            "code": "4111751000",
            "name": "매탄1동"
          },
          {
            "code": "4111752000",
            "name": "매탄2동"
          },
          {
            "code": "4111753000",
            "name": "매탄3동"
          },
          {
            "code": "4111754000",
            "name": "매탄4동"
          },
          {
            "code": "4111755000",
            "name": "원천동"
          },
          {
            "code": "4111757000",
            "name": "영통1동"
          },
          {
            "code": "4111758000",
            "name": "영통2동"
          },
          {
            "code": "4111758500",
            "name": "영통3동"
          },
          {
            "code": "4111759300",
            "name": "망포1동"
          },
          {
            "code": "4111759600",
            "name": "망포2동"
          },
          {
            "code": "4111760000",
            "name": "광교1동"
          },
          {
            "code": "4111761000",
            "name": "광교2동"
          }
        ]
      },
      {
        "code": "41131",
        "name": "성남시 수정구",
        "sub": [
          {
            "code": "4113151000",
            "name": "신흥1동"
          },
          {
            "code": "4113152000",
            "name": "신흥2동"
          },
          {
            "code": "4113153000",
            "name": "신흥3동"
          },
          {
            "code": "4113154000",
            "name": "태평1동"
          },
          {
            "code": "4113155000",
            "name": "태평2동"
          },
          {
            "code": "4113156000",
            "name": "태평3동"
          },
          {
            "code": "4113156100",
            "name": "태평4동"
          },
          {
            "code": "4113157000",
            "name": "수진1동"
          },
          {
            "code": "4113158000",
            "name": "수진2동"
          },
          {
            "code": "4113159000",
            "name": "단대동"
          },
          {
            "code": "4113160000",
            "name": "산성동"
          },
          {
            "code": "4113161000",
            "name": "양지동"
          },
          {
            "code": "4113162000",
            "name": "복정동"
          },
          {
            "code": "4113162500",
            "name": "위례동"
          },
          {
            "code": "4113163000",
            "name": "신촌동"
          },
          {
            "code": "4113164000",
            "name": "고등동"
          },
          {
            "code": "4113165000",
            "name": "시흥동"
          }
        ]
      },
      {
        "code": "41133",
        "name": "성남시 중원구",
        "sub": [
          {
            "code": "4113351000",
            "name": "성남동"
          },
          {
            "code": "4113352500",
            "name": "중앙동"
          },
          {
            "code": "4113353000",
            "name": "금광1동"
          },
          {
            "code": "4113354000",
            "name": "금광2동"
          },
          {
            "code": "4113355000",
            "name": "은행1동"
          },
          {
            "code": "4113356000",
            "name": "은행2동"
          },
          {
            "code": "4113357000",
            "name": "상대원1동"
          },
          {
            "code": "4113358000",
            "name": "상대원2동"
          },
          {
            "code": "4113359000",
            "name": "상대원3동"
          },
          {
            "code": "4113366000",
            "name": "하대원동"
          },
          {
            "code": "4113367000",
            "name": "도촌동"
          }
        ]
      },
      {
        "code": "41135",
        "name": "성남시 분당구",
        "sub": [
          {
            "code": "4113551000",
            "name": "분당동"
          },
          {
            "code": "4113552000",
            "name": "수내1동"
          },
          {
            "code": "4113553000",
            "name": "수내2동"
          },
          {
            "code": "4113554000",
            "name": "수내3동"
          },
          {
            "code": "4113554500",
            "name": "정자동"
          },
          {
            "code": "4113555000",
            "name": "정자1동"
          },
          {
            "code": "4113556000",
            "name": "정자2동"
          },
          {
            "code": "4113557000",
            "name": "정자3동"
          },
          {
            "code": "4113558000",
            "name": "서현1동"
          },
          {
            "code": "4113559000",
            "name": "서현2동"
          },
          {
            "code": "4113560000",
            "name": "이매1동"
          },
          {
            "code": "4113561000",
            "name": "이매2동"
          },
          {
            "code": "4113562000",
            "name": "야탑1동"
          },
          {
            "code": "4113563000",
            "name": "야탑2동"
          },
          {
            "code": "4113564000",
            "name": "야탑3동"
          },
          {
            "code": "4113565000",
            "name": "판교동"
          },
          {
            "code": "4113565500",
            "name": "삼평동"
          },
          {
            "code": "4113565700",
            "name": "백현동"
          },
          {
            "code": "4113566200",
            "name": "금곡동"
          },
          {
            "code": "4113566500",
            "name": "구미1동"
          },
          {
            "code": "4113567000",
            "name": "구미동"
          },
          {
            "code": "4113568000",
            "name": "운중동"
          }
        ]
      },
      {
        "code": "41150",
        "name": "의정부시",
        "sub": [
          {
            "code": "4115051000",
            "name": "의정부1동"
          },
          {
            "code": "4115052000",
            "name": "의정부2동"
          },
          {
            "code": "4115054500",
            "name": "호원1동"
          },
          {
            "code": "4115055500",
            "name": "호원2동"
          },
          {
            "code": "4115056100",
            "name": "장암동"
          },
          {
            "code": "4115056700",
            "name": "신곡1동"
          },
          {
            "code": "4115056800",
            "name": "신곡2동"
          },
          {
            "code": "4115057300",
            "name": "송산1동"
          },
          {
            "code": "4115057600",
            "name": "송산2동"
          },
          {
            "code": "4115057800",
            "name": "송산3동"
          },
          {
            "code": "4115058000",
            "name": "자금동"
          },
          {
            "code": "4115059500",
            "name": "가능동"
          },
          {
            "code": "4115061500",
            "name": "흥선동"
          },
          {
            "code": "4115062000",
            "name": "녹양동"
          }
        ]
      },
      {
        "code": "41171",
        "name": "안양시 만안구",
        "sub": [
          {
            "code": "4117151000",
            "name": "안양1동"
          },
          {
            "code": "4117152000",
            "name": "안양2동"
          },
          {
            "code": "4117153000",
            "name": "안양3동"
          },
          {
            "code": "4117154000",
            "name": "안양4동"
          },
          {
            "code": "4117155000",
            "name": "안양5동"
          },
          {
            "code": "4117156000",
            "name": "안양6동"
          },
          {
            "code": "4117157000",
            "name": "안양7동"
          },
          {
            "code": "4117158000",
            "name": "안양8동"
          },
          {
            "code": "4117158100",
            "name": "안양9동"
          },
          {
            "code": "4117159000",
            "name": "석수1동"
          },
          {
            "code": "4117160000",
            "name": "석수2동"
          },
          {
            "code": "4117161000",
            "name": "석수3동"
          },
          {
            "code": "4117162100",
            "name": "박달1동"
          },
          {
            "code": "4117163000",
            "name": "박달2동"
          }
        ]
      },
      {
        "code": "41173",
        "name": "안양시 동안구",
        "sub": [
          {
            "code": "4117351000",
            "name": "비산1동"
          },
          {
            "code": "4117352000",
            "name": "비산2동"
          },
          {
            "code": "4117353000",
            "name": "비산3동"
          },
          {
            "code": "4117354000",
            "name": "부흥동"
          },
          {
            "code": "4117354600",
            "name": "달안동"
          },
          {
            "code": "4117355000",
            "name": "관양1동"
          },
          {
            "code": "4117356000",
            "name": "관양2동"
          },
          {
            "code": "4117356600",
            "name": "부림동"
          },
          {
            "code": "4117357000",
            "name": "평촌동"
          },
          {
            "code": "4117357600",
            "name": "평안동"
          },
          {
            "code": "4117357800",
            "name": "귀인동"
          },
          {
            "code": "4117358000",
            "name": "호계1동"
          },
          {
            "code": "4117359000",
            "name": "호계2동"
          },
          {
            "code": "4117360000",
            "name": "호계3동"
          },
          {
            "code": "4117361000",
            "name": "범계동"
          },
          {
            "code": "4117362000",
            "name": "신촌동"
          },
          {
            "code": "4117363000",
            "name": "갈산동"
          }
        ]
      },
      {
        "code": "41190",
        "name": "부천시",
        "sub": [
          {
            "code": "4119060300",
            "name": "심곡동"
          },
          {
            "code": "4119060600",
            "name": "부천동"
          },
          {
            "code": "4119061000",
            "name": "중동"
          },
          {
            "code": "4119074200",
            "name": "신중동"
          },
          {
            "code": "4119074400",
            "name": "상동"
          },
          {
            "code": "4119074600",
            "name": "대산동"
          },
          {
            "code": "4119075000",
            "name": "소사본동"
          },
          {
            "code": "4119079500",
            "name": "범안동"
          },
          {
            "code": "4119080000",
            "name": "성곡동"
          },
          {
            "code": "4119083000",
            "name": "오정동"
          }
        ]
      },
      {
        "code": "41210",
        "name": "광명시",
        "sub": [
          {
            "code": "4121051000",
            "name": "광명1동"
          },
          {
            "code": "4121052000",
            "name": "광명2동"
          },
          {
            "code": "4121054000",
            "name": "광명3동"
          },
          {
            "code": "4121055000",
            "name": "광명4동"
          },
          {
            "code": "4121056000",
            "name": "광명5동"
          },
          {
            "code": "4121057000",
            "name": "광명6동"
          },
          {
            "code": "4121058000",
            "name": "광명7동"
          },
          {
            "code": "4121059000",
            "name": "철산1동"
          },
          {
            "code": "4121060000",
            "name": "철산2동"
          },
          {
            "code": "4121061000",
            "name": "철산3동"
          },
          {
            "code": "4121062000",
            "name": "철산4동"
          },
          {
            "code": "4121063100",
            "name": "하안1동"
          },
          {
            "code": "4121063200",
            "name": "하안2동"
          },
          {
            "code": "4121063300",
            "name": "하안3동"
          },
          {
            "code": "4121063400",
            "name": "하안4동"
          },
          {
            "code": "4121064000",
            "name": "소하1동"
          },
          {
            "code": "4121065000",
            "name": "소하2동"
          },
          {
            "code": "4121065500",
            "name": "일직동"
          },
          {
            "code": "4121066000",
            "name": "학온동"
          }
        ]
      },
      {
        "code": "41220",
        "name": "평택시",
        "sub": [
          {
            "code": "4122025000",
            "name": "팽성읍"
          },
          {
            "code": "4122025300",
            "name": "안중읍"
          },
          {
            "code": "4122025600",
            "name": "포승읍"
          },
          {
            "code": "4122025900",
            "name": "청북읍"
          },
          {
            "code": "4122031000",
            "name": "진위면"
          },
          {
            "code": "4122032000",
            "name": "서탄면"
          },
          {
            "code": "4122033000",
            "name": "고덕면"
          },
          {
            "code": "4122034000",
            "name": "오성면"
          },
          {
            "code": "4122037000",
            "name": "현덕면"
          },
          {
            "code": "4122051000",
            "name": "중앙동"
          },
          {
            "code": "4122052000",
            "name": "서정동"
          },
          {
            "code": "4122053500",
            "name": "송탄동"
          },
          {
            "code": "4122055000",
            "name": "지산동"
          },
          {
            "code": "4122056000",
            "name": "송북동"
          },
          {
            "code": "4122057000",
            "name": "신장1동"
          },
          {
            "code": "4122058000",
            "name": "신장2동"
          },
          {
            "code": "4122059000",
            "name": "신평동"
          },
          {
            "code": "4122060000",
            "name": "원평동"
          },
          {
            "code": "4122061000",
            "name": "통복동"
          },
          {
            "code": "4122062000",
            "name": "비전1동"
          },
          {
            "code": "4122063000",
            "name": "비전2동"
          },
          {
            "code": "4122063500",
            "name": "용이동"
          },
          {
            "code": "4122064000",
            "name": "세교동"
          },
          {
            "code": "4122065000",
            "name": "동삭동"
          },
          {
            "code": "4122066000",
            "name": "고덕동"
          }
        ]
      },
      {
        "code": "41250",
        "name": "동두천시",
        "sub": [
          {
            "code": "4125051000",
            "name": "생연1동"
          },
          {
            "code": "4125052000",
            "name": "생연2동"
          },
          {
            "code": "4125053500",
            "name": "중앙동"
          },
          {
            "code": "4125055000",
            "name": "보산동"
          },
          {
            "code": "4125056500",
            "name": "불현동"
          },
          {
            "code": "4125056600",
            "name": "송내동"
          },
          {
            "code": "4125058000",
            "name": "소요동"
          },
          {
            "code": "4125060000",
            "name": "상패동"
          }
        ]
      },
      {
        "code": "41271",
        "name": "안산시 상록구",
        "sub": [
          {
            "code": "4127151000",
            "name": "일동"
          },
          {
            "code": "4127151500",
            "name": "이동"
          },
          {
            "code": "4127152500",
            "name": "사동"
          },
          {
            "code": "4127153200",
            "name": "사이동"
          },
          {
            "code": "4127153700",
            "name": "해양동"
          },
          {
            "code": "4127154000",
            "name": "본오1동"
          },
          {
            "code": "4127155000",
            "name": "본오2동"
          },
          {
            "code": "4127156000",
            "name": "본오3동"
          },
          {
            "code": "4127157000",
            "name": "부곡동"
          },
          {
            "code": "4127158000",
            "name": "월피동"
          },
          {
            "code": "4127159000",
            "name": "성포동"
          },
          {
            "code": "4127160000",
            "name": "반월동"
          },
          {
            "code": "4127161000",
            "name": "안산동"
          }
        ]
      },
      {
        "code": "41273",
        "name": "안산시 단원구",
        "sub": [
          {
            "code": "4127351000",
            "name": "와동"
          },
          {
            "code": "4127352500",
            "name": "고잔동"
          },
          {
            "code": "4127353200",
            "name": "중앙동"
          },
          {
            "code": "4127353500",
            "name": "호수동"
          },
          {
            "code": "4127354500",
            "name": "원곡동"
          },
          {
            "code": "4127355500",
            "name": "백운동"
          },
          {
            "code": "4127356500",
            "name": "신길동"
          },
          {
            "code": "4127357000",
            "name": "초지동"
          },
          {
            "code": "4127358000",
            "name": "선부1동"
          },
          {
            "code": "4127359000",
            "name": "선부2동"
          },
          {
            "code": "4127360000",
            "name": "선부3동"
          },
          {
            "code": "4127361000",
            "name": "대부동"
          }
        ]
      },
      {
        "code": "41281",
        "name": "고양시 덕양구",
        "sub": [
          {
            "code": "4128151000",
            "name": "주교동"
          },
          {
            "code": "4128152000",
            "name": "원신동"
          },
          {
            "code": "4128153000",
            "name": "흥도동"
          },
          {
            "code": "4128154000",
            "name": "성사1동"
          },
          {
            "code": "4128155000",
            "name": "성사2동"
          },
          {
            "code": "4128156000",
            "name": "효자동"
          },
          {
            "code": "4128157600",
            "name": "삼송1동"
          },
          {
            "code": "4128157700",
            "name": "삼송2동"
          },
          {
            "code": "4128158000",
            "name": "창릉동"
          },
          {
            "code": "4128159000",
            "name": "고양동"
          },
          {
            "code": "4128160000",
            "name": "관산동"
          },
          {
            "code": "4128161000",
            "name": "능곡동"
          },
          {
            "code": "4128162100",
            "name": "화정1동"
          },
          {
            "code": "4128162200",
            "name": "화정2동"
          },
          {
            "code": "4128163000",
            "name": "행주동"
          },
          {
            "code": "4128164000",
            "name": "행신1동"
          },
          {
            "code": "4128165000",
            "name": "행신2동"
          },
          {
            "code": "4128165500",
            "name": "행신3동"
          },
          {
            "code": "4128165600",
            "name": "행신4동"
          },
          {
            "code": "4128166000",
            "name": "화전동"
          },
          {
            "code": "4128167000",
            "name": "대덕동"
          }
        ]
      },
      {
        "code": "41285",
        "name": "고양시 일산동구",
        "sub": [
          {
            "code": "4128551000",
            "name": "식사동"
          },
          {
            "code": "4128552500",
            "name": "중산1동"
          },
          {
            "code": "4128552600",
            "name": "중산2동"
          },
          {
            "code": "4128553000",
            "name": "정발산동"
          },
          {
            "code": "4128554000",
            "name": "풍산동"
          },
          {
            "code": "4128555100",
            "name": "백석1동"
          },
          {
            "code": "4128555200",
            "name": "백석2동"
          },
          {
            "code": "4128556000",
            "name": "마두1동"
          },
          {
            "code": "4128557000",
            "name": "마두2동"
          },
          {
            "code": "4128558000",
            "name": "장항1동"
          },
          {
            "code": "4128559000",
            "name": "장항2동"
          },
          {
            "code": "4128560000",
            "name": "고봉동"
          }
        ]
      },
      {
        "code": "41287",
        "name": "고양시 일산서구",
        "sub": [
          {
            "code": "4128751000",
            "name": "일산1동"
          },
          {
            "code": "4128752000",
            "name": "일산2동"
          },
          {
            "code": "4128753000",
            "name": "일산3동"
          },
          {
            "code": "4128754500",
            "name": "탄현1동"
          },
          {
            "code": "4128754600",
            "name": "탄현2동"
          },
          {
            "code": "4128755000",
            "name": "주엽1동"
          },
          {
            "code": "4128756000",
            "name": "주엽2동"
          },
          {
            "code": "4128757000",
            "name": "대화동"
          },
          {
            "code": "4128758000",
            "name": "송포동"
          },
          {
            "code": "4128760000",
            "name": "덕이동"
          },
          {
            "code": "4128761000",
            "name": "가좌동"
          }
        ]
      },
      {
        "code": "41290",
        "name": "과천시",
        "sub": [
          {
            "code": "4129051000",
            "name": "중앙동"
          },
          {
            "code": "4129052000",
            "name": "갈현동"
          },
          {
            "code": "4129053000",
            "name": "별양동"
          },
          {
            "code": "4129054000",
            "name": "부림동"
          },
          {
            "code": "4129055000",
            "name": "과천동"
          },
          {
            "code": "4129056000",
            "name": "문원동"
          }
        ]
      },
      {
        "code": "41310",
        "name": "구리시",
        "sub": [
          {
            "code": "4131051000",
            "name": "갈매동"
          },
          {
            "code": "4131052000",
            "name": "동구동"
          },
          {
            "code": "4131053000",
            "name": "인창동"
          },
          {
            "code": "4131054100",
            "name": "교문1동"
          },
          {
            "code": "4131054200",
            "name": "교문2동"
          },
          {
            "code": "4131057000",
            "name": "수택1동"
          },
          {
            "code": "4131058000",
            "name": "수택2동"
          },
          {
            "code": "4131059000",
            "name": "수택3동"
          }
        ]
      },
      {
        "code": "41360",
        "name": "남양주시",
        "sub": [
          {
            "code": "4136025000",
            "name": "와부읍"
          },
          {
            "code": "4136025300",
            "name": "진접읍"
          },
          {
            "code": "4136025600",
            "name": "화도읍"
          },
          {
            "code": "4136025700",
            "name": "화도읍동부출장소"
          },
          {
            "code": "4136025800",
            "name": "화도읍남부출장소"
          },
          {
            "code": "4136025900",
            "name": "진건읍"
          },
          {
            "code": "4136026200",
            "name": "오남읍"
          },
          {
            "code": "4136026500",
            "name": "퇴계원읍"
          },
          {
            "code": "4136031000",
            "name": "별내면"
          },
          {
            "code": "4136034000",
            "name": "수동면"
          },
          {
            "code": "4136036000",
            "name": "조안면"
          },
          {
            "code": "4136051000",
            "name": "호평동"
          },
          {
            "code": "4136052000",
            "name": "평내동"
          },
          {
            "code": "4136053000",
            "name": "금곡동"
          },
          {
            "code": "4136054000",
            "name": "양정동"
          },
          {
            "code": "4136054500",
            "name": "다산1동"
          },
          {
            "code": "4136056500",
            "name": "다산2동"
          },
          {
            "code": "4136057000",
            "name": "별내동"
          }
        ]
      },
      {
        "code": "41370",
        "name": "오산시",
        "sub": [
          {
            "code": "4137051000",
            "name": "중앙동"
          },
          {
            "code": "4137053000",
            "name": "남촌동"
          },
          {
            "code": "4137054000",
            "name": "신장동"
          },
          {
            "code": "4137055000",
            "name": "세마동"
          },
          {
            "code": "4137056000",
            "name": "초평동"
          },
          {
            "code": "4137057000",
            "name": "대원동"
          }
        ]
      },
      {
        "code": "41390",
        "name": "시흥시",
        "sub": [
          {
            "code": "4139051000",
            "name": "대야동"
          },
          {
            "code": "4139052000",
            "name": "신천동"
          },
          {
            "code": "4139053100",
            "name": "신현동"
          },
          {
            "code": "4139054000",
            "name": "은행동"
          },
          {
            "code": "4139055000",
            "name": "매화동"
          },
          {
            "code": "4139057000",
            "name": "목감동"
          },
          {
            "code": "4139058100",
            "name": "군자동"
          },
          {
            "code": "4139058200",
            "name": "월곶동"
          },
          {
            "code": "4139058900",
            "name": "정왕본동"
          },
          {
            "code": "4139059100",
            "name": "정왕1동"
          },
          {
            "code": "4139059200",
            "name": "정왕2동"
          },
          {
            "code": "4139059300",
            "name": "정왕3동"
          },
          {
            "code": "4139059400",
            "name": "정왕4동"
          },
          {
            "code": "4139059600",
            "name": "배곧1동"
          },
          {
            "code": "4139059700",
            "name": "배곧2동"
          },
          {
            "code": "4139062100",
            "name": "과림동"
          },
          {
            "code": "4139063000",
            "name": "연성동"
          },
          {
            "code": "4139063100",
            "name": "장곡동"
          },
          {
            "code": "4139064000",
            "name": "능곡동"
          }
        ]
      },
      {
        "code": "41410",
        "name": "군포시",
        "sub": [
          {
            "code": "4141051000",
            "name": "군포1동"
          },
          {
            "code": "4141052000",
            "name": "군포2동"
          },
          {
            "code": "4141054000",
            "name": "산본1동"
          },
          {
            "code": "4141055000",
            "name": "산본2동"
          },
          {
            "code": "4141056000",
            "name": "금정동"
          },
          {
            "code": "4141057000",
            "name": "재궁동"
          },
          {
            "code": "4141058000",
            "name": "오금동"
          },
          {
            "code": "4141059000",
            "name": "수리동"
          },
          {
            "code": "4141060000",
            "name": "궁내동"
          },
          {
            "code": "4141061000",
            "name": "대야동"
          },
          {
            "code": "4141062000",
            "name": "광정동"
          },
          {
            "code": "4141063000",
            "name": "송부동"
          }
        ]
      },
      {
        "code": "41430",
        "name": "의왕시",
        "sub": [
          {
            "code": "4143051000",
            "name": "고천동"
          },
          {
            "code": "4143052000",
            "name": "부곡동"
          },
          {
            "code": "4143053000",
            "name": "오전동"
          },
          {
            "code": "4143054000",
            "name": "내손1동"
          },
          {
            "code": "4143055000",
            "name": "내손2동"
          },
          {
            "code": "4143056000",
            "name": "청계동"
          }
        ]
      },
      {
        "code": "41450",
        "name": "하남시",
        "sub": [
          {
            "code": "4145051000",
            "name": "천현동"
          },
          {
            "code": "4145052000",
            "name": "신장1동"
          },
          {
            "code": "4145053000",
            "name": "신장2동"
          },
          {
            "code": "4145054000",
            "name": "덕풍1동"
          },
          {
            "code": "4145055000",
            "name": "덕풍2동"
          },
          {
            "code": "4145056000",
            "name": "덕풍3동"
          },
          {
            "code": "4145057000",
            "name": "풍산동"
          },
          {
            "code": "4145058000",
            "name": "감북동"
          },
          {
            "code": "4145058200",
            "name": "감일동"
          },
          {
            "code": "4145058500",
            "name": "위례동"
          },
          {
            "code": "4145059000",
            "name": "춘궁동"
          },
          {
            "code": "4145060000",
            "name": "초이동"
          },
          {
            "code": "4145061000",
            "name": "미사1동"
          },
          {
            "code": "4145062000",
            "name": "미사2동"
          }
        ]
      },
      {
        "code": "41461",
        "name": "용인시 처인구",
        "sub": [
          {
            "code": "4146125000",
            "name": "포곡읍"
          },
          {
            "code": "4146125300",
            "name": "모현읍"
          },
          {
            "code": "4146125600",
            "name": "이동읍"
          },
          {
            "code": "4146125900",
            "name": "남사읍"
          },
          {
            "code": "4146134000",
            "name": "원삼면"
          },
          {
            "code": "4146135000",
            "name": "백암면"
          },
          {
            "code": "4146136000",
            "name": "양지면"
          },
          {
            "code": "4146151000",
            "name": "중앙동"
          },
          {
            "code": "4146152500",
            "name": "역북동"
          },
          {
            "code": "4146152600",
            "name": "삼가동"
          },
          {
            "code": "4146153000",
            "name": "유림동"
          },
          {
            "code": "4146154000",
            "name": "동부동"
          }
        ]
      },
      {
        "code": "41463",
        "name": "용인시 기흥구",
        "sub": [
          {
            "code": "4146351000",
            "name": "신갈동"
          },
          {
            "code": "4146351600",
            "name": "영덕1동"
          },
          {
            "code": "4146351700",
            "name": "영덕2동"
          },
          {
            "code": "4146352000",
            "name": "구갈동"
          },
          {
            "code": "4146353000",
            "name": "상갈동"
          },
          {
            "code": "4146353500",
            "name": "보라동"
          },
          {
            "code": "4146354000",
            "name": "기흥동"
          },
          {
            "code": "4146355000",
            "name": "서농동"
          },
          {
            "code": "4146356000",
            "name": "구성동"
          },
          {
            "code": "4146357000",
            "name": "마북동"
          },
          {
            "code": "4146357200",
            "name": "동백1동"
          },
          {
            "code": "4146357500",
            "name": "동백2동"
          },
          {
            "code": "4146357700",
            "name": "동백3동"
          },
          {
            "code": "4146358600",
            "name": "상하동"
          },
          {
            "code": "4146359000",
            "name": "보정동"
          }
        ]
      },
      {
        "code": "41465",
        "name": "용인시 수지구",
        "sub": [
          {
            "code": "4146551000",
            "name": "풍덕천1동"
          },
          {
            "code": "4146552000",
            "name": "풍덕천2동"
          },
          {
            "code": "4146553000",
            "name": "신봉동"
          },
          {
            "code": "4146554000",
            "name": "죽전1동"
          },
          {
            "code": "4146555000",
            "name": "죽전2동"
          },
          {
            "code": "4146555500",
            "name": "죽전3동"
          },
          {
            "code": "4146556000",
            "name": "동천동"
          },
          {
            "code": "4146557000",
            "name": "상현1동"
          },
          {
            "code": "4146558000",
            "name": "상현2동"
          },
          {
            "code": "4146558500",
            "name": "상현3동"
          },
          {
            "code": "4146559000",
            "name": "성복동"
          }
        ]
      },
      {
        "code": "41480",
        "name": "파주시",
        "sub": [
          {
            "code": "4148025000",
            "name": "문산읍"
          },
          {
            "code": "4148025300",
            "name": "파주읍"
          },
          {
            "code": "4148025600",
            "name": "법원읍"
          },
          {
            "code": "4148026200",
            "name": "조리읍"
          },
          {
            "code": "4148031000",
            "name": "월롱면"
          },
          {
            "code": "4148032000",
            "name": "탄현면"
          },
          {
            "code": "4148035000",
            "name": "광탄면"
          },
          {
            "code": "4148036000",
            "name": "파평면"
          },
          {
            "code": "4148037000",
            "name": "적성면"
          },
          {
            "code": "4148039000",
            "name": "장단면"
          },
          {
            "code": "4148051000",
            "name": "금촌1동"
          },
          {
            "code": "4148052000",
            "name": "금촌2동"
          },
          {
            "code": "4148053000",
            "name": "금촌3동"
          },
          {
            "code": "4148054000",
            "name": "교하동"
          },
          {
            "code": "4148055000",
            "name": "운정1동"
          },
          {
            "code": "4148056000",
            "name": "운정2동"
          },
          {
            "code": "4148057000",
            "name": "운정3동"
          }
        ]
      },
      {
        "code": "41500",
        "name": "이천시",
        "sub": [
          {
            "code": "4150025000",
            "name": "장호원읍"
          },
          {
            "code": "4150025300",
            "name": "부발읍"
          },
          {
            "code": "4150031000",
            "name": "신둔면"
          },
          {
            "code": "4150032000",
            "name": "백사면"
          },
          {
            "code": "4150033000",
            "name": "호법면"
          },
          {
            "code": "4150034000",
            "name": "마장면"
          },
          {
            "code": "4150035000",
            "name": "대월면"
          },
          {
            "code": "4150036000",
            "name": "모가면"
          },
          {
            "code": "4150037000",
            "name": "설성면"
          },
          {
            "code": "4150038000",
            "name": "율면"
          },
          {
            "code": "4150051000",
            "name": "창전동"
          },
          {
            "code": "4150051500",
            "name": "증포동"
          },
          {
            "code": "4150052000",
            "name": "중리동"
          },
          {
            "code": "4150053000",
            "name": "관고동"
          }
        ]
      },
      {
        "code": "41550",
        "name": "안성시",
        "sub": [
          {
            "code": "4155025000",
            "name": "공도읍"
          },
          {
            "code": "4155031000",
            "name": "보개면"
          },
          {
            "code": "4155032000",
            "name": "금광면"
          },
          {
            "code": "4155033000",
            "name": "서운면"
          },
          {
            "code": "4155034000",
            "name": "미양면"
          },
          {
            "code": "4155035000",
            "name": "대덕면"
          },
          {
            "code": "4155036000",
            "name": "양성면"
          },
          {
            "code": "4155038000",
            "name": "원곡면"
          },
          {
            "code": "4155039000",
            "name": "일죽면"
          },
          {
            "code": "4155040000",
            "name": "죽산면"
          },
          {
            "code": "4155041000",
            "name": "삼죽면"
          },
          {
            "code": "4155042000",
            "name": "고삼면"
          },
          {
            "code": "4155051000",
            "name": "안성1동"
          },
          {
            "code": "4155052000",
            "name": "안성2동"
          },
          {
            "code": "4155053000",
            "name": "안성3동"
          }
        ]
      },
      {
        "code": "41570",
        "name": "김포시",
        "sub": [
          {
            "code": "4157025000",
            "name": "통진읍"
          },
          {
            "code": "4157025300",
            "name": "고촌읍"
          },
          {
            "code": "4157025600",
            "name": "양촌읍"
          },
          {
            "code": "4157034000",
            "name": "대곶면"
          },
          {
            "code": "4157035000",
            "name": "월곶면"
          },
          {
            "code": "4157036000",
            "name": "하성면"
          },
          {
            "code": "4157051500",
            "name": "김포본동"
          },
          {
            "code": "4157052500",
            "name": "장기본동"
          },
          {
            "code": "4157054000",
            "name": "사우동"
          },
          {
            "code": "4157055000",
            "name": "풍무동"
          },
          {
            "code": "4157056000",
            "name": "장기동"
          },
          {
            "code": "4157057000",
            "name": "구래동"
          },
          {
            "code": "4157057500",
            "name": "마산동"
          },
          {
            "code": "4157058000",
            "name": "운양동"
          }
        ]
      },
      {
        "code": "41590",
        "name": "화성시",
        "sub": [
          {
            "code": "4159025300",
            "name": "봉담읍"
          },
          {
            "code": "4159025600",
            "name": "우정읍"
          },
          {
            "code": "4159025900",
            "name": "향남읍"
          },
          {
            "code": "4159026200",
            "name": "남양읍"
          },
          {
            "code": "4159031000",
            "name": "매송면"
          },
          {
            "code": "4159032000",
            "name": "비봉면"
          },
          {
            "code": "4159033000",
            "name": "마도면"
          },
          {
            "code": "4159034000",
            "name": "송산면"
          },
          {
            "code": "4159035000",
            "name": "서신면"
          },
          {
            "code": "4159036000",
            "name": "팔탄면"
          },
          {
            "code": "4159037000",
            "name": "장안면"
          },
          {
            "code": "4159040000",
            "name": "양감면"
          },
          {
            "code": "4159041000",
            "name": "정남면"
          },
          {
            "code": "4159051500",
            "name": "새솔동"
          },
          {
            "code": "4159052000",
            "name": "진안동"
          },
          {
            "code": "4159053000",
            "name": "병점1동"
          },
          {
            "code": "4159054000",
            "name": "병점2동"
          },
          {
            "code": "4159055000",
            "name": "반월동"
          },
          {
            "code": "4159056000",
            "name": "기배동"
          },
          {
            "code": "4159057000",
            "name": "화산동"
          },
          {
            "code": "4159058500",
            "name": "동탄1동"
          },
          {
            "code": "4159058600",
            "name": "동탄2동"
          },
          {
            "code": "4159058700",
            "name": "동탄3동"
          },
          {
            "code": "4159058800",
            "name": "동탄4동"
          },
          {
            "code": "4159059000",
            "name": "동탄5동"
          },
          {
            "code": "4159060000",
            "name": "동탄6동"
          },
          {
            "code": "4159061000",
            "name": "동탄7동"
          },
          {
            "code": "4159062000",
            "name": "동탄8동"
          }
        ]
      },
      {
        "code": "41610",
        "name": "광주시",
        "sub": [
          {
            "code": "4161025300",
            "name": "초월읍"
          },
          {
            "code": "4161025900",
            "name": "곤지암읍"
          },
          {
            "code": "4161033000",
            "name": "도척면"
          },
          {
            "code": "4161034000",
            "name": "퇴촌면"
          },
          {
            "code": "4161035000",
            "name": "남종면"
          },
          {
            "code": "4161037000",
            "name": "남한산성면"
          },
          {
            "code": "4161051000",
            "name": "경안동"
          },
          {
            "code": "4161052000",
            "name": "송정동"
          },
          {
            "code": "4161054000",
            "name": "쌍령동"
          },
          {
            "code": "4161055000",
            "name": "탄벌동"
          },
          {
            "code": "4161056000",
            "name": "광남1동"
          },
          {
            "code": "4161057000",
            "name": "광남2동"
          },
          {
            "code": "4161058000",
            "name": "오포1동"
          },
          {
            "code": "4161059000",
            "name": "오포2동"
          },
          {
            "code": "4161060000",
            "name": "신현동"
          },
          {
            "code": "4161061000",
            "name": "능평동"
          }
        ]
      },
      {
        "code": "41630",
        "name": "양주시",
        "sub": [
          {
            "code": "4163025000",
            "name": "백석읍"
          },
          {
            "code": "4163031000",
            "name": "은현면"
          },
          {
            "code": "4163032000",
            "name": "남면"
          },
          {
            "code": "4163033000",
            "name": "광적면"
          },
          {
            "code": "4163034000",
            "name": "장흥면"
          },
          {
            "code": "4163051000",
            "name": "양주1동"
          },
          {
            "code": "4163052000",
            "name": "양주2동"
          },
          {
            "code": "4163053000",
            "name": "회천1동"
          },
          {
            "code": "4163054000",
            "name": "회천2동"
          },
          {
            "code": "4163055000",
            "name": "회천3동"
          },
          {
            "code": "4163056000",
            "name": "회천4동"
          }
        ]
      },
      {
        "code": "41650",
        "name": "포천시",
        "sub": [
          {
            "code": "4165025000",
            "name": "소흘읍"
          },
          {
            "code": "4165031000",
            "name": "군내면"
          },
          {
            "code": "4165032000",
            "name": "내촌면"
          },
          {
            "code": "4165033000",
            "name": "가산면"
          },
          {
            "code": "4165034000",
            "name": "신북면"
          },
          {
            "code": "4165035000",
            "name": "창수면"
          },
          {
            "code": "4165036000",
            "name": "영중면"
          },
          {
            "code": "4165037000",
            "name": "일동면"
          },
          {
            "code": "4165038000",
            "name": "이동면"
          },
          {
            "code": "4165039000",
            "name": "영북면"
          },
          {
            "code": "4165040000",
            "name": "관인면"
          },
          {
            "code": "4165041000",
            "name": "화현면"
          },
          {
            "code": "4165051000",
            "name": "포천동"
          },
          {
            "code": "4165052000",
            "name": "선단동"
          }
        ]
      },
      {
        "code": "41670",
        "name": "여주시",
        "sub": [
          {
            "code": "4167025000",
            "name": "가남읍"
          },
          {
            "code": "4167031000",
            "name": "점동면"
          },
          {
            "code": "4167032000",
            "name": "흥천면"
          },
          {
            "code": "4167033000",
            "name": "금사면"
          },
          {
            "code": "4167034500",
            "name": "세종대왕면"
          },
          {
            "code": "4167035000",
            "name": "대신면"
          },
          {
            "code": "4167036000",
            "name": "북내면"
          },
          {
            "code": "4167037000",
            "name": "강천면"
          },
          {
            "code": "4167038000",
            "name": "산북면"
          },
          {
            "code": "4167051000",
            "name": "여흥동"
          },
          {
            "code": "4167052000",
            "name": "중앙동"
          },
          {
            "code": "4167053000",
            "name": "오학동"
          }
        ]
      },
      {
        "code": "41800",
        "name": "연천군",
        "sub": [
          {
            "code": "4180025000",
            "name": "연천읍"
          },
          {
            "code": "4180025300",
            "name": "전곡읍"
          },
          {
            "code": "4180031000",
            "name": "군남면"
          },
          {
            "code": "4180032000",
            "name": "청산면"
          },
          {
            "code": "4180033000",
            "name": "백학면"
          },
          {
            "code": "4180034000",
            "name": "미산면"
          },
          {
            "code": "4180035000",
            "name": "왕징면"
          },
          {
            "code": "4180036000",
            "name": "신서면"
          },
          {
            "code": "4180037000",
            "name": "중면"
          },
          {
            "code": "4180038000",
            "name": "장남면"
          }
        ]
      },
      {
        "code": "41820",
        "name": "가평군",
        "sub": [
          {
            "code": "4182025000",
            "name": "가평읍"
          },
          {
            "code": "4182031000",
            "name": "설악면"
          },
          {
            "code": "4182032500",
            "name": "청평면"
          },
          {
            "code": "4182033000",
            "name": "상면"
          },
          {
            "code": "4182034500",
            "name": "조종면"
          },
          {
            "code": "4182035000",
            "name": "북면"
          }
        ]
      },
      {
        "code": "41830",
        "name": "양평군",
        "sub": [
          {
            "code": "4183025000",
            "name": "양평읍"
          },
          {
            "code": "4183031000",
            "name": "강상면"
          },
          {
            "code": "4183032000",
            "name": "강하면"
          },
          {
            "code": "4183033000",
            "name": "양서면"
          },
          {
            "code": "4183034000",
            "name": "옥천면"
          },
          {
            "code": "4183035000",
            "name": "서종면"
          },
          {
            "code": "4183036000",
            "name": "단월면"
          },
          {
            "code": "4183037000",
            "name": "청운면"
          },
          {
            "code": "4183038000",
            "name": "양동면"
          },
          {
            "code": "4183039500",
            "name": "지평면"
          },
          {
            "code": "4183040000",
            "name": "용문면"
          },
          {
            "code": "4183041000",
            "name": "개군면"
          }
        ]
      }
    ]
  },
  {
    "code": "42",
    "name": "강원도",
    "sub": [
      {
        "code": "42110",
        "name": "춘천시",
        "sub": [
          {
            "code": "4211025000",
            "name": "신북읍"
          },
          {
            "code": "4211031000",
            "name": "동면"
          },
          {
            "code": "4211032000",
            "name": "동산면"
          },
          {
            "code": "4211033000",
            "name": "신동면"
          },
          {
            "code": "4211034000",
            "name": "남면"
          },
          {
            "code": "4211035000",
            "name": "서면"
          },
          {
            "code": "4211036000",
            "name": "사북면"
          },
          {
            "code": "4211038000",
            "name": "북산면"
          },
          {
            "code": "4211039000",
            "name": "동내면"
          },
          {
            "code": "4211040000",
            "name": "남산면"
          },
          {
            "code": "4211052000",
            "name": "교동"
          },
          {
            "code": "4211053000",
            "name": "조운동"
          },
          {
            "code": "4211054500",
            "name": "약사명동"
          },
          {
            "code": "4211057000",
            "name": "근화동"
          },
          {
            "code": "4211058000",
            "name": "소양동"
          },
          {
            "code": "4211060000",
            "name": "후평1동"
          },
          {
            "code": "4211061000",
            "name": "후평2동"
          },
          {
            "code": "4211061100",
            "name": "후평3동"
          },
          {
            "code": "4211062000",
            "name": "효자1동"
          },
          {
            "code": "4211063000",
            "name": "효자2동"
          },
          {
            "code": "4211064000",
            "name": "효자3동"
          },
          {
            "code": "4211065000",
            "name": "석사동"
          },
          {
            "code": "4211066000",
            "name": "퇴계동"
          },
          {
            "code": "4211067500",
            "name": "강남동"
          },
          {
            "code": "4211070500",
            "name": "신사우동"
          }
        ]
      },
      {
        "code": "42130",
        "name": "원주시",
        "sub": [
          {
            "code": "4213025000",
            "name": "문막읍"
          },
          {
            "code": "4213031000",
            "name": "소초면"
          },
          {
            "code": "4213032000",
            "name": "호저면"
          },
          {
            "code": "4213033000",
            "name": "지정면"
          },
          {
            "code": "4213035000",
            "name": "부론면"
          },
          {
            "code": "4213036000",
            "name": "귀래면"
          },
          {
            "code": "4213037000",
            "name": "흥업면"
          },
          {
            "code": "4213038000",
            "name": "판부면"
          },
          {
            "code": "4213039000",
            "name": "신림면"
          },
          {
            "code": "4213051500",
            "name": "중앙동"
          },
          {
            "code": "4213052000",
            "name": "원인동"
          },
          {
            "code": "4213053000",
            "name": "개운동"
          },
          {
            "code": "4213054100",
            "name": "명륜1동"
          },
          {
            "code": "4213054200",
            "name": "명륜2동"
          },
          {
            "code": "4213055000",
            "name": "단구동"
          },
          {
            "code": "4213056000",
            "name": "일산동"
          },
          {
            "code": "4213057500",
            "name": "학성동"
          },
          {
            "code": "4213059000",
            "name": "단계동"
          },
          {
            "code": "4213060000",
            "name": "우산동"
          },
          {
            "code": "4213061000",
            "name": "태장1동"
          },
          {
            "code": "4213062000",
            "name": "태장2동"
          },
          {
            "code": "4213063500",
            "name": "봉산동"
          },
          {
            "code": "4213065000",
            "name": "행구동"
          },
          {
            "code": "4213066000",
            "name": "무실동"
          },
          {
            "code": "4213067500",
            "name": "반곡관설동"
          }
        ]
      },
      {
        "code": "42150",
        "name": "강릉시",
        "sub": [
          {
            "code": "4215025000",
            "name": "주문진읍"
          },
          {
            "code": "4215031000",
            "name": "성산면"
          },
          {
            "code": "4215032000",
            "name": "왕산면"
          },
          {
            "code": "4215033000",
            "name": "구정면"
          },
          {
            "code": "4215034000",
            "name": "강동면"
          },
          {
            "code": "4215035000",
            "name": "옥계면"
          },
          {
            "code": "4215036000",
            "name": "사천면"
          },
          {
            "code": "4215037000",
            "name": "연곡면"
          },
          {
            "code": "4215051000",
            "name": "홍제동"
          },
          {
            "code": "4215052000",
            "name": "중앙동"
          },
          {
            "code": "4215054000",
            "name": "옥천동"
          },
          {
            "code": "4215055000",
            "name": "교1동"
          },
          {
            "code": "4215056000",
            "name": "교2동"
          },
          {
            "code": "4215057100",
            "name": "포남1동"
          },
          {
            "code": "4215057200",
            "name": "포남2동"
          },
          {
            "code": "4215058000",
            "name": "초당동"
          },
          {
            "code": "4215059000",
            "name": "송정동"
          },
          {
            "code": "4215060000",
            "name": "내곡동"
          },
          {
            "code": "4215061500",
            "name": "강남동"
          },
          {
            "code": "4215064500",
            "name": "성덕동"
          },
          {
            "code": "4215066500",
            "name": "경포동"
          }
        ]
      },
      {
        "code": "42170",
        "name": "동해시",
        "sub": [
          {
            "code": "4217051000",
            "name": "천곡동"
          },
          {
            "code": "4217052000",
            "name": "송정동"
          },
          {
            "code": "4217053000",
            "name": "북삼동"
          },
          {
            "code": "4217054000",
            "name": "부곡동"
          },
          {
            "code": "4217055000",
            "name": "동호동"
          },
          {
            "code": "4217057000",
            "name": "발한동"
          },
          {
            "code": "4217059000",
            "name": "묵호동"
          },
          {
            "code": "4217060000",
            "name": "북평동"
          },
          {
            "code": "4217063000",
            "name": "망상동"
          },
          {
            "code": "4217065000",
            "name": "삼화동"
          }
        ]
      },
      {
        "code": "42190",
        "name": "태백시",
        "sub": [
          {
            "code": "4219051500",
            "name": "황지동"
          },
          {
            "code": "4219052500",
            "name": "황연동"
          },
          {
            "code": "4219053500",
            "name": "삼수동"
          },
          {
            "code": "4219054000",
            "name": "상장동"
          },
          {
            "code": "4219058500",
            "name": "문곡소도동"
          },
          {
            "code": "4219059500",
            "name": "장성동"
          },
          {
            "code": "4219060500",
            "name": "구문소동"
          },
          {
            "code": "4219061500",
            "name": "철암동"
          }
        ]
      },
      {
        "code": "42210",
        "name": "속초시",
        "sub": [
          {
            "code": "4221051000",
            "name": "영랑동"
          },
          {
            "code": "4221052000",
            "name": "동명동"
          },
          {
            "code": "4221054000",
            "name": "금호동"
          },
          {
            "code": "4221056000",
            "name": "교동"
          },
          {
            "code": "4221057000",
            "name": "노학동"
          },
          {
            "code": "4221058000",
            "name": "조양동"
          },
          {
            "code": "4221059000",
            "name": "청호동"
          },
          {
            "code": "4221060000",
            "name": "대포동"
          }
        ]
      },
      {
        "code": "42230",
        "name": "삼척시",
        "sub": [
          {
            "code": "4223025000",
            "name": "도계읍"
          },
          {
            "code": "4223025300",
            "name": "원덕읍"
          },
          {
            "code": "4223025400",
            "name": "원덕읍임원출장소"
          },
          {
            "code": "4223031000",
            "name": "근덕면"
          },
          {
            "code": "4223032000",
            "name": "하장면"
          },
          {
            "code": "4223033000",
            "name": "노곡면"
          },
          {
            "code": "4223034000",
            "name": "미로면"
          },
          {
            "code": "4223035000",
            "name": "가곡면"
          },
          {
            "code": "4223036000",
            "name": "신기면"
          },
          {
            "code": "4223051000",
            "name": "남양동"
          },
          {
            "code": "4223053000",
            "name": "교동"
          },
          {
            "code": "4223054000",
            "name": "정라동"
          },
          {
            "code": "4223057000",
            "name": "성내동"
          }
        ]
      },
      {
        "code": "42720",
        "name": "홍천군",
        "sub": [
          {
            "code": "4272025000",
            "name": "홍천읍"
          },
          {
            "code": "4272031000",
            "name": "화촌면"
          },
          {
            "code": "4272032000",
            "name": "두촌면"
          },
          {
            "code": "4272033000",
            "name": "내촌면"
          },
          {
            "code": "4272034000",
            "name": "서석면"
          },
          {
            "code": "4272035200",
            "name": "영귀미면"
          },
          {
            "code": "4272036000",
            "name": "남면"
          },
          {
            "code": "4272037000",
            "name": "서면"
          },
          {
            "code": "4272038000",
            "name": "북방면"
          },
          {
            "code": "4272039000",
            "name": "내면"
          }
        ]
      },
      {
        "code": "42730",
        "name": "횡성군",
        "sub": [
          {
            "code": "4273025000",
            "name": "횡성읍"
          },
          {
            "code": "4273031000",
            "name": "우천면"
          },
          {
            "code": "4273032000",
            "name": "안흥면"
          },
          {
            "code": "4273033000",
            "name": "둔내면"
          },
          {
            "code": "4273034000",
            "name": "갑천면"
          },
          {
            "code": "4273035000",
            "name": "청일면"
          },
          {
            "code": "4273036000",
            "name": "공근면"
          },
          {
            "code": "4273037000",
            "name": "서원면"
          },
          {
            "code": "4273038000",
            "name": "강림면"
          }
        ]
      },
      {
        "code": "42750",
        "name": "영월군",
        "sub": [
          {
            "code": "4275025000",
            "name": "영월읍"
          },
          {
            "code": "4275025300",
            "name": "상동읍"
          },
          {
            "code": "4275031200",
            "name": "산솔면"
          },
          {
            "code": "4275032500",
            "name": "김삿갓면"
          },
          {
            "code": "4275033000",
            "name": "북면"
          },
          {
            "code": "4275034000",
            "name": "남면"
          },
          {
            "code": "4275035500",
            "name": "한반도면"
          },
          {
            "code": "4275035900",
            "name": "한반도면쌍용출장소"
          },
          {
            "code": "4275036000",
            "name": "주천면"
          },
          {
            "code": "4275038000",
            "name": "무릉도원면"
          }
        ]
      },
      {
        "code": "42760",
        "name": "평창군",
        "sub": [
          {
            "code": "4276025000",
            "name": "평창읍"
          },
          {
            "code": "4276031000",
            "name": "미탄면"
          },
          {
            "code": "4276032000",
            "name": "방림면"
          },
          {
            "code": "4276032500",
            "name": "방림면계촌출장소"
          },
          {
            "code": "4276033000",
            "name": "대화면"
          },
          {
            "code": "4276034000",
            "name": "봉평면"
          },
          {
            "code": "4276035000",
            "name": "용평면"
          },
          {
            "code": "4276036000",
            "name": "진부면"
          },
          {
            "code": "4276038000",
            "name": "대관령면"
          }
        ]
      },
      {
        "code": "42770",
        "name": "정선군",
        "sub": [
          {
            "code": "4277025000",
            "name": "정선읍"
          },
          {
            "code": "4277025300",
            "name": "고한읍"
          },
          {
            "code": "4277025600",
            "name": "사북읍"
          },
          {
            "code": "4277025900",
            "name": "신동읍"
          },
          {
            "code": "4277026000",
            "name": "신동읍함백출장소"
          },
          {
            "code": "4277032000",
            "name": "남면"
          },
          {
            "code": "4277034000",
            "name": "북평면"
          },
          {
            "code": "4277035000",
            "name": "임계면"
          },
          {
            "code": "4277036000",
            "name": "화암면"
          },
          {
            "code": "4277037000",
            "name": "여량면"
          }
        ]
      },
      {
        "code": "42780",
        "name": "철원군",
        "sub": [
          {
            "code": "4278025000",
            "name": "철원읍"
          },
          {
            "code": "4278025300",
            "name": "김화읍"
          },
          {
            "code": "4278025600",
            "name": "갈말읍"
          },
          {
            "code": "4278025900",
            "name": "동송읍"
          },
          {
            "code": "4278031000",
            "name": "서면"
          },
          {
            "code": "4278031500",
            "name": "서면와수출장소"
          },
          {
            "code": "4278032000",
            "name": "근남면"
          },
          {
            "code": "4278033000",
            "name": "근북면"
          },
          {
            "code": "4278034000",
            "name": "근동면"
          },
          {
            "code": "4278035000",
            "name": "원동면"
          },
          {
            "code": "4278036000",
            "name": "원남면"
          },
          {
            "code": "4278037000",
            "name": "임남면"
          }
        ]
      },
      {
        "code": "42790",
        "name": "화천군",
        "sub": [
          {
            "code": "4279025000",
            "name": "화천읍"
          },
          {
            "code": "4279031000",
            "name": "간동면"
          },
          {
            "code": "4279032000",
            "name": "하남면"
          },
          {
            "code": "4279033000",
            "name": "상서면"
          },
          {
            "code": "4279034000",
            "name": "사내면"
          }
        ]
      },
      {
        "code": "42800",
        "name": "양구군",
        "sub": [
          {
            "code": "4280025000",
            "name": "양구읍"
          },
          {
            "code": "4280031500",
            "name": "국토정중앙면"
          },
          {
            "code": "4280032000",
            "name": "동면"
          },
          {
            "code": "4280033000",
            "name": "방산면"
          },
          {
            "code": "4280034000",
            "name": "해안면"
          }
        ]
      },
      {
        "code": "42810",
        "name": "인제군",
        "sub": [
          {
            "code": "4281025000",
            "name": "인제읍"
          },
          {
            "code": "4281025100",
            "name": "인제읍귀둔출장소"
          },
          {
            "code": "4281031000",
            "name": "남면"
          },
          {
            "code": "4281032000",
            "name": "북면"
          },
          {
            "code": "4281033000",
            "name": "기린면"
          },
          {
            "code": "4281034000",
            "name": "서화면"
          },
          {
            "code": "4281035000",
            "name": "상남면"
          }
        ]
      },
      {
        "code": "42820",
        "name": "고성군",
        "sub": [
          {
            "code": "4282025000",
            "name": "간성읍"
          },
          {
            "code": "4282025300",
            "name": "거진읍"
          },
          {
            "code": "4282031000",
            "name": "현내면"
          },
          {
            "code": "4282032000",
            "name": "죽왕면"
          },
          {
            "code": "4282033000",
            "name": "토성면"
          },
          {
            "code": "4282034000",
            "name": "수동면"
          }
        ]
      },
      {
        "code": "42830",
        "name": "양양군",
        "sub": [
          {
            "code": "4283025000",
            "name": "양양읍"
          },
          {
            "code": "4283031000",
            "name": "서면"
          },
          {
            "code": "4283032000",
            "name": "손양면"
          },
          {
            "code": "4283033000",
            "name": "현북면"
          },
          {
            "code": "4283034000",
            "name": "현남면"
          },
          {
            "code": "4283035000",
            "name": "강현면"
          }
        ]
      }
    ]
  },
  {
    "code": "43",
    "name": "충청북도",
    "sub": [
      {
        "code": "43111",
        "name": "청주시 상당구",
        "sub": [
          {
            "code": "4311131000",
            "name": "낭성면"
          },
          {
            "code": "4311132000",
            "name": "미원면"
          },
          {
            "code": "4311133000",
            "name": "가덕면"
          },
          {
            "code": "4311134000",
            "name": "남일면"
          },
          {
            "code": "4311135000",
            "name": "문의면"
          },
          {
            "code": "4311152500",
            "name": "중앙동"
          },
          {
            "code": "4311154500",
            "name": "성안동"
          },
          {
            "code": "4311162000",
            "name": "탑대성동"
          },
          {
            "code": "4311167000",
            "name": "영운동"
          },
          {
            "code": "4311168000",
            "name": "금천동"
          },
          {
            "code": "4311169000",
            "name": "용담.명암.산성동"
          },
          {
            "code": "4311172000",
            "name": "용암1동"
          },
          {
            "code": "4311173000",
            "name": "용암2동"
          }
        ]
      },
      {
        "code": "43112",
        "name": "청주시 서원구",
        "sub": [
          {
            "code": "4311231000",
            "name": "남이면"
          },
          {
            "code": "4311232000",
            "name": "현도면"
          },
          {
            "code": "4311251000",
            "name": "사직1동"
          },
          {
            "code": "4311252000",
            "name": "사직2동"
          },
          {
            "code": "4311253000",
            "name": "사창동"
          },
          {
            "code": "4311254000",
            "name": "모충동"
          },
          {
            "code": "4311255000",
            "name": "산남동"
          },
          {
            "code": "4311256000",
            "name": "분평동"
          },
          {
            "code": "4311257000",
            "name": "수곡1동"
          },
          {
            "code": "4311258000",
            "name": "수곡2동"
          },
          {
            "code": "4311259000",
            "name": "성화.개신.죽림동"
          }
        ]
      },
      {
        "code": "43113",
        "name": "청주시 흥덕구",
        "sub": [
          {
            "code": "4311325000",
            "name": "오송읍"
          },
          {
            "code": "4311331000",
            "name": "강내면"
          },
          {
            "code": "4311332000",
            "name": "옥산면"
          },
          {
            "code": "4311370000",
            "name": "운천.신봉동"
          },
          {
            "code": "4311374100",
            "name": "복대1동"
          },
          {
            "code": "4311374200",
            "name": "복대2동"
          },
          {
            "code": "4311374700",
            "name": "가경동"
          },
          {
            "code": "4311375100",
            "name": "봉명1동"
          },
          {
            "code": "4311375600",
            "name": "봉명2.송정동"
          },
          {
            "code": "4311376000",
            "name": "강서제1동"
          },
          {
            "code": "4311377000",
            "name": "강서제2동"
          }
        ]
      },
      {
        "code": "43114",
        "name": "청주시 청원구",
        "sub": [
          {
            "code": "4311425000",
            "name": "내수읍"
          },
          {
            "code": "4311425300",
            "name": "오창읍"
          },
          {
            "code": "4311431000",
            "name": "북이면"
          },
          {
            "code": "4311451000",
            "name": "우암동"
          },
          {
            "code": "4311452000",
            "name": "내덕1동"
          },
          {
            "code": "4311453000",
            "name": "내덕2동"
          },
          {
            "code": "4311454000",
            "name": "율량.사천동"
          },
          {
            "code": "4311455000",
            "name": "오근장동"
          }
        ]
      },
      {
        "code": "43130",
        "name": "충주시",
        "sub": [
          {
            "code": "4313025000",
            "name": "주덕읍"
          },
          {
            "code": "4313031000",
            "name": "살미면"
          },
          {
            "code": "4313032500",
            "name": "수안보면"
          },
          {
            "code": "4313033500",
            "name": "대소원면"
          },
          {
            "code": "4313035000",
            "name": "신니면"
          },
          {
            "code": "4313036000",
            "name": "노은면"
          },
          {
            "code": "4313037000",
            "name": "앙성면"
          },
          {
            "code": "4313038500",
            "name": "중앙탑면"
          },
          {
            "code": "4313039000",
            "name": "금가면"
          },
          {
            "code": "4313040000",
            "name": "동량면"
          },
          {
            "code": "4313041000",
            "name": "산척면"
          },
          {
            "code": "4313042000",
            "name": "엄정면"
          },
          {
            "code": "4313043000",
            "name": "소태면"
          },
          {
            "code": "4313051500",
            "name": "성내.충인동"
          },
          {
            "code": "4313053500",
            "name": "교현.안림동"
          },
          {
            "code": "4313054000",
            "name": "교현2동"
          },
          {
            "code": "4313055000",
            "name": "용산동"
          },
          {
            "code": "4313056000",
            "name": "지현동"
          },
          {
            "code": "4313057100",
            "name": "문화동"
          },
          {
            "code": "4313058000",
            "name": "호암.직동"
          },
          {
            "code": "4313060500",
            "name": "달천동"
          },
          {
            "code": "4313061000",
            "name": "봉방동"
          },
          {
            "code": "4313062500",
            "name": "칠금.금릉동"
          },
          {
            "code": "4313063000",
            "name": "연수동"
          },
          {
            "code": "4313064000",
            "name": "목행.용탄동"
          }
        ]
      },
      {
        "code": "43150",
        "name": "제천시",
        "sub": [
          {
            "code": "4315025000",
            "name": "봉양읍"
          },
          {
            "code": "4315031000",
            "name": "금성면"
          },
          {
            "code": "4315032000",
            "name": "청풍면"
          },
          {
            "code": "4315033000",
            "name": "수산면"
          },
          {
            "code": "4315034000",
            "name": "덕산면"
          },
          {
            "code": "4315035000",
            "name": "한수면"
          },
          {
            "code": "4315036000",
            "name": "백운면"
          },
          {
            "code": "4315038000",
            "name": "송학면"
          },
          {
            "code": "4315051000",
            "name": "교동"
          },
          {
            "code": "4315051800",
            "name": "의림지동"
          },
          {
            "code": "4315052800",
            "name": "중앙동"
          },
          {
            "code": "4315053700",
            "name": "남현동"
          },
          {
            "code": "4315054700",
            "name": "영서동"
          },
          {
            "code": "4315056000",
            "name": "용두동"
          },
          {
            "code": "4315057700",
            "name": "신백동"
          },
          {
            "code": "4315059000",
            "name": "청전동"
          },
          {
            "code": "4315060500",
            "name": "화산동"
          }
        ]
      },
      {
        "code": "43720",
        "name": "보은군",
        "sub": [
          {
            "code": "4372025000",
            "name": "보은읍"
          },
          {
            "code": "4372031500",
            "name": "속리산면"
          },
          {
            "code": "4372032500",
            "name": "장안면"
          },
          {
            "code": "4372033000",
            "name": "마로면"
          },
          {
            "code": "4372034000",
            "name": "탄부면"
          },
          {
            "code": "4372035000",
            "name": "삼승면"
          },
          {
            "code": "4372036000",
            "name": "수한면"
          },
          {
            "code": "4372037000",
            "name": "회남면"
          },
          {
            "code": "4372038500",
            "name": "회인면"
          },
          {
            "code": "4372039000",
            "name": "내북면"
          },
          {
            "code": "4372040000",
            "name": "산외면"
          }
        ]
      },
      {
        "code": "43730",
        "name": "옥천군",
        "sub": [
          {
            "code": "4373025000",
            "name": "옥천읍"
          },
          {
            "code": "4373031000",
            "name": "동이면"
          },
          {
            "code": "4373032000",
            "name": "안남면"
          },
          {
            "code": "4373033000",
            "name": "안내면"
          },
          {
            "code": "4373034000",
            "name": "청성면"
          },
          {
            "code": "4373035000",
            "name": "청산면"
          },
          {
            "code": "4373036000",
            "name": "이원면"
          },
          {
            "code": "4373037000",
            "name": "군서면"
          },
          {
            "code": "4373038000",
            "name": "군북면"
          }
        ]
      },
      {
        "code": "43740",
        "name": "영동군",
        "sub": [
          {
            "code": "4374025000",
            "name": "영동읍"
          },
          {
            "code": "4374031000",
            "name": "용산면"
          },
          {
            "code": "4374032000",
            "name": "황간면"
          },
          {
            "code": "4374033500",
            "name": "추풍령면"
          },
          {
            "code": "4374034000",
            "name": "매곡면"
          },
          {
            "code": "4374035000",
            "name": "상촌면"
          },
          {
            "code": "4374036000",
            "name": "양강면"
          },
          {
            "code": "4374037000",
            "name": "용화면"
          },
          {
            "code": "4374038000",
            "name": "학산면"
          },
          {
            "code": "4374039000",
            "name": "양산면"
          },
          {
            "code": "4374040000",
            "name": "심천면"
          }
        ]
      },
      {
        "code": "43745",
        "name": "증평군",
        "sub": [
          {
            "code": "4374525000",
            "name": "증평읍"
          },
          {
            "code": "4374531000",
            "name": "도안면"
          }
        ]
      },
      {
        "code": "43750",
        "name": "진천군",
        "sub": [
          {
            "code": "4375025000",
            "name": "진천읍"
          },
          {
            "code": "4375025300",
            "name": "덕산읍"
          },
          {
            "code": "4375025400",
            "name": "덕산읍혁신도시출장소"
          },
          {
            "code": "4375032000",
            "name": "초평면"
          },
          {
            "code": "4375033000",
            "name": "문백면"
          },
          {
            "code": "4375034000",
            "name": "백곡면"
          },
          {
            "code": "4375035000",
            "name": "이월면"
          },
          {
            "code": "4375037000",
            "name": "광혜원면"
          }
        ]
      },
      {
        "code": "43760",
        "name": "괴산군",
        "sub": [
          {
            "code": "4376025000",
            "name": "괴산읍"
          },
          {
            "code": "4376031000",
            "name": "감물면"
          },
          {
            "code": "4376032000",
            "name": "장연면"
          },
          {
            "code": "4376033000",
            "name": "연풍면"
          },
          {
            "code": "4376034000",
            "name": "칠성면"
          },
          {
            "code": "4376035000",
            "name": "문광면"
          },
          {
            "code": "4376036000",
            "name": "청천면"
          },
          {
            "code": "4376037000",
            "name": "청안면"
          },
          {
            "code": "4376039000",
            "name": "사리면"
          },
          {
            "code": "4376040000",
            "name": "소수면"
          },
          {
            "code": "4376041000",
            "name": "불정면"
          }
        ]
      },
      {
        "code": "43770",
        "name": "음성군",
        "sub": [
          {
            "code": "4377025000",
            "name": "음성읍"
          },
          {
            "code": "4377025300",
            "name": "금왕읍"
          },
          {
            "code": "4377031000",
            "name": "소이면"
          },
          {
            "code": "4377032000",
            "name": "원남면"
          },
          {
            "code": "4377033000",
            "name": "맹동면"
          },
          {
            "code": "4377034000",
            "name": "대소면"
          },
          {
            "code": "4377035000",
            "name": "삼성면"
          },
          {
            "code": "4377036000",
            "name": "생극면"
          },
          {
            "code": "4377037000",
            "name": "감곡면"
          }
        ]
      },
      {
        "code": "43800",
        "name": "단양군",
        "sub": [
          {
            "code": "4380025000",
            "name": "단양읍"
          },
          {
            "code": "4380025300",
            "name": "매포읍"
          },
          {
            "code": "4380031000",
            "name": "대강면"
          },
          {
            "code": "4380032000",
            "name": "가곡면"
          },
          {
            "code": "4380033000",
            "name": "영춘면"
          },
          {
            "code": "4380034000",
            "name": "어상천면"
          },
          {
            "code": "4380035000",
            "name": "적성면"
          },
          {
            "code": "4380036000",
            "name": "단성면"
          }
        ]
      }
    ]
  },
  {
    "code": "44",
    "name": "충청남도",
    "sub": [
      {
        "code": "44131",
        "name": "천안시 동남구",
        "sub": [
          {
            "code": "4413125000",
            "name": "목천읍"
          },
          {
            "code": "4413131000",
            "name": "풍세면"
          },
          {
            "code": "4413132000",
            "name": "광덕면"
          },
          {
            "code": "4413133000",
            "name": "북면"
          },
          {
            "code": "4413134000",
            "name": "성남면"
          },
          {
            "code": "4413135000",
            "name": "수신면"
          },
          {
            "code": "4413136000",
            "name": "병천면"
          },
          {
            "code": "4413137000",
            "name": "동면"
          },
          {
            "code": "4413151000",
            "name": "중앙동"
          },
          {
            "code": "4413152000",
            "name": "문성동"
          },
          {
            "code": "4413153000",
            "name": "원성1동"
          },
          {
            "code": "4413154000",
            "name": "원성2동"
          },
          {
            "code": "4413155000",
            "name": "봉명동"
          },
          {
            "code": "4413156000",
            "name": "일봉동"
          },
          {
            "code": "4413157000",
            "name": "신방동"
          },
          {
            "code": "4413158000",
            "name": "청룡동"
          },
          {
            "code": "4413159000",
            "name": "신안동"
          }
        ]
      },
      {
        "code": "44133",
        "name": "천안시 서북구",
        "sub": [
          {
            "code": "4413325000",
            "name": "성환읍"
          },
          {
            "code": "4413325300",
            "name": "성거읍"
          },
          {
            "code": "4413325600",
            "name": "직산읍"
          },
          {
            "code": "4413331000",
            "name": "입장면"
          },
          {
            "code": "4413351000",
            "name": "성정1동"
          },
          {
            "code": "4413352000",
            "name": "성정2동"
          },
          {
            "code": "4413353000",
            "name": "쌍용1동"
          },
          {
            "code": "4413354000",
            "name": "쌍용2동"
          },
          {
            "code": "4413355000",
            "name": "쌍용3동"
          },
          {
            "code": "4413356000",
            "name": "백석동"
          },
          {
            "code": "4413356600",
            "name": "불당1동"
          },
          {
            "code": "4413356700",
            "name": "불당2동"
          },
          {
            "code": "4413358000",
            "name": "부성1동"
          },
          {
            "code": "4413359000",
            "name": "부성2동"
          }
        ]
      },
      {
        "code": "44150",
        "name": "공주시",
        "sub": [
          {
            "code": "4415025000",
            "name": "유구읍"
          },
          {
            "code": "4415031000",
            "name": "이인면"
          },
          {
            "code": "4415032000",
            "name": "탄천면"
          },
          {
            "code": "4415033000",
            "name": "계룡면"
          },
          {
            "code": "4415034000",
            "name": "반포면"
          },
          {
            "code": "4415036000",
            "name": "의당면"
          },
          {
            "code": "4415037000",
            "name": "정안면"
          },
          {
            "code": "4415038000",
            "name": "우성면"
          },
          {
            "code": "4415039000",
            "name": "사곡면"
          },
          {
            "code": "4415040000",
            "name": "신풍면"
          },
          {
            "code": "4415051000",
            "name": "중학동"
          },
          {
            "code": "4415054000",
            "name": "웅진동"
          },
          {
            "code": "4415055000",
            "name": "금학동"
          },
          {
            "code": "4415056000",
            "name": "옥룡동"
          },
          {
            "code": "4415057000",
            "name": "신관동"
          },
          {
            "code": "4415059000",
            "name": "월송동"
          }
        ]
      },
      {
        "code": "44180",
        "name": "보령시",
        "sub": [
          {
            "code": "4418025000",
            "name": "웅천읍"
          },
          {
            "code": "4418031000",
            "name": "주포면"
          },
          {
            "code": "4418032000",
            "name": "오천면"
          },
          {
            "code": "4418032500",
            "name": "오천면어항출장소"
          },
          {
            "code": "4418032800",
            "name": "원산도출장소"
          },
          {
            "code": "4418033000",
            "name": "천북면"
          },
          {
            "code": "4418034000",
            "name": "청소면"
          },
          {
            "code": "4418035000",
            "name": "청라면"
          },
          {
            "code": "4418036000",
            "name": "남포면"
          },
          {
            "code": "4418038000",
            "name": "주산면"
          },
          {
            "code": "4418039000",
            "name": "미산면"
          },
          {
            "code": "4418040000",
            "name": "성주면"
          },
          {
            "code": "4418041000",
            "name": "주교면"
          },
          {
            "code": "4418051500",
            "name": "대천1동"
          },
          {
            "code": "4418052500",
            "name": "대천2동"
          },
          {
            "code": "4418053500",
            "name": "대천3동"
          },
          {
            "code": "4418054500",
            "name": "대천4동"
          },
          {
            "code": "4418056500",
            "name": "대천5동"
          }
        ]
      },
      {
        "code": "44200",
        "name": "아산시",
        "sub": [
          {
            "code": "4420025000",
            "name": "염치읍"
          },
          {
            "code": "4420025300",
            "name": "배방읍"
          },
          {
            "code": "4420031000",
            "name": "송악면"
          },
          {
            "code": "4420033000",
            "name": "탕정면"
          },
          {
            "code": "4420035000",
            "name": "음봉면"
          },
          {
            "code": "4420036000",
            "name": "둔포면"
          },
          {
            "code": "4420037000",
            "name": "영인면"
          },
          {
            "code": "4420038000",
            "name": "인주면"
          },
          {
            "code": "4420039000",
            "name": "선장면"
          },
          {
            "code": "4420040000",
            "name": "도고면"
          },
          {
            "code": "4420041000",
            "name": "신창면"
          },
          {
            "code": "4420057000",
            "name": "온양1동"
          },
          {
            "code": "4420058000",
            "name": "온양2동"
          },
          {
            "code": "4420059000",
            "name": "온양3동"
          },
          {
            "code": "4420060000",
            "name": "온양4동"
          },
          {
            "code": "4420061000",
            "name": "온양5동"
          },
          {
            "code": "4420062000",
            "name": "온양6동"
          }
        ]
      },
      {
        "code": "44210",
        "name": "서산시",
        "sub": [
          {
            "code": "4421025000",
            "name": "대산읍"
          },
          {
            "code": "4421031000",
            "name": "인지면"
          },
          {
            "code": "4421032000",
            "name": "부석면"
          },
          {
            "code": "4421033000",
            "name": "팔봉면"
          },
          {
            "code": "4421034000",
            "name": "지곡면"
          },
          {
            "code": "4421036000",
            "name": "성연면"
          },
          {
            "code": "4421037000",
            "name": "음암면"
          },
          {
            "code": "4421038000",
            "name": "운산면"
          },
          {
            "code": "4421039000",
            "name": "해미면"
          },
          {
            "code": "4421040000",
            "name": "고북면"
          },
          {
            "code": "4421051000",
            "name": "부춘동"
          },
          {
            "code": "4421052500",
            "name": "동문1동"
          },
          {
            "code": "4421053500",
            "name": "동문2동"
          },
          {
            "code": "4421054000",
            "name": "수석동"
          },
          {
            "code": "4421055000",
            "name": "석남동"
          }
        ]
      },
      {
        "code": "44230",
        "name": "논산시",
        "sub": [
          {
            "code": "4423025000",
            "name": "강경읍"
          },
          {
            "code": "4423025300",
            "name": "연무읍"
          },
          {
            "code": "4423031000",
            "name": "성동면"
          },
          {
            "code": "4423032000",
            "name": "광석면"
          },
          {
            "code": "4423033000",
            "name": "노성면"
          },
          {
            "code": "4423034000",
            "name": "상월면"
          },
          {
            "code": "4423035000",
            "name": "부적면"
          },
          {
            "code": "4423036000",
            "name": "연산면"
          },
          {
            "code": "4423038000",
            "name": "벌곡면"
          },
          {
            "code": "4423039000",
            "name": "양촌면"
          },
          {
            "code": "4423040000",
            "name": "가야곡면"
          },
          {
            "code": "4423041000",
            "name": "은진면"
          },
          {
            "code": "4423042000",
            "name": "채운면"
          },
          {
            "code": "4423051000",
            "name": "취암동"
          },
          {
            "code": "4423052000",
            "name": "부창동"
          }
        ]
      },
      {
        "code": "44250",
        "name": "계룡시",
        "sub": [
          {
            "code": "4425031000",
            "name": "두마면"
          },
          {
            "code": "4425031500",
            "name": "엄사면"
          },
          {
            "code": "4425033000",
            "name": "신도안면"
          },
          {
            "code": "4425051000",
            "name": "금암동"
          }
        ]
      },
      {
        "code": "44270",
        "name": "당진시",
        "sub": [
          {
            "code": "4427025000",
            "name": "합덕읍"
          },
          {
            "code": "4427025300",
            "name": "송악읍"
          },
          {
            "code": "4427031000",
            "name": "고대면"
          },
          {
            "code": "4427032000",
            "name": "석문면"
          },
          {
            "code": "4427033000",
            "name": "대호지면"
          },
          {
            "code": "4427034000",
            "name": "정미면"
          },
          {
            "code": "4427035000",
            "name": "면천면"
          },
          {
            "code": "4427036000",
            "name": "순성면"
          },
          {
            "code": "4427037000",
            "name": "우강면"
          },
          {
            "code": "4427038000",
            "name": "신평면"
          },
          {
            "code": "4427039000",
            "name": "송산면"
          },
          {
            "code": "4427051000",
            "name": "당진1동"
          },
          {
            "code": "4427052000",
            "name": "당진2동"
          },
          {
            "code": "4427053000",
            "name": "당진3동"
          }
        ]
      },
      {
        "code": "44710",
        "name": "금산군",
        "sub": [
          {
            "code": "4471025000",
            "name": "금산읍"
          },
          {
            "code": "4471031000",
            "name": "금성면"
          },
          {
            "code": "4471032000",
            "name": "제원면"
          },
          {
            "code": "4471033000",
            "name": "부리면"
          },
          {
            "code": "4471034000",
            "name": "군북면"
          },
          {
            "code": "4471035000",
            "name": "남일면"
          },
          {
            "code": "4471036000",
            "name": "남이면"
          },
          {
            "code": "4471037000",
            "name": "진산면"
          },
          {
            "code": "4471038000",
            "name": "복수면"
          },
          {
            "code": "4471039000",
            "name": "추부면"
          }
        ]
      },
      {
        "code": "44760",
        "name": "부여군",
        "sub": [
          {
            "code": "4476025000",
            "name": "부여읍"
          },
          {
            "code": "4476031000",
            "name": "규암면"
          },
          {
            "code": "4476032000",
            "name": "은산면"
          },
          {
            "code": "4476033000",
            "name": "외산면"
          },
          {
            "code": "4476034000",
            "name": "내산면"
          },
          {
            "code": "4476035000",
            "name": "구룡면"
          },
          {
            "code": "4476036000",
            "name": "홍산면"
          },
          {
            "code": "4476037000",
            "name": "옥산면"
          },
          {
            "code": "4476038000",
            "name": "남면"
          },
          {
            "code": "4476039000",
            "name": "충화면"
          },
          {
            "code": "4476040000",
            "name": "양화면"
          },
          {
            "code": "4476041000",
            "name": "임천면"
          },
          {
            "code": "4476042000",
            "name": "장암면"
          },
          {
            "code": "4476043000",
            "name": "세도면"
          },
          {
            "code": "4476044000",
            "name": "석성면"
          },
          {
            "code": "4476045000",
            "name": "초촌면"
          }
        ]
      },
      {
        "code": "44770",
        "name": "서천군",
        "sub": [
          {
            "code": "4477025000",
            "name": "장항읍"
          },
          {
            "code": "4477025300",
            "name": "서천읍"
          },
          {
            "code": "4477031000",
            "name": "마서면"
          },
          {
            "code": "4477032000",
            "name": "화양면"
          },
          {
            "code": "4477033000",
            "name": "기산면"
          },
          {
            "code": "4477034000",
            "name": "한산면"
          },
          {
            "code": "4477035000",
            "name": "마산면"
          },
          {
            "code": "4477036000",
            "name": "시초면"
          },
          {
            "code": "4477037000",
            "name": "문산면"
          },
          {
            "code": "4477038000",
            "name": "판교면"
          },
          {
            "code": "4477039000",
            "name": "종천면"
          },
          {
            "code": "4477040000",
            "name": "비인면"
          },
          {
            "code": "4477041000",
            "name": "서면"
          }
        ]
      },
      {
        "code": "44790",
        "name": "청양군",
        "sub": [
          {
            "code": "4479025000",
            "name": "청양읍"
          },
          {
            "code": "4479031000",
            "name": "운곡면"
          },
          {
            "code": "4479032000",
            "name": "대치면"
          },
          {
            "code": "4479033000",
            "name": "정산면"
          },
          {
            "code": "4479034000",
            "name": "목면"
          },
          {
            "code": "4479035000",
            "name": "청남면"
          },
          {
            "code": "4479036000",
            "name": "장평면"
          },
          {
            "code": "4479037000",
            "name": "남양면"
          },
          {
            "code": "4479038000",
            "name": "화성면"
          },
          {
            "code": "4479039000",
            "name": "비봉면"
          }
        ]
      },
      {
        "code": "44800",
        "name": "홍성군",
        "sub": [
          {
            "code": "4480025000",
            "name": "홍성읍"
          },
          {
            "code": "4480025300",
            "name": "광천읍"
          },
          {
            "code": "4480025600",
            "name": "홍북읍"
          },
          {
            "code": "4480032000",
            "name": "금마면"
          },
          {
            "code": "4480033000",
            "name": "홍동면"
          },
          {
            "code": "4480034000",
            "name": "장곡면"
          },
          {
            "code": "4480035000",
            "name": "은하면"
          },
          {
            "code": "4480036000",
            "name": "결성면"
          },
          {
            "code": "4480037000",
            "name": "서부면"
          },
          {
            "code": "4480038000",
            "name": "갈산면"
          },
          {
            "code": "4480039000",
            "name": "구항면"
          }
        ]
      },
      {
        "code": "44810",
        "name": "예산군",
        "sub": [
          {
            "code": "4481025000",
            "name": "예산읍"
          },
          {
            "code": "4481025300",
            "name": "삽교읍"
          },
          {
            "code": "4481031000",
            "name": "대술면"
          },
          {
            "code": "4481032000",
            "name": "신양면"
          },
          {
            "code": "4481033000",
            "name": "광시면"
          },
          {
            "code": "4481034000",
            "name": "대흥면"
          },
          {
            "code": "4481035000",
            "name": "응봉면"
          },
          {
            "code": "4481036000",
            "name": "덕산면"
          },
          {
            "code": "4481037000",
            "name": "봉산면"
          },
          {
            "code": "4481038000",
            "name": "고덕면"
          },
          {
            "code": "4481039000",
            "name": "신암면"
          },
          {
            "code": "4481040000",
            "name": "오가면"
          }
        ]
      },
      {
        "code": "44825",
        "name": "태안군",
        "sub": [
          {
            "code": "4482525000",
            "name": "태안읍"
          },
          {
            "code": "4482525300",
            "name": "안면읍"
          },
          {
            "code": "4482531000",
            "name": "고남면"
          },
          {
            "code": "4482532000",
            "name": "남면"
          },
          {
            "code": "4482533000",
            "name": "근흥면"
          },
          {
            "code": "4482534000",
            "name": "소원면"
          },
          {
            "code": "4482535000",
            "name": "원북면"
          },
          {
            "code": "4482536000",
            "name": "이원면"
          }
        ]
      }
    ]
  },
  {
    "code": "45",
    "name": "전라북도",
    "sub": [
      {
        "code": "45111",
        "name": "전주시 완산구",
        "sub": [
          {
            "code": "4511151000",
            "name": "중앙동"
          },
          {
            "code": "4511153000",
            "name": "풍남동"
          },
          {
            "code": "4511160500",
            "name": "노송동"
          },
          {
            "code": "4511163500",
            "name": "완산동"
          },
          {
            "code": "4511165000",
            "name": "동서학동"
          },
          {
            "code": "4511166000",
            "name": "서서학동"
          },
          {
            "code": "4511167100",
            "name": "중화산1동"
          },
          {
            "code": "4511167200",
            "name": "중화산2동"
          },
          {
            "code": "4511168000",
            "name": "서신동"
          },
          {
            "code": "4511169100",
            "name": "평화1동"
          },
          {
            "code": "4511169200",
            "name": "평화2동"
          },
          {
            "code": "4511170100",
            "name": "삼천1동"
          },
          {
            "code": "4511170200",
            "name": "삼천2동"
          },
          {
            "code": "4511170300",
            "name": "삼천3동"
          },
          {
            "code": "4511171100",
            "name": "효자1동"
          },
          {
            "code": "4511171200",
            "name": "효자2동"
          },
          {
            "code": "4511171300",
            "name": "효자3동"
          },
          {
            "code": "4511171400",
            "name": "효자4동"
          },
          {
            "code": "4511173000",
            "name": "효자5동"
          }
        ]
      },
      {
        "code": "45113",
        "name": "전주시 덕진구",
        "sub": [
          {
            "code": "4511352500",
            "name": "진북동"
          },
          {
            "code": "4511354000",
            "name": "인후1동"
          },
          {
            "code": "4511355000",
            "name": "인후2동"
          },
          {
            "code": "4511356000",
            "name": "인후3동"
          },
          {
            "code": "4511357000",
            "name": "덕진동"
          },
          {
            "code": "4511358000",
            "name": "금암1동"
          },
          {
            "code": "4511359000",
            "name": "금암2동"
          },
          {
            "code": "4511360000",
            "name": "팔복동"
          },
          {
            "code": "4511361100",
            "name": "우아1동"
          },
          {
            "code": "4511361200",
            "name": "우아2동"
          },
          {
            "code": "4511362000",
            "name": "호성동"
          },
          {
            "code": "4511364100",
            "name": "송천1동"
          },
          {
            "code": "4511364200",
            "name": "송천2동"
          },
          {
            "code": "4511365000",
            "name": "조촌동"
          },
          {
            "code": "4511366500",
            "name": "여의동"
          },
          {
            "code": "4511367000",
            "name": "혁신동"
          }
        ]
      },
      {
        "code": "45130",
        "name": "군산시",
        "sub": [
          {
            "code": "4513025000",
            "name": "옥구읍"
          },
          {
            "code": "4513031000",
            "name": "옥산면"
          },
          {
            "code": "4513032000",
            "name": "회현면"
          },
          {
            "code": "4513033000",
            "name": "임피면"
          },
          {
            "code": "4513034000",
            "name": "서수면"
          },
          {
            "code": "4513035000",
            "name": "대야면"
          },
          {
            "code": "4513036000",
            "name": "개정면"
          },
          {
            "code": "4513037000",
            "name": "성산면"
          },
          {
            "code": "4513038000",
            "name": "나포면"
          },
          {
            "code": "4513039000",
            "name": "옥도면"
          },
          {
            "code": "4513040000",
            "name": "옥서면"
          },
          {
            "code": "4513051500",
            "name": "해신동"
          },
          {
            "code": "4513053000",
            "name": "월명동"
          },
          {
            "code": "4513055000",
            "name": "신풍동"
          },
          {
            "code": "4513056000",
            "name": "삼학동"
          },
          {
            "code": "4513060500",
            "name": "중앙동"
          },
          {
            "code": "4513064000",
            "name": "흥남동"
          },
          {
            "code": "4513065000",
            "name": "조촌동"
          },
          {
            "code": "4513066000",
            "name": "경암동"
          },
          {
            "code": "4513067000",
            "name": "구암동"
          },
          {
            "code": "4513068000",
            "name": "개정동"
          },
          {
            "code": "4513069000",
            "name": "수송동"
          },
          {
            "code": "4513070100",
            "name": "나운1동"
          },
          {
            "code": "4513070200",
            "name": "나운2동"
          },
          {
            "code": "4513070300",
            "name": "나운3동"
          },
          {
            "code": "4513071000",
            "name": "소룡동"
          },
          {
            "code": "4513072000",
            "name": "미성동"
          }
        ]
      },
      {
        "code": "45140",
        "name": "익산시",
        "sub": [
          {
            "code": "4514025000",
            "name": "함열읍"
          },
          {
            "code": "4514031000",
            "name": "오산면"
          },
          {
            "code": "4514032000",
            "name": "황등면"
          },
          {
            "code": "4514033000",
            "name": "함라면"
          },
          {
            "code": "4514034000",
            "name": "웅포면"
          },
          {
            "code": "4514035000",
            "name": "성당면"
          },
          {
            "code": "4514036000",
            "name": "용안면"
          },
          {
            "code": "4514037000",
            "name": "낭산면"
          },
          {
            "code": "4514038000",
            "name": "망성면"
          },
          {
            "code": "4514039000",
            "name": "여산면"
          },
          {
            "code": "4514040000",
            "name": "금마면"
          },
          {
            "code": "4514041000",
            "name": "왕궁면"
          },
          {
            "code": "4514042000",
            "name": "춘포면"
          },
          {
            "code": "4514043000",
            "name": "삼기면"
          },
          {
            "code": "4514044000",
            "name": "용동면"
          },
          {
            "code": "4514052000",
            "name": "중앙동"
          },
          {
            "code": "4514053000",
            "name": "평화동"
          },
          {
            "code": "4514056000",
            "name": "인화동"
          },
          {
            "code": "4514057000",
            "name": "동산동"
          },
          {
            "code": "4514058000",
            "name": "마동"
          },
          {
            "code": "4514059500",
            "name": "남중동"
          },
          {
            "code": "4514061000",
            "name": "모현동"
          },
          {
            "code": "4514062000",
            "name": "송학동"
          },
          {
            "code": "4514064600",
            "name": "영등1동"
          },
          {
            "code": "4514064700",
            "name": "영등2동"
          },
          {
            "code": "4514065200",
            "name": "어양동"
          },
          {
            "code": "4514065600",
            "name": "신동"
          },
          {
            "code": "4514067000",
            "name": "팔봉동"
          },
          {
            "code": "4514069000",
            "name": "삼성동"
          }
        ]
      },
      {
        "code": "45180",
        "name": "정읍시",
        "sub": [
          {
            "code": "4518025000",
            "name": "신태인읍"
          },
          {
            "code": "4518031000",
            "name": "북면"
          },
          {
            "code": "4518032000",
            "name": "입암면"
          },
          {
            "code": "4518033000",
            "name": "소성면"
          },
          {
            "code": "4518034000",
            "name": "고부면"
          },
          {
            "code": "4518035000",
            "name": "영원면"
          },
          {
            "code": "4518036000",
            "name": "덕천면"
          },
          {
            "code": "4518037000",
            "name": "이평면"
          },
          {
            "code": "4518038000",
            "name": "정우면"
          },
          {
            "code": "4518039000",
            "name": "태인면"
          },
          {
            "code": "4518040000",
            "name": "감곡면"
          },
          {
            "code": "4518041000",
            "name": "옹동면"
          },
          {
            "code": "4518042000",
            "name": "칠보면"
          },
          {
            "code": "4518043000",
            "name": "산내면"
          },
          {
            "code": "4518044000",
            "name": "산외면"
          },
          {
            "code": "4518051000",
            "name": "수성동"
          },
          {
            "code": "4518052000",
            "name": "장명동"
          },
          {
            "code": "4518053500",
            "name": "내장상동"
          },
          {
            "code": "4518054500",
            "name": "시기동"
          },
          {
            "code": "4518056500",
            "name": "초산동"
          },
          {
            "code": "4518057000",
            "name": "연지동"
          },
          {
            "code": "4518058000",
            "name": "농소동"
          },
          {
            "code": "4518059500",
            "name": "상교동"
          }
        ]
      },
      {
        "code": "45190",
        "name": "남원시",
        "sub": [
          {
            "code": "4519025000",
            "name": "운봉읍"
          },
          {
            "code": "4519031000",
            "name": "주천면"
          },
          {
            "code": "4519032000",
            "name": "수지면"
          },
          {
            "code": "4519033000",
            "name": "송동면"
          },
          {
            "code": "4519034000",
            "name": "주생면"
          },
          {
            "code": "4519035000",
            "name": "금지면"
          },
          {
            "code": "4519036000",
            "name": "대강면"
          },
          {
            "code": "4519037000",
            "name": "대산면"
          },
          {
            "code": "4519038000",
            "name": "사매면"
          },
          {
            "code": "4519039000",
            "name": "덕과면"
          },
          {
            "code": "4519040000",
            "name": "보절면"
          },
          {
            "code": "4519041000",
            "name": "산동면"
          },
          {
            "code": "4519042000",
            "name": "이백면"
          },
          {
            "code": "4519045000",
            "name": "아영면"
          },
          {
            "code": "4519046000",
            "name": "산내면"
          },
          {
            "code": "4519047000",
            "name": "인월면"
          },
          {
            "code": "4519051000",
            "name": "동충동"
          },
          {
            "code": "4519052000",
            "name": "죽항동"
          },
          {
            "code": "4519054000",
            "name": "노암동"
          },
          {
            "code": "4519055000",
            "name": "금동"
          },
          {
            "code": "4519056000",
            "name": "왕정동"
          },
          {
            "code": "4519057000",
            "name": "향교동"
          },
          {
            "code": "4519059000",
            "name": "도통동"
          }
        ]
      },
      {
        "code": "45210",
        "name": "김제시",
        "sub": [
          {
            "code": "4521025000",
            "name": "만경읍"
          },
          {
            "code": "4521032000",
            "name": "죽산면"
          },
          {
            "code": "4521033000",
            "name": "백산면"
          },
          {
            "code": "4521034000",
            "name": "용지면"
          },
          {
            "code": "4521035000",
            "name": "백구면"
          },
          {
            "code": "4521036000",
            "name": "부량면"
          },
          {
            "code": "4521038000",
            "name": "공덕면"
          },
          {
            "code": "4521039000",
            "name": "청하면"
          },
          {
            "code": "4521040000",
            "name": "성덕면"
          },
          {
            "code": "4521041000",
            "name": "진봉면"
          },
          {
            "code": "4521042000",
            "name": "금구면"
          },
          {
            "code": "4521043000",
            "name": "봉남면"
          },
          {
            "code": "4521044000",
            "name": "황산면"
          },
          {
            "code": "4521045000",
            "name": "금산면"
          },
          {
            "code": "4521046000",
            "name": "광활면"
          },
          {
            "code": "4521051000",
            "name": "요촌동"
          },
          {
            "code": "4521052000",
            "name": "신풍동"
          },
          {
            "code": "4521054000",
            "name": "검산동"
          },
          {
            "code": "4521058000",
            "name": "교월동"
          }
        ]
      },
      {
        "code": "45710",
        "name": "완주군",
        "sub": [
          {
            "code": "4571025000",
            "name": "삼례읍"
          },
          {
            "code": "4571025300",
            "name": "봉동읍"
          },
          {
            "code": "4571025600",
            "name": "용진읍"
          },
          {
            "code": "4571032000",
            "name": "상관면"
          },
          {
            "code": "4571033000",
            "name": "이서면"
          },
          {
            "code": "4571034000",
            "name": "소양면"
          },
          {
            "code": "4571035000",
            "name": "구이면"
          },
          {
            "code": "4571036000",
            "name": "고산면"
          },
          {
            "code": "4571037000",
            "name": "비봉면"
          },
          {
            "code": "4571038000",
            "name": "운주면"
          },
          {
            "code": "4571039000",
            "name": "화산면"
          },
          {
            "code": "4571040000",
            "name": "동상면"
          },
          {
            "code": "4571041000",
            "name": "경천면"
          }
        ]
      },
      {
        "code": "45720",
        "name": "진안군",
        "sub": [
          {
            "code": "4572025000",
            "name": "진안읍"
          },
          {
            "code": "4572031000",
            "name": "용담면"
          },
          {
            "code": "4572032000",
            "name": "안천면"
          },
          {
            "code": "4572033000",
            "name": "동향면"
          },
          {
            "code": "4572034000",
            "name": "상전면"
          },
          {
            "code": "4572035000",
            "name": "백운면"
          },
          {
            "code": "4572036000",
            "name": "성수면"
          },
          {
            "code": "4572037000",
            "name": "마령면"
          },
          {
            "code": "4572038000",
            "name": "부귀면"
          },
          {
            "code": "4572039000",
            "name": "정천면"
          },
          {
            "code": "4572040000",
            "name": "주천면"
          }
        ]
      },
      {
        "code": "45730",
        "name": "무주군",
        "sub": [
          {
            "code": "4573025000",
            "name": "무주읍"
          },
          {
            "code": "4573031000",
            "name": "무풍면"
          },
          {
            "code": "4573032000",
            "name": "설천면"
          },
          {
            "code": "4573033000",
            "name": "적상면"
          },
          {
            "code": "4573034000",
            "name": "안성면"
          },
          {
            "code": "4573035000",
            "name": "부남면"
          }
        ]
      },
      {
        "code": "45740",
        "name": "장수군",
        "sub": [
          {
            "code": "4574025000",
            "name": "장수읍"
          },
          {
            "code": "4574031000",
            "name": "산서면"
          },
          {
            "code": "4574032000",
            "name": "번암면"
          },
          {
            "code": "4574033500",
            "name": "장계면"
          },
          {
            "code": "4574034000",
            "name": "천천면"
          },
          {
            "code": "4574035000",
            "name": "계남면"
          },
          {
            "code": "4574036000",
            "name": "계북면"
          }
        ]
      },
      {
        "code": "45750",
        "name": "임실군",
        "sub": [
          {
            "code": "4575025000",
            "name": "임실읍"
          },
          {
            "code": "4575031000",
            "name": "청웅면"
          },
          {
            "code": "4575032000",
            "name": "운암면"
          },
          {
            "code": "4575033000",
            "name": "신평면"
          },
          {
            "code": "4575034000",
            "name": "성수면"
          },
          {
            "code": "4575035500",
            "name": "오수면"
          },
          {
            "code": "4575036000",
            "name": "신덕면"
          },
          {
            "code": "4575037000",
            "name": "삼계면"
          },
          {
            "code": "4575038000",
            "name": "관촌면"
          },
          {
            "code": "4575039000",
            "name": "강진면"
          },
          {
            "code": "4575040000",
            "name": "덕치면"
          },
          {
            "code": "4575041000",
            "name": "지사면"
          }
        ]
      },
      {
        "code": "45770",
        "name": "순창군",
        "sub": [
          {
            "code": "4577025000",
            "name": "순창읍"
          },
          {
            "code": "4577031000",
            "name": "인계면"
          },
          {
            "code": "4577032000",
            "name": "동계면"
          },
          {
            "code": "4577033000",
            "name": "풍산면"
          },
          {
            "code": "4577034000",
            "name": "금과면"
          },
          {
            "code": "4577035000",
            "name": "팔덕면"
          },
          {
            "code": "4577036000",
            "name": "쌍치면"
          },
          {
            "code": "4577037000",
            "name": "복흥면"
          },
          {
            "code": "4577038000",
            "name": "적성면"
          },
          {
            "code": "4577039000",
            "name": "유등면"
          },
          {
            "code": "4577040000",
            "name": "구림면"
          }
        ]
      },
      {
        "code": "45790",
        "name": "고창군",
        "sub": [
          {
            "code": "4579025000",
            "name": "고창읍"
          },
          {
            "code": "4579031000",
            "name": "고수면"
          },
          {
            "code": "4579032000",
            "name": "아산면"
          },
          {
            "code": "4579033000",
            "name": "무장면"
          },
          {
            "code": "4579034000",
            "name": "공음면"
          },
          {
            "code": "4579035000",
            "name": "상하면"
          },
          {
            "code": "4579036000",
            "name": "해리면"
          },
          {
            "code": "4579037000",
            "name": "성송면"
          },
          {
            "code": "4579038000",
            "name": "대산면"
          },
          {
            "code": "4579039000",
            "name": "심원면"
          },
          {
            "code": "4579040000",
            "name": "흥덕면"
          },
          {
            "code": "4579041000",
            "name": "성내면"
          },
          {
            "code": "4579042000",
            "name": "신림면"
          },
          {
            "code": "4579043000",
            "name": "부안면"
          }
        ]
      },
      {
        "code": "45800",
        "name": "부안군",
        "sub": [
          {
            "code": "4580025000",
            "name": "부안읍"
          },
          {
            "code": "4580031000",
            "name": "주산면"
          },
          {
            "code": "4580032000",
            "name": "동진면"
          },
          {
            "code": "4580033000",
            "name": "행안면"
          },
          {
            "code": "4580034000",
            "name": "계화면"
          },
          {
            "code": "4580035000",
            "name": "보안면"
          },
          {
            "code": "4580036000",
            "name": "변산면"
          },
          {
            "code": "4580037000",
            "name": "진서면"
          },
          {
            "code": "4580038000",
            "name": "백산면"
          },
          {
            "code": "4580039000",
            "name": "상서면"
          },
          {
            "code": "4580040000",
            "name": "하서면"
          },
          {
            "code": "4580041000",
            "name": "줄포면"
          },
          {
            "code": "4580042000",
            "name": "위도면"
          }
        ]
      }
    ]
  },
  {
    "code": "46",
    "name": "전라남도",
    "sub": [
      {
        "code": "46110",
        "name": "목포시",
        "sub": [
          {
            "code": "4611051000",
            "name": "용당1동"
          },
          {
            "code": "4611052000",
            "name": "용당2동"
          },
          {
            "code": "4611053500",
            "name": "연동"
          },
          {
            "code": "4611054500",
            "name": "산정동"
          },
          {
            "code": "4611055400",
            "name": "연산동"
          },
          {
            "code": "4611055800",
            "name": "원산동"
          },
          {
            "code": "4611056500",
            "name": "대성동"
          },
          {
            "code": "4611059500",
            "name": "목원동"
          },
          {
            "code": "4611064000",
            "name": "동명동"
          },
          {
            "code": "4611064500",
            "name": "삼학동"
          },
          {
            "code": "4611065500",
            "name": "만호동"
          },
          {
            "code": "4611066000",
            "name": "유달동"
          },
          {
            "code": "4611069500",
            "name": "죽교동"
          },
          {
            "code": "4611070500",
            "name": "북항동"
          },
          {
            "code": "4611074500",
            "name": "용해동"
          },
          {
            "code": "4611075000",
            "name": "이로동"
          },
          {
            "code": "4611075600",
            "name": "상동"
          },
          {
            "code": "4611075700",
            "name": "하당동"
          },
          {
            "code": "4611075800",
            "name": "신흥동"
          },
          {
            "code": "4611078000",
            "name": "삼향동"
          },
          {
            "code": "4611079000",
            "name": "옥암동"
          },
          {
            "code": "4611080000",
            "name": "부흥동"
          },
          {
            "code": "4611081000",
            "name": "부주동"
          }
        ]
      },
      {
        "code": "46130",
        "name": "여수시",
        "sub": [
          {
            "code": "4613025000",
            "name": "돌산읍"
          },
          {
            "code": "4613025100",
            "name": "돌산읍우두출장소"
          },
          {
            "code": "4613025200",
            "name": "돌산읍죽포출장소"
          },
          {
            "code": "4613031000",
            "name": "소라면"
          },
          {
            "code": "4613032000",
            "name": "율촌면"
          },
          {
            "code": "4613033000",
            "name": "화양면"
          },
          {
            "code": "4613034000",
            "name": "남면"
          },
          {
            "code": "4613035000",
            "name": "화정면"
          },
          {
            "code": "4613035600",
            "name": "화정면개도출장소"
          },
          {
            "code": "4613036000",
            "name": "삼산면"
          },
          {
            "code": "4613051500",
            "name": "동문동"
          },
          {
            "code": "4613053500",
            "name": "한려동"
          },
          {
            "code": "4613057000",
            "name": "중앙동"
          },
          {
            "code": "4613060000",
            "name": "충무동"
          },
          {
            "code": "4613062500",
            "name": "광림동"
          },
          {
            "code": "4613063500",
            "name": "서강동"
          },
          {
            "code": "4613065500",
            "name": "대교동"
          },
          {
            "code": "4613067000",
            "name": "국동"
          },
          {
            "code": "4613068500",
            "name": "월호동"
          },
          {
            "code": "4613070000",
            "name": "여서동"
          },
          {
            "code": "4613071000",
            "name": "문수동"
          },
          {
            "code": "4613073000",
            "name": "미평동"
          },
          {
            "code": "4613074000",
            "name": "둔덕동"
          },
          {
            "code": "4613076500",
            "name": "만덕동"
          },
          {
            "code": "4613078000",
            "name": "쌍봉동"
          },
          {
            "code": "4613079000",
            "name": "시전동"
          },
          {
            "code": "4613080000",
            "name": "여천동"
          },
          {
            "code": "4613081000",
            "name": "주삼동"
          },
          {
            "code": "4613082000",
            "name": "삼일동"
          },
          {
            "code": "4613083000",
            "name": "묘도동"
          }
        ]
      },
      {
        "code": "46150",
        "name": "순천시",
        "sub": [
          {
            "code": "4615025000",
            "name": "승주읍"
          },
          {
            "code": "4615031000",
            "name": "해룡면"
          },
          {
            "code": "4615031500",
            "name": "해룡면상삼출장소"
          },
          {
            "code": "4615031600",
            "name": "해룡면신대출장소"
          },
          {
            "code": "4615032000",
            "name": "서면"
          },
          {
            "code": "4615033000",
            "name": "황전면"
          },
          {
            "code": "4615034000",
            "name": "월등면"
          },
          {
            "code": "4615035000",
            "name": "주암면"
          },
          {
            "code": "4615036000",
            "name": "송광면"
          },
          {
            "code": "4615037000",
            "name": "외서면"
          },
          {
            "code": "4615038000",
            "name": "낙안면"
          },
          {
            "code": "4615039000",
            "name": "별량면"
          },
          {
            "code": "4615040000",
            "name": "상사면"
          },
          {
            "code": "4615051500",
            "name": "향동"
          },
          {
            "code": "4615054000",
            "name": "매곡동"
          },
          {
            "code": "4615055000",
            "name": "삼산동"
          },
          {
            "code": "4615056000",
            "name": "조곡동"
          },
          {
            "code": "4615057000",
            "name": "덕연동"
          },
          {
            "code": "4615058000",
            "name": "풍덕동"
          },
          {
            "code": "4615059000",
            "name": "남제동"
          },
          {
            "code": "4615060000",
            "name": "저전동"
          },
          {
            "code": "4615061000",
            "name": "장천동"
          },
          {
            "code": "4615062000",
            "name": "중앙동"
          },
          {
            "code": "4615063500",
            "name": "도사동"
          },
          {
            "code": "4615066100",
            "name": "왕조1동"
          },
          {
            "code": "4615066500",
            "name": "왕조2동"
          }
        ]
      },
      {
        "code": "46170",
        "name": "나주시",
        "sub": [
          {
            "code": "4617025000",
            "name": "남평읍"
          },
          {
            "code": "4617031000",
            "name": "세지면"
          },
          {
            "code": "4617032000",
            "name": "왕곡면"
          },
          {
            "code": "4617033000",
            "name": "반남면"
          },
          {
            "code": "4617034000",
            "name": "공산면"
          },
          {
            "code": "4617035000",
            "name": "동강면"
          },
          {
            "code": "4617036000",
            "name": "다시면"
          },
          {
            "code": "4617037000",
            "name": "문평면"
          },
          {
            "code": "4617038000",
            "name": "노안면"
          },
          {
            "code": "4617039000",
            "name": "금천면"
          },
          {
            "code": "4617040000",
            "name": "산포면"
          },
          {
            "code": "4617042000",
            "name": "다도면"
          },
          {
            "code": "4617043000",
            "name": "봉황면"
          },
          {
            "code": "4617051000",
            "name": "송월동"
          },
          {
            "code": "4617052000",
            "name": "영강동"
          },
          {
            "code": "4617054000",
            "name": "금남동"
          },
          {
            "code": "4617055000",
            "name": "성북동"
          },
          {
            "code": "4617058000",
            "name": "영산동"
          },
          {
            "code": "4617060000",
            "name": "이창동"
          },
          {
            "code": "4617062000",
            "name": "빛가람동"
          }
        ]
      },
      {
        "code": "46230",
        "name": "광양시",
        "sub": [
          {
            "code": "4623025000",
            "name": "광양읍"
          },
          {
            "code": "4623031000",
            "name": "봉강면"
          },
          {
            "code": "4623032000",
            "name": "옥룡면"
          },
          {
            "code": "4623033000",
            "name": "옥곡면"
          },
          {
            "code": "4623034000",
            "name": "진상면"
          },
          {
            "code": "4623035000",
            "name": "진월면"
          },
          {
            "code": "4623036000",
            "name": "다압면"
          },
          {
            "code": "4623051500",
            "name": "골약동"
          },
          {
            "code": "4623053000",
            "name": "중마동"
          },
          {
            "code": "4623054000",
            "name": "광영동"
          },
          {
            "code": "4623055000",
            "name": "금호동"
          },
          {
            "code": "4623057000",
            "name": "태인동"
          }
        ]
      },
      {
        "code": "46710",
        "name": "담양군",
        "sub": [
          {
            "code": "4671025000",
            "name": "담양읍"
          },
          {
            "code": "4671031000",
            "name": "봉산면"
          },
          {
            "code": "4671032000",
            "name": "고서면"
          },
          {
            "code": "4671033500",
            "name": "가사문학면"
          },
          {
            "code": "4671034000",
            "name": "창평면"
          },
          {
            "code": "4671035000",
            "name": "대덕면"
          },
          {
            "code": "4671036000",
            "name": "무정면"
          },
          {
            "code": "4671037000",
            "name": "금성면"
          },
          {
            "code": "4671038000",
            "name": "용면"
          },
          {
            "code": "4671039000",
            "name": "월산면"
          },
          {
            "code": "4671040000",
            "name": "수북면"
          },
          {
            "code": "4671041000",
            "name": "대전면"
          }
        ]
      },
      {
        "code": "46720",
        "name": "곡성군",
        "sub": [
          {
            "code": "4672025000",
            "name": "곡성읍"
          },
          {
            "code": "4672031000",
            "name": "오곡면"
          },
          {
            "code": "4672032000",
            "name": "삼기면"
          },
          {
            "code": "4672033000",
            "name": "석곡면"
          },
          {
            "code": "4672034000",
            "name": "목사동면"
          },
          {
            "code": "4672035000",
            "name": "죽곡면"
          },
          {
            "code": "4672036000",
            "name": "고달면"
          },
          {
            "code": "4672037000",
            "name": "옥과면"
          },
          {
            "code": "4672038000",
            "name": "입면"
          },
          {
            "code": "4672039000",
            "name": "겸면"
          },
          {
            "code": "4672040000",
            "name": "오산면"
          }
        ]
      },
      {
        "code": "46730",
        "name": "구례군",
        "sub": [
          {
            "code": "4673025000",
            "name": "구례읍"
          },
          {
            "code": "4673031000",
            "name": "문척면"
          },
          {
            "code": "4673032000",
            "name": "간전면"
          },
          {
            "code": "4673033000",
            "name": "토지면"
          },
          {
            "code": "4673034000",
            "name": "마산면"
          },
          {
            "code": "4673035000",
            "name": "광의면"
          },
          {
            "code": "4673036000",
            "name": "용방면"
          },
          {
            "code": "4673037000",
            "name": "산동면"
          }
        ]
      },
      {
        "code": "46770",
        "name": "고흥군",
        "sub": [
          {
            "code": "4677025000",
            "name": "고흥읍"
          },
          {
            "code": "4677025300",
            "name": "도양읍"
          },
          {
            "code": "4677025400",
            "name": "도양읍소록출장소"
          },
          {
            "code": "4677025500",
            "name": "도양읍시산출장소"
          },
          {
            "code": "4677031000",
            "name": "풍양면"
          },
          {
            "code": "4677032000",
            "name": "도덕면"
          },
          {
            "code": "4677033000",
            "name": "금산면"
          },
          {
            "code": "4677034000",
            "name": "도화면"
          },
          {
            "code": "4677035000",
            "name": "포두면"
          },
          {
            "code": "4677036000",
            "name": "봉래면"
          },
          {
            "code": "4677037000",
            "name": "점암면"
          },
          {
            "code": "4677038000",
            "name": "과역면"
          },
          {
            "code": "4677039000",
            "name": "남양면"
          },
          {
            "code": "4677040000",
            "name": "동강면"
          },
          {
            "code": "4677041000",
            "name": "대서면"
          },
          {
            "code": "4677042000",
            "name": "두원면"
          },
          {
            "code": "4677044000",
            "name": "영남면"
          },
          {
            "code": "4677045000",
            "name": "동일면"
          }
        ]
      },
      {
        "code": "46780",
        "name": "보성군",
        "sub": [
          {
            "code": "4678025000",
            "name": "보성읍"
          },
          {
            "code": "4678025300",
            "name": "벌교읍"
          },
          {
            "code": "4678031000",
            "name": "노동면"
          },
          {
            "code": "4678032000",
            "name": "미력면"
          },
          {
            "code": "4678033000",
            "name": "겸백면"
          },
          {
            "code": "4678034000",
            "name": "율어면"
          },
          {
            "code": "4678035000",
            "name": "복내면"
          },
          {
            "code": "4678036000",
            "name": "문덕면"
          },
          {
            "code": "4678037000",
            "name": "조성면"
          },
          {
            "code": "4678038000",
            "name": "득량면"
          },
          {
            "code": "4678038500",
            "name": "득량면예당출장소"
          },
          {
            "code": "4678039000",
            "name": "회천면"
          },
          {
            "code": "4678040000",
            "name": "웅치면"
          }
        ]
      },
      {
        "code": "46790",
        "name": "화순군",
        "sub": [
          {
            "code": "4679025000",
            "name": "화순읍"
          },
          {
            "code": "4679031000",
            "name": "한천면"
          },
          {
            "code": "4679031500",
            "name": "한천면영외출장소"
          },
          {
            "code": "4679032000",
            "name": "춘양면"
          },
          {
            "code": "4679033000",
            "name": "청풍면"
          },
          {
            "code": "4679034000",
            "name": "이양면"
          },
          {
            "code": "4679035000",
            "name": "능주면"
          },
          {
            "code": "4679036000",
            "name": "도곡면"
          },
          {
            "code": "4679037000",
            "name": "도암면"
          },
          {
            "code": "4679038000",
            "name": "이서면"
          },
          {
            "code": "4679039500",
            "name": "백아면"
          },
          {
            "code": "4679040000",
            "name": "동복면"
          },
          {
            "code": "4679041500",
            "name": "사평면"
          },
          {
            "code": "4679042000",
            "name": "동면"
          }
        ]
      },
      {
        "code": "46800",
        "name": "장흥군",
        "sub": [
          {
            "code": "4680025000",
            "name": "장흥읍"
          },
          {
            "code": "4680025300",
            "name": "관산읍"
          },
          {
            "code": "4680025600",
            "name": "대덕읍"
          },
          {
            "code": "4680031000",
            "name": "용산면"
          },
          {
            "code": "4680032000",
            "name": "안양면"
          },
          {
            "code": "4680033000",
            "name": "장동면"
          },
          {
            "code": "4680034000",
            "name": "장평면"
          },
          {
            "code": "4680035000",
            "name": "유치면"
          },
          {
            "code": "4680036000",
            "name": "부산면"
          },
          {
            "code": "4680037000",
            "name": "회진면"
          }
        ]
      },
      {
        "code": "46810",
        "name": "강진군",
        "sub": [
          {
            "code": "4681025000",
            "name": "강진읍"
          },
          {
            "code": "4681031000",
            "name": "군동면"
          },
          {
            "code": "4681032000",
            "name": "칠량면"
          },
          {
            "code": "4681033000",
            "name": "대구면"
          },
          {
            "code": "4681034000",
            "name": "도암면"
          },
          {
            "code": "4681035000",
            "name": "신전면"
          },
          {
            "code": "4681036000",
            "name": "성전면"
          },
          {
            "code": "4681037000",
            "name": "작천면"
          },
          {
            "code": "4681038000",
            "name": "병영면"
          },
          {
            "code": "4681039000",
            "name": "옴천면"
          },
          {
            "code": "4681040000",
            "name": "마량면"
          }
        ]
      },
      {
        "code": "46820",
        "name": "해남군",
        "sub": [
          {
            "code": "4682025000",
            "name": "해남읍"
          },
          {
            "code": "4682031000",
            "name": "삼산면"
          },
          {
            "code": "4682032000",
            "name": "화산면"
          },
          {
            "code": "4682033000",
            "name": "현산면"
          },
          {
            "code": "4682034000",
            "name": "송지면"
          },
          {
            "code": "4682035000",
            "name": "북평면"
          },
          {
            "code": "4682036000",
            "name": "북일면"
          },
          {
            "code": "4682037000",
            "name": "옥천면"
          },
          {
            "code": "4682038000",
            "name": "계곡면"
          },
          {
            "code": "4682039000",
            "name": "마산면"
          },
          {
            "code": "4682040000",
            "name": "황산면"
          },
          {
            "code": "4682041000",
            "name": "산이면"
          },
          {
            "code": "4682042000",
            "name": "문내면"
          },
          {
            "code": "4682043000",
            "name": "화원면"
          }
        ]
      },
      {
        "code": "46830",
        "name": "영암군",
        "sub": [
          {
            "code": "4683025000",
            "name": "영암읍"
          },
          {
            "code": "4683025300",
            "name": "삼호읍"
          },
          {
            "code": "4683025400",
            "name": "삼호읍서부출장소"
          },
          {
            "code": "4683031000",
            "name": "덕진면"
          },
          {
            "code": "4683032000",
            "name": "금정면"
          },
          {
            "code": "4683033000",
            "name": "신북면"
          },
          {
            "code": "4683034000",
            "name": "시종면"
          },
          {
            "code": "4683035000",
            "name": "도포면"
          },
          {
            "code": "4683036000",
            "name": "군서면"
          },
          {
            "code": "4683037000",
            "name": "서호면"
          },
          {
            "code": "4683038000",
            "name": "학산면"
          },
          {
            "code": "4683039000",
            "name": "미암면"
          }
        ]
      },
      {
        "code": "46840",
        "name": "무안군",
        "sub": [
          {
            "code": "4684025000",
            "name": "무안읍"
          },
          {
            "code": "4684025300",
            "name": "일로읍"
          },
          {
            "code": "4684025600",
            "name": "삼향읍"
          },
          {
            "code": "4684025800",
            "name": "삼향읍남악출장소"
          },
          {
            "code": "4684032000",
            "name": "몽탄면"
          },
          {
            "code": "4684033000",
            "name": "청계면"
          },
          {
            "code": "4684034000",
            "name": "현경면"
          },
          {
            "code": "4684035000",
            "name": "망운면"
          },
          {
            "code": "4684036000",
            "name": "해제면"
          },
          {
            "code": "4684037000",
            "name": "운남면"
          }
        ]
      },
      {
        "code": "46860",
        "name": "함평군",
        "sub": [
          {
            "code": "4686025000",
            "name": "함평읍"
          },
          {
            "code": "4686031000",
            "name": "손불면"
          },
          {
            "code": "4686032000",
            "name": "신광면"
          },
          {
            "code": "4686033000",
            "name": "학교면"
          },
          {
            "code": "4686034000",
            "name": "엄다면"
          },
          {
            "code": "4686035000",
            "name": "대동면"
          },
          {
            "code": "4686036000",
            "name": "나산면"
          },
          {
            "code": "4686037000",
            "name": "해보면"
          },
          {
            "code": "4686038000",
            "name": "월야면"
          }
        ]
      },
      {
        "code": "46870",
        "name": "영광군",
        "sub": [
          {
            "code": "4687025000",
            "name": "영광읍"
          },
          {
            "code": "4687025300",
            "name": "백수읍"
          },
          {
            "code": "4687025600",
            "name": "홍농읍"
          },
          {
            "code": "4687031000",
            "name": "대마면"
          },
          {
            "code": "4687032000",
            "name": "묘량면"
          },
          {
            "code": "4687033000",
            "name": "불갑면"
          },
          {
            "code": "4687034000",
            "name": "군서면"
          },
          {
            "code": "4687035000",
            "name": "군남면"
          },
          {
            "code": "4687036000",
            "name": "염산면"
          },
          {
            "code": "4687037000",
            "name": "법성면"
          },
          {
            "code": "4687038000",
            "name": "낙월면"
          },
          {
            "code": "4687038500",
            "name": "낙월면안마출장소"
          }
        ]
      },
      {
        "code": "46880",
        "name": "장성군",
        "sub": [
          {
            "code": "4688025000",
            "name": "장성읍"
          },
          {
            "code": "4688031000",
            "name": "진원면"
          },
          {
            "code": "4688032000",
            "name": "남면"
          },
          {
            "code": "4688033000",
            "name": "동화면"
          },
          {
            "code": "4688034000",
            "name": "삼서면"
          },
          {
            "code": "4688035000",
            "name": "삼계면"
          },
          {
            "code": "4688036000",
            "name": "황룡면"
          },
          {
            "code": "4688037000",
            "name": "서삼면"
          },
          {
            "code": "4688038000",
            "name": "북일면"
          },
          {
            "code": "4688039000",
            "name": "북이면"
          },
          {
            "code": "4688040000",
            "name": "북하면"
          }
        ]
      },
      {
        "code": "46890",
        "name": "완도군",
        "sub": [
          {
            "code": "4689025000",
            "name": "완도읍"
          },
          {
            "code": "4689025300",
            "name": "금일읍"
          },
          {
            "code": "4689025600",
            "name": "노화읍"
          },
          {
            "code": "4689029000",
            "name": "노화읍넙도출장소"
          },
          {
            "code": "4689031000",
            "name": "군외면"
          },
          {
            "code": "4689032000",
            "name": "신지면"
          },
          {
            "code": "4689033000",
            "name": "고금면"
          },
          {
            "code": "4689034000",
            "name": "약산면"
          },
          {
            "code": "4689035000",
            "name": "청산면"
          },
          {
            "code": "4689035500",
            "name": "청산면모도출장소"
          },
          {
            "code": "4689036000",
            "name": "소안면"
          },
          {
            "code": "4689037000",
            "name": "금당면"
          },
          {
            "code": "4689038000",
            "name": "보길면"
          },
          {
            "code": "4689039000",
            "name": "생일면"
          }
        ]
      },
      {
        "code": "46900",
        "name": "진도군",
        "sub": [
          {
            "code": "4690025000",
            "name": "진도읍"
          },
          {
            "code": "4690031000",
            "name": "군내면"
          },
          {
            "code": "4690032000",
            "name": "고군면"
          },
          {
            "code": "4690033000",
            "name": "의신면"
          },
          {
            "code": "4690034000",
            "name": "임회면"
          },
          {
            "code": "4690035000",
            "name": "지산면"
          },
          {
            "code": "4690036000",
            "name": "조도면"
          },
          {
            "code": "4690036500",
            "name": "조도면가사출장소"
          },
          {
            "code": "4690036600",
            "name": "조도면거차출장소"
          }
        ]
      },
      {
        "code": "46910",
        "name": "신안군",
        "sub": [
          {
            "code": "4691025000",
            "name": "지도읍"
          },
          {
            "code": "4691025100",
            "name": "지도읍선도출장소"
          },
          {
            "code": "4691025300",
            "name": "압해읍"
          },
          {
            "code": "4691025400",
            "name": "압해읍매화출장소"
          },
          {
            "code": "4691025500",
            "name": "압해읍고이도출장소"
          },
          {
            "code": "4691031000",
            "name": "증도면"
          },
          {
            "code": "4691031500",
            "name": "증도면병풍출장소"
          },
          {
            "code": "4691032000",
            "name": "임자면"
          },
          {
            "code": "4691033000",
            "name": "자은면"
          },
          {
            "code": "4691034000",
            "name": "비금면"
          },
          {
            "code": "4691035000",
            "name": "도초면"
          },
          {
            "code": "4691035500",
            "name": "도초면우이도출장소"
          },
          {
            "code": "4691036000",
            "name": "흑산면"
          },
          {
            "code": "4691036500",
            "name": "흑산면가거도출장소"
          },
          {
            "code": "4691036600",
            "name": "흑산면태도출장소"
          },
          {
            "code": "4691036700",
            "name": "흑산면홍도출장소"
          },
          {
            "code": "4691036800",
            "name": "흑산면대둔도출장소"
          },
          {
            "code": "4691037000",
            "name": "하의면"
          },
          {
            "code": "4691038000",
            "name": "신의면"
          },
          {
            "code": "4691039000",
            "name": "장산면"
          },
          {
            "code": "4691040000",
            "name": "안좌면"
          },
          {
            "code": "4691040500",
            "name": "안좌면자라출장소"
          },
          {
            "code": "4691041000",
            "name": "팔금면"
          },
          {
            "code": "4691042000",
            "name": "암태면"
          }
        ]
      }
    ]
  },
  {
    "code": "47",
    "name": "경상북도",
    "sub": [
      {
        "code": "47111",
        "name": "포항시 남구",
        "sub": [
          {
            "code": "4711125000",
            "name": "구룡포읍"
          },
          {
            "code": "4711125300",
            "name": "연일읍"
          },
          {
            "code": "4711125600",
            "name": "오천읍"
          },
          {
            "code": "4711131000",
            "name": "대송면"
          },
          {
            "code": "4711132000",
            "name": "동해면"
          },
          {
            "code": "4711133000",
            "name": "장기면"
          },
          {
            "code": "4711135000",
            "name": "호미곶면"
          },
          {
            "code": "4711152500",
            "name": "상대동"
          },
          {
            "code": "4711154500",
            "name": "해도동"
          },
          {
            "code": "4711155000",
            "name": "송도동"
          },
          {
            "code": "4711156000",
            "name": "청림동"
          },
          {
            "code": "4711157000",
            "name": "제철동"
          },
          {
            "code": "4711158000",
            "name": "효곡동"
          },
          {
            "code": "4711159000",
            "name": "대이동"
          }
        ]
      },
      {
        "code": "47113",
        "name": "포항시 북구",
        "sub": [
          {
            "code": "4711325000",
            "name": "흥해읍"
          },
          {
            "code": "4711331000",
            "name": "신광면"
          },
          {
            "code": "4711332000",
            "name": "청하면"
          },
          {
            "code": "4711333000",
            "name": "송라면"
          },
          {
            "code": "4711334000",
            "name": "기계면"
          },
          {
            "code": "4711335000",
            "name": "죽장면"
          },
          {
            "code": "4711335500",
            "name": "죽장면상옥출장소"
          },
          {
            "code": "4711336000",
            "name": "기북면"
          },
          {
            "code": "4711352000",
            "name": "중앙동"
          },
          {
            "code": "4711363000",
            "name": "양학동"
          },
          {
            "code": "4711365500",
            "name": "죽도동"
          },
          {
            "code": "4711366500",
            "name": "용흥동"
          },
          {
            "code": "4711368000",
            "name": "우창동"
          },
          {
            "code": "4711369000",
            "name": "두호동"
          },
          {
            "code": "4711370000",
            "name": "장량동"
          },
          {
            "code": "4711371000",
            "name": "환여동"
          }
        ]
      },
      {
        "code": "47130",
        "name": "경주시",
        "sub": [
          {
            "code": "4713025000",
            "name": "감포읍"
          },
          {
            "code": "4713025300",
            "name": "안강읍"
          },
          {
            "code": "4713025600",
            "name": "건천읍"
          },
          {
            "code": "4713025900",
            "name": "외동읍"
          },
          {
            "code": "4713031500",
            "name": "문무대왕면"
          },
          {
            "code": "4713032000",
            "name": "양남면"
          },
          {
            "code": "4713033000",
            "name": "내남면"
          },
          {
            "code": "4713034000",
            "name": "산내면"
          },
          {
            "code": "4713035000",
            "name": "서면"
          },
          {
            "code": "4713036000",
            "name": "현곡면"
          },
          {
            "code": "4713037000",
            "name": "강동면"
          },
          {
            "code": "4713038000",
            "name": "천북면"
          },
          {
            "code": "4713051500",
            "name": "중부동"
          },
          {
            "code": "4713053000",
            "name": "황오동"
          },
          {
            "code": "4713055000",
            "name": "성건동"
          },
          {
            "code": "4713057000",
            "name": "황남동"
          },
          {
            "code": "4713059000",
            "name": "선도동"
          },
          {
            "code": "4713060500",
            "name": "월성동"
          },
          {
            "code": "4713061500",
            "name": "용강동"
          },
          {
            "code": "4713062100",
            "name": "황성동"
          },
          {
            "code": "4713063000",
            "name": "동천동"
          },
          {
            "code": "4713065000",
            "name": "불국동"
          },
          {
            "code": "4713066000",
            "name": "보덕동"
          }
        ]
      },
      {
        "code": "47150",
        "name": "김천시",
        "sub": [
          {
            "code": "4715025000",
            "name": "아포읍"
          },
          {
            "code": "4715031000",
            "name": "농소면"
          },
          {
            "code": "4715032000",
            "name": "남면"
          },
          {
            "code": "4715034000",
            "name": "개령면"
          },
          {
            "code": "4715035000",
            "name": "감문면"
          },
          {
            "code": "4715036000",
            "name": "어모면"
          },
          {
            "code": "4715037000",
            "name": "봉산면"
          },
          {
            "code": "4715038000",
            "name": "대항면"
          },
          {
            "code": "4715039000",
            "name": "감천면"
          },
          {
            "code": "4715040000",
            "name": "조마면"
          },
          {
            "code": "4715041000",
            "name": "구성면"
          },
          {
            "code": "4715042000",
            "name": "지례면"
          },
          {
            "code": "4715043000",
            "name": "부항면"
          },
          {
            "code": "4715044000",
            "name": "대덕면"
          },
          {
            "code": "4715045000",
            "name": "증산면"
          },
          {
            "code": "4715051600",
            "name": "자산동"
          },
          {
            "code": "4715053600",
            "name": "평화남산동"
          },
          {
            "code": "4715056500",
            "name": "양금동"
          },
          {
            "code": "4715057500",
            "name": "대신동"
          },
          {
            "code": "4715059500",
            "name": "대곡동"
          },
          {
            "code": "4715061000",
            "name": "지좌동"
          },
          {
            "code": "4715064000",
            "name": "율곡동"
          }
        ]
      },
      {
        "code": "47170",
        "name": "안동시",
        "sub": [
          {
            "code": "4717025000",
            "name": "풍산읍"
          },
          {
            "code": "4717031000",
            "name": "와룡면"
          },
          {
            "code": "4717032000",
            "name": "북후면"
          },
          {
            "code": "4717033000",
            "name": "서후면"
          },
          {
            "code": "4717034000",
            "name": "풍천면"
          },
          {
            "code": "4717035000",
            "name": "일직면"
          },
          {
            "code": "4717036000",
            "name": "남후면"
          },
          {
            "code": "4717037000",
            "name": "남선면"
          },
          {
            "code": "4717038000",
            "name": "임하면"
          },
          {
            "code": "4717039000",
            "name": "길안면"
          },
          {
            "code": "4717040000",
            "name": "임동면"
          },
          {
            "code": "4717041000",
            "name": "예안면"
          },
          {
            "code": "4717042000",
            "name": "도산면"
          },
          {
            "code": "4717043000",
            "name": "녹전면"
          },
          {
            "code": "4717051000",
            "name": "중구동"
          },
          {
            "code": "4717052000",
            "name": "명륜동"
          },
          {
            "code": "4717055500",
            "name": "용상동"
          },
          {
            "code": "4717058500",
            "name": "서구동"
          },
          {
            "code": "4717060000",
            "name": "태화동"
          },
          {
            "code": "4717062000",
            "name": "평화동"
          },
          {
            "code": "4717063000",
            "name": "안기동"
          },
          {
            "code": "4717065000",
            "name": "옥동"
          },
          {
            "code": "4717066000",
            "name": "송하동"
          },
          {
            "code": "4717069000",
            "name": "강남동"
          }
        ]
      },
      {
        "code": "47190",
        "name": "구미시",
        "sub": [
          {
            "code": "4719025000",
            "name": "선산읍"
          },
          {
            "code": "4719025300",
            "name": "고아읍"
          },
          {
            "code": "4719025600",
            "name": "산동읍"
          },
          {
            "code": "4719031000",
            "name": "무을면"
          },
          {
            "code": "4719032000",
            "name": "옥성면"
          },
          {
            "code": "4719033000",
            "name": "도개면"
          },
          {
            "code": "4719034000",
            "name": "해평면"
          },
          {
            "code": "4719036000",
            "name": "장천면"
          },
          {
            "code": "4719051000",
            "name": "송정동"
          },
          {
            "code": "4719053500",
            "name": "원평동"
          },
          {
            "code": "4719055100",
            "name": "도량동"
          },
          {
            "code": "4719055500",
            "name": "지산동"
          },
          {
            "code": "4719056500",
            "name": "선주원남동"
          },
          {
            "code": "4719058200",
            "name": "형곡1동"
          },
          {
            "code": "4719058300",
            "name": "형곡2동"
          },
          {
            "code": "4719059000",
            "name": "신평1동"
          },
          {
            "code": "4719060000",
            "name": "신평2동"
          },
          {
            "code": "4719061000",
            "name": "비산동"
          },
          {
            "code": "4719063000",
            "name": "광평동"
          },
          {
            "code": "4719064500",
            "name": "상모사곡동"
          },
          {
            "code": "4719066000",
            "name": "임오동"
          },
          {
            "code": "4719067000",
            "name": "인동동"
          },
          {
            "code": "4719068000",
            "name": "진미동"
          },
          {
            "code": "4719069000",
            "name": "양포동"
          },
          {
            "code": "4719070000",
            "name": "공단동"
          }
        ]
      },
      {
        "code": "47210",
        "name": "영주시",
        "sub": [
          {
            "code": "4721025000",
            "name": "풍기읍"
          },
          {
            "code": "4721031000",
            "name": "이산면"
          },
          {
            "code": "4721032000",
            "name": "평은면"
          },
          {
            "code": "4721033000",
            "name": "문수면"
          },
          {
            "code": "4721034000",
            "name": "장수면"
          },
          {
            "code": "4721035000",
            "name": "안정면"
          },
          {
            "code": "4721036000",
            "name": "봉현면"
          },
          {
            "code": "4721037000",
            "name": "순흥면"
          },
          {
            "code": "4721038000",
            "name": "단산면"
          },
          {
            "code": "4721039000",
            "name": "부석면"
          },
          {
            "code": "4721051000",
            "name": "상망동"
          },
          {
            "code": "4721052500",
            "name": "하망동"
          },
          {
            "code": "4721055000",
            "name": "영주1동"
          },
          {
            "code": "4721056000",
            "name": "영주2동"
          },
          {
            "code": "4721059000",
            "name": "휴천1동"
          },
          {
            "code": "4721060000",
            "name": "휴천2동"
          },
          {
            "code": "4721061000",
            "name": "휴천3동"
          },
          {
            "code": "4721062000",
            "name": "가흥1동"
          },
          {
            "code": "4721063000",
            "name": "가흥2동"
          }
        ]
      },
      {
        "code": "47230",
        "name": "영천시",
        "sub": [
          {
            "code": "4723025000",
            "name": "금호읍"
          },
          {
            "code": "4723031000",
            "name": "청통면"
          },
          {
            "code": "4723032000",
            "name": "신녕면"
          },
          {
            "code": "4723033000",
            "name": "화산면"
          },
          {
            "code": "4723034000",
            "name": "화북면"
          },
          {
            "code": "4723035000",
            "name": "화남면"
          },
          {
            "code": "4723036000",
            "name": "자양면"
          },
          {
            "code": "4723037000",
            "name": "임고면"
          },
          {
            "code": "4723038000",
            "name": "고경면"
          },
          {
            "code": "4723039000",
            "name": "북안면"
          },
          {
            "code": "4723040000",
            "name": "대창면"
          },
          {
            "code": "4723051000",
            "name": "동부동"
          },
          {
            "code": "4723052000",
            "name": "중앙동"
          },
          {
            "code": "4723053500",
            "name": "서부동"
          },
          {
            "code": "4723054000",
            "name": "완산동"
          },
          {
            "code": "4723055500",
            "name": "남부동"
          }
        ]
      },
      {
        "code": "47250",
        "name": "상주시",
        "sub": [
          {
            "code": "4725025000",
            "name": "함창읍"
          },
          {
            "code": "4725031000",
            "name": "중동면"
          },
          {
            "code": "4725032500",
            "name": "사벌국면"
          },
          {
            "code": "4725033000",
            "name": "낙동면"
          },
          {
            "code": "4725033500",
            "name": "낙동면동부출장소"
          },
          {
            "code": "4725034000",
            "name": "청리면"
          },
          {
            "code": "4725035000",
            "name": "공성면"
          },
          {
            "code": "4725036000",
            "name": "외남면"
          },
          {
            "code": "4725037000",
            "name": "내서면"
          },
          {
            "code": "4725038000",
            "name": "모동면"
          },
          {
            "code": "4725039000",
            "name": "모서면"
          },
          {
            "code": "4725039500",
            "name": "모서면서부출장소"
          },
          {
            "code": "4725040000",
            "name": "화동면"
          },
          {
            "code": "4725041000",
            "name": "화서면"
          },
          {
            "code": "4725042000",
            "name": "화북면"
          },
          {
            "code": "4725042600",
            "name": "화북면서부출장소"
          },
          {
            "code": "4725043000",
            "name": "외서면"
          },
          {
            "code": "4725044000",
            "name": "은척면"
          },
          {
            "code": "4725044500",
            "name": "은척면북부출장소"
          },
          {
            "code": "4725045000",
            "name": "공검면"
          },
          {
            "code": "4725046000",
            "name": "이안면"
          },
          {
            "code": "4725047000",
            "name": "화남면"
          },
          {
            "code": "4725052000",
            "name": "남원동"
          },
          {
            "code": "4725053000",
            "name": "북문동"
          },
          {
            "code": "4725054000",
            "name": "계림동"
          },
          {
            "code": "4725055000",
            "name": "동문동"
          },
          {
            "code": "4725056000",
            "name": "동성동"
          },
          {
            "code": "4725057000",
            "name": "신흥동"
          }
        ]
      },
      {
        "code": "47280",
        "name": "문경시",
        "sub": [
          {
            "code": "4728025000",
            "name": "문경읍"
          },
          {
            "code": "4728025100",
            "name": "문경읍갈평출장소"
          },
          {
            "code": "4728025300",
            "name": "가은읍"
          },
          {
            "code": "4728025400",
            "name": "가은읍북부출장소"
          },
          {
            "code": "4728031000",
            "name": "영순면"
          },
          {
            "code": "4728032000",
            "name": "산양면"
          },
          {
            "code": "4728033000",
            "name": "호계면"
          },
          {
            "code": "4728034000",
            "name": "산북면"
          },
          {
            "code": "4728035000",
            "name": "동로면"
          },
          {
            "code": "4728036000",
            "name": "마성면"
          },
          {
            "code": "4728037000",
            "name": "농암면"
          },
          {
            "code": "4728057000",
            "name": "점촌1동"
          },
          {
            "code": "4728058000",
            "name": "점촌2동"
          },
          {
            "code": "4728059000",
            "name": "점촌3동"
          },
          {
            "code": "4728060000",
            "name": "점촌4동"
          },
          {
            "code": "4728061000",
            "name": "점촌5동"
          }
        ]
      },
      {
        "code": "47290",
        "name": "경산시",
        "sub": [
          {
            "code": "4729025000",
            "name": "하양읍"
          },
          {
            "code": "4729025300",
            "name": "진량읍"
          },
          {
            "code": "4729025600",
            "name": "압량읍"
          },
          {
            "code": "4729031000",
            "name": "와촌면"
          },
          {
            "code": "4729033000",
            "name": "자인면"
          },
          {
            "code": "4729034000",
            "name": "용성면"
          },
          {
            "code": "4729035000",
            "name": "남산면"
          },
          {
            "code": "4729037000",
            "name": "남천면"
          },
          {
            "code": "4729051000",
            "name": "중방동"
          },
          {
            "code": "4729052000",
            "name": "중앙동"
          },
          {
            "code": "4729053000",
            "name": "남부동"
          },
          {
            "code": "4729054100",
            "name": "서부1동"
          },
          {
            "code": "4729054200",
            "name": "서부2동"
          },
          {
            "code": "4729055000",
            "name": "북부동"
          },
          {
            "code": "4729056000",
            "name": "동부동"
          }
        ]
      },
      {
        "code": "47720",
        "name": "군위군",
        "sub": [
          {
            "code": "4772025000",
            "name": "군위읍"
          },
          {
            "code": "4772031000",
            "name": "소보면"
          },
          {
            "code": "4772032000",
            "name": "효령면"
          },
          {
            "code": "4772033000",
            "name": "부계면"
          },
          {
            "code": "4772034000",
            "name": "우보면"
          },
          {
            "code": "4772035000",
            "name": "의흥면"
          },
          {
            "code": "4772036000",
            "name": "산성면"
          },
          {
            "code": "4772038000",
            "name": "삼국유사면"
          }
        ]
      },
      {
        "code": "47730",
        "name": "의성군",
        "sub": [
          {
            "code": "4773025000",
            "name": "의성읍"
          },
          {
            "code": "4773031000",
            "name": "단촌면"
          },
          {
            "code": "4773032000",
            "name": "점곡면"
          },
          {
            "code": "4773033000",
            "name": "옥산면"
          },
          {
            "code": "4773034000",
            "name": "사곡면"
          },
          {
            "code": "4773035000",
            "name": "춘산면"
          },
          {
            "code": "4773036000",
            "name": "가음면"
          },
          {
            "code": "4773037000",
            "name": "금성면"
          },
          {
            "code": "4773038000",
            "name": "봉양면"
          },
          {
            "code": "4773039000",
            "name": "비안면"
          },
          {
            "code": "4773040000",
            "name": "구천면"
          },
          {
            "code": "4773041000",
            "name": "단밀면"
          },
          {
            "code": "4773042000",
            "name": "단북면"
          },
          {
            "code": "4773043000",
            "name": "안계면"
          },
          {
            "code": "4773044000",
            "name": "다인면"
          },
          {
            "code": "4773045000",
            "name": "신평면"
          },
          {
            "code": "4773046000",
            "name": "안평면"
          },
          {
            "code": "4773047000",
            "name": "안사면"
          }
        ]
      },
      {
        "code": "47750",
        "name": "청송군",
        "sub": [
          {
            "code": "4775025000",
            "name": "청송읍"
          },
          {
            "code": "4775031500",
            "name": "주왕산면"
          },
          {
            "code": "4775032000",
            "name": "부남면"
          },
          {
            "code": "4775033000",
            "name": "현동면"
          },
          {
            "code": "4775034000",
            "name": "현서면"
          },
          {
            "code": "4775035000",
            "name": "안덕면"
          },
          {
            "code": "4775036000",
            "name": "파천면"
          },
          {
            "code": "4775037000",
            "name": "진보면"
          }
        ]
      },
      {
        "code": "47760",
        "name": "영양군",
        "sub": [
          {
            "code": "4776025000",
            "name": "영양읍"
          },
          {
            "code": "4776031000",
            "name": "입암면"
          },
          {
            "code": "4776032000",
            "name": "청기면"
          },
          {
            "code": "4776033000",
            "name": "일월면"
          },
          {
            "code": "4776034000",
            "name": "수비면"
          },
          {
            "code": "4776035000",
            "name": "석보면"
          }
        ]
      },
      {
        "code": "47770",
        "name": "영덕군",
        "sub": [
          {
            "code": "4777025000",
            "name": "영덕읍"
          },
          {
            "code": "4777031000",
            "name": "강구면"
          },
          {
            "code": "4777032000",
            "name": "남정면"
          },
          {
            "code": "4777033000",
            "name": "달산면"
          },
          {
            "code": "4777034000",
            "name": "지품면"
          },
          {
            "code": "4777034500",
            "name": "지품면원전출장소"
          },
          {
            "code": "4777035000",
            "name": "축산면"
          },
          {
            "code": "4777035500",
            "name": "축산면축산출장소"
          },
          {
            "code": "4777036000",
            "name": "영해면"
          },
          {
            "code": "4777037000",
            "name": "병곡면"
          },
          {
            "code": "4777038000",
            "name": "창수면"
          }
        ]
      },
      {
        "code": "47820",
        "name": "청도군",
        "sub": [
          {
            "code": "4782025000",
            "name": "화양읍"
          },
          {
            "code": "4782025100",
            "name": "화양읍남성현출장소"
          },
          {
            "code": "4782025300",
            "name": "청도읍"
          },
          {
            "code": "4782025400",
            "name": "청도읍유호출장소"
          },
          {
            "code": "4782031000",
            "name": "각남면"
          },
          {
            "code": "4782032000",
            "name": "풍각면"
          },
          {
            "code": "4782033000",
            "name": "각북면"
          },
          {
            "code": "4782034000",
            "name": "이서면"
          },
          {
            "code": "4782035000",
            "name": "운문면"
          },
          {
            "code": "4782036000",
            "name": "금천면"
          },
          {
            "code": "4782037000",
            "name": "매전면"
          }
        ]
      },
      {
        "code": "47830",
        "name": "고령군",
        "sub": [
          {
            "code": "4783025300",
            "name": "대가야읍"
          },
          {
            "code": "4783031000",
            "name": "덕곡면"
          },
          {
            "code": "4783032000",
            "name": "운수면"
          },
          {
            "code": "4783033000",
            "name": "성산면"
          },
          {
            "code": "4783034000",
            "name": "다산면"
          },
          {
            "code": "4783035000",
            "name": "개진면"
          },
          {
            "code": "4783036000",
            "name": "우곡면"
          },
          {
            "code": "4783037000",
            "name": "쌍림면"
          }
        ]
      },
      {
        "code": "47840",
        "name": "성주군",
        "sub": [
          {
            "code": "4784025000",
            "name": "성주읍"
          },
          {
            "code": "4784031000",
            "name": "선남면"
          },
          {
            "code": "4784032000",
            "name": "용암면"
          },
          {
            "code": "4784033000",
            "name": "수륜면"
          },
          {
            "code": "4784034000",
            "name": "가천면"
          },
          {
            "code": "4784035000",
            "name": "금수면"
          },
          {
            "code": "4784036000",
            "name": "대가면"
          },
          {
            "code": "4784037000",
            "name": "벽진면"
          },
          {
            "code": "4784038000",
            "name": "초전면"
          },
          {
            "code": "4784039000",
            "name": "월항면"
          }
        ]
      },
      {
        "code": "47850",
        "name": "칠곡군",
        "sub": [
          {
            "code": "4785025000",
            "name": "왜관읍"
          },
          {
            "code": "4785025300",
            "name": "북삼읍"
          },
          {
            "code": "4785025600",
            "name": "석적읍"
          },
          {
            "code": "4785031000",
            "name": "지천면"
          },
          {
            "code": "4785032000",
            "name": "동명면"
          },
          {
            "code": "4785033000",
            "name": "가산면"
          },
          {
            "code": "4785036000",
            "name": "약목면"
          },
          {
            "code": "4785037000",
            "name": "기산면"
          }
        ]
      },
      {
        "code": "47900",
        "name": "예천군",
        "sub": [
          {
            "code": "4790025000",
            "name": "예천읍"
          },
          {
            "code": "4790031000",
            "name": "용문면"
          },
          {
            "code": "4790034000",
            "name": "감천면"
          },
          {
            "code": "4790035000",
            "name": "보문면"
          },
          {
            "code": "4790036000",
            "name": "호명면"
          },
          {
            "code": "4790037000",
            "name": "유천면"
          },
          {
            "code": "4790038000",
            "name": "용궁면"
          },
          {
            "code": "4790039000",
            "name": "개포면"
          },
          {
            "code": "4790040000",
            "name": "지보면"
          },
          {
            "code": "4790041000",
            "name": "풍양면"
          },
          {
            "code": "4790042000",
            "name": "효자면"
          },
          {
            "code": "4790043000",
            "name": "은풍면"
          }
        ]
      },
      {
        "code": "47920",
        "name": "봉화군",
        "sub": [
          {
            "code": "4792025000",
            "name": "봉화읍"
          },
          {
            "code": "4792031000",
            "name": "물야면"
          },
          {
            "code": "4792032000",
            "name": "봉성면"
          },
          {
            "code": "4792033000",
            "name": "법전면"
          },
          {
            "code": "4792034000",
            "name": "춘양면"
          },
          {
            "code": "4792035000",
            "name": "소천면"
          },
          {
            "code": "4792036000",
            "name": "재산면"
          },
          {
            "code": "4792037000",
            "name": "명호면"
          },
          {
            "code": "4792038000",
            "name": "상운면"
          },
          {
            "code": "4792039000",
            "name": "석포면"
          }
        ]
      },
      {
        "code": "47930",
        "name": "울진군",
        "sub": [
          {
            "code": "4793025000",
            "name": "울진읍"
          },
          {
            "code": "4793025300",
            "name": "평해읍"
          },
          {
            "code": "4793031000",
            "name": "북면"
          },
          {
            "code": "4793031500",
            "name": "북면하당출장소"
          },
          {
            "code": "4793033000",
            "name": "근남면"
          },
          {
            "code": "4793035000",
            "name": "기성면"
          },
          {
            "code": "4793036000",
            "name": "온정면"
          },
          {
            "code": "4793037000",
            "name": "죽변면"
          },
          {
            "code": "4793038000",
            "name": "후포면"
          },
          {
            "code": "4793039000",
            "name": "금강송면"
          },
          {
            "code": "4793040000",
            "name": "매화면"
          }
        ]
      },
      {
        "code": "47940",
        "name": "울릉군",
        "sub": [
          {
            "code": "4794025000",
            "name": "울릉읍"
          },
          {
            "code": "4794031000",
            "name": "서면"
          },
          {
            "code": "4794031500",
            "name": "서면태하출장소"
          },
          {
            "code": "4794032000",
            "name": "북면"
          }
        ]
      }
    ]
  },
  {
    "code": "48",
    "name": "경상남도",
    "sub": [
      {
        "code": "48121",
        "name": "창원시 의창구",
        "sub": [
          {
            "code": "4812125000",
            "name": "동읍"
          },
          {
            "code": "4812131000",
            "name": "북면"
          },
          {
            "code": "4812132000",
            "name": "대산면"
          },
          {
            "code": "4812151000",
            "name": "의창동"
          },
          {
            "code": "4812152000",
            "name": "팔룡동"
          },
          {
            "code": "4812153000",
            "name": "명곡동"
          },
          {
            "code": "4812154000",
            "name": "봉림동"
          }
        ]
      },
      {
        "code": "48123",
        "name": "창원시 성산구",
        "sub": [
          {
            "code": "4812351000",
            "name": "반송동"
          },
          {
            "code": "4812351500",
            "name": "용지동"
          },
          {
            "code": "4812352000",
            "name": "중앙동"
          },
          {
            "code": "4812353000",
            "name": "상남동"
          },
          {
            "code": "4812354000",
            "name": "사파동"
          },
          {
            "code": "4812355000",
            "name": "가음정동"
          },
          {
            "code": "4812356000",
            "name": "성주동"
          },
          {
            "code": "4812357000",
            "name": "웅남동"
          }
        ]
      },
      {
        "code": "48125",
        "name": "창원시 마산합포구",
        "sub": [
          {
            "code": "4812531000",
            "name": "구산면"
          },
          {
            "code": "4812532000",
            "name": "진동면"
          },
          {
            "code": "4812533000",
            "name": "진북면"
          },
          {
            "code": "4812534000",
            "name": "진전면"
          },
          {
            "code": "4812551000",
            "name": "현동"
          },
          {
            "code": "4812552000",
            "name": "가포동"
          },
          {
            "code": "4812553000",
            "name": "월영동"
          },
          {
            "code": "4812554000",
            "name": "문화동"
          },
          {
            "code": "4812556500",
            "name": "반월중앙동"
          },
          {
            "code": "4812557000",
            "name": "완월동"
          },
          {
            "code": "4812558000",
            "name": "자산동"
          },
          {
            "code": "4812561000",
            "name": "교방동"
          },
          {
            "code": "4812563000",
            "name": "오동동"
          },
          {
            "code": "4812564000",
            "name": "합포동"
          },
          {
            "code": "4812565000",
            "name": "산호동"
          }
        ]
      },
      {
        "code": "48127",
        "name": "창원시 마산회원구",
        "sub": [
          {
            "code": "4812725000",
            "name": "내서읍"
          },
          {
            "code": "4812751000",
            "name": "회원1동"
          },
          {
            "code": "4812752000",
            "name": "회원2동"
          },
          {
            "code": "4812754500",
            "name": "석전동"
          },
          {
            "code": "4812755000",
            "name": "회성동"
          },
          {
            "code": "4812756000",
            "name": "양덕1동"
          },
          {
            "code": "4812757000",
            "name": "양덕2동"
          },
          {
            "code": "4812758000",
            "name": "합성1동"
          },
          {
            "code": "4812759000",
            "name": "합성2동"
          },
          {
            "code": "4812760000",
            "name": "구암1동"
          },
          {
            "code": "4812761000",
            "name": "구암2동"
          },
          {
            "code": "4812762000",
            "name": "봉암동"
          }
        ]
      },
      {
        "code": "48129",
        "name": "창원시 진해구",
        "sub": [
          {
            "code": "4812953000",
            "name": "충무동"
          },
          {
            "code": "4812954000",
            "name": "여좌동"
          },
          {
            "code": "4812955000",
            "name": "태백동"
          },
          {
            "code": "4812956000",
            "name": "경화동"
          },
          {
            "code": "4812957000",
            "name": "병암동"
          },
          {
            "code": "4812958000",
            "name": "석동"
          },
          {
            "code": "4812959000",
            "name": "이동"
          },
          {
            "code": "4812960000",
            "name": "자은동"
          },
          {
            "code": "4812961000",
            "name": "덕산동"
          },
          {
            "code": "4812962000",
            "name": "풍호동"
          },
          {
            "code": "4812963000",
            "name": "웅천동"
          },
          {
            "code": "4812964000",
            "name": "웅동1동"
          },
          {
            "code": "4812965000",
            "name": "웅동2동"
          }
        ]
      },
      {
        "code": "48170",
        "name": "진주시",
        "sub": [
          {
            "code": "4817025000",
            "name": "문산읍"
          },
          {
            "code": "4817031000",
            "name": "내동면"
          },
          {
            "code": "4817032000",
            "name": "정촌면"
          },
          {
            "code": "4817033000",
            "name": "금곡면"
          },
          {
            "code": "4817035000",
            "name": "진성면"
          },
          {
            "code": "4817036000",
            "name": "일반성면"
          },
          {
            "code": "4817037000",
            "name": "이반성면"
          },
          {
            "code": "4817038000",
            "name": "사봉면"
          },
          {
            "code": "4817039000",
            "name": "지수면"
          },
          {
            "code": "4817040000",
            "name": "대곡면"
          },
          {
            "code": "4817041000",
            "name": "금산면"
          },
          {
            "code": "4817042000",
            "name": "집현면"
          },
          {
            "code": "4817043000",
            "name": "미천면"
          },
          {
            "code": "4817044000",
            "name": "명석면"
          },
          {
            "code": "4817045000",
            "name": "대평면"
          },
          {
            "code": "4817046000",
            "name": "수곡면"
          },
          {
            "code": "4817051500",
            "name": "천전동"
          },
          {
            "code": "4817055500",
            "name": "성북동"
          },
          {
            "code": "4817056500",
            "name": "중앙동"
          },
          {
            "code": "4817059500",
            "name": "상봉동"
          },
          {
            "code": "4817067300",
            "name": "상대동"
          },
          {
            "code": "4817067800",
            "name": "하대동"
          },
          {
            "code": "4817068000",
            "name": "상평동"
          },
          {
            "code": "4817069500",
            "name": "초장동"
          },
          {
            "code": "4817071000",
            "name": "평거동"
          },
          {
            "code": "4817071500",
            "name": "신안동"
          },
          {
            "code": "4817072000",
            "name": "이현동"
          },
          {
            "code": "4817073000",
            "name": "판문동"
          },
          {
            "code": "4817074000",
            "name": "가호동"
          },
          {
            "code": "4817075000",
            "name": "충무공동"
          }
        ]
      },
      {
        "code": "48220",
        "name": "통영시",
        "sub": [
          {
            "code": "4822025000",
            "name": "산양읍"
          },
          {
            "code": "4822031000",
            "name": "용남면"
          },
          {
            "code": "4822033000",
            "name": "도산면"
          },
          {
            "code": "4822034000",
            "name": "광도면"
          },
          {
            "code": "4822035000",
            "name": "욕지면"
          },
          {
            "code": "4822036000",
            "name": "한산면"
          },
          {
            "code": "4822037000",
            "name": "사량면"
          },
          {
            "code": "4822051000",
            "name": "도천동"
          },
          {
            "code": "4822053000",
            "name": "명정동"
          },
          {
            "code": "4822055000",
            "name": "중앙동"
          },
          {
            "code": "4822059000",
            "name": "정량동"
          },
          {
            "code": "4822060000",
            "name": "북신동"
          },
          {
            "code": "4822066500",
            "name": "미수동"
          },
          {
            "code": "4822067000",
            "name": "봉평동"
          },
          {
            "code": "4822070000",
            "name": "무전동"
          }
        ]
      },
      {
        "code": "48240",
        "name": "사천시",
        "sub": [
          {
            "code": "4824025000",
            "name": "사천읍"
          },
          {
            "code": "4824031000",
            "name": "정동면"
          },
          {
            "code": "4824032000",
            "name": "사남면"
          },
          {
            "code": "4824033000",
            "name": "용현면"
          },
          {
            "code": "4824034000",
            "name": "축동면"
          },
          {
            "code": "4824035000",
            "name": "곤양면"
          },
          {
            "code": "4824036000",
            "name": "곤명면"
          },
          {
            "code": "4824037000",
            "name": "서포면"
          },
          {
            "code": "4824051000",
            "name": "동서동"
          },
          {
            "code": "4824052000",
            "name": "선구동"
          },
          {
            "code": "4824053000",
            "name": "동서금동"
          },
          {
            "code": "4824055000",
            "name": "벌용동"
          },
          {
            "code": "4824057000",
            "name": "향촌동"
          },
          {
            "code": "4824059500",
            "name": "남양동"
          },
          {
            "code": "4824089000",
            "name": "신수출장소"
          }
        ]
      },
      {
        "code": "48250",
        "name": "김해시",
        "sub": [
          {
            "code": "4825025000",
            "name": "진영읍"
          },
          {
            "code": "4825032000",
            "name": "주촌면"
          },
          {
            "code": "4825033000",
            "name": "진례면"
          },
          {
            "code": "4825034000",
            "name": "한림면"
          },
          {
            "code": "4825035000",
            "name": "생림면"
          },
          {
            "code": "4825036000",
            "name": "상동면"
          },
          {
            "code": "4825037000",
            "name": "대동면"
          },
          {
            "code": "4825051000",
            "name": "동상동"
          },
          {
            "code": "4825052000",
            "name": "회현동"
          },
          {
            "code": "4825053000",
            "name": "부원동"
          },
          {
            "code": "4825054000",
            "name": "내외동"
          },
          {
            "code": "4825055000",
            "name": "북부동"
          },
          {
            "code": "4825056500",
            "name": "칠산서부동"
          },
          {
            "code": "4825058000",
            "name": "활천동"
          },
          {
            "code": "4825059000",
            "name": "삼안동"
          },
          {
            "code": "4825060000",
            "name": "불암동"
          },
          {
            "code": "4825061000",
            "name": "장유1동"
          },
          {
            "code": "4825062000",
            "name": "장유2동"
          },
          {
            "code": "4825063000",
            "name": "장유3동"
          }
        ]
      },
      {
        "code": "48270",
        "name": "밀양시",
        "sub": [
          {
            "code": "4827025000",
            "name": "삼랑진읍"
          },
          {
            "code": "4827025100",
            "name": "삼랑진임천출장소"
          },
          {
            "code": "4827025300",
            "name": "하남읍"
          },
          {
            "code": "4827031000",
            "name": "부북면"
          },
          {
            "code": "4827032000",
            "name": "상동면"
          },
          {
            "code": "4827033000",
            "name": "산외면"
          },
          {
            "code": "4827034000",
            "name": "산내면"
          },
          {
            "code": "4827035000",
            "name": "단장면"
          },
          {
            "code": "4827036000",
            "name": "상남면"
          },
          {
            "code": "4827037000",
            "name": "초동면"
          },
          {
            "code": "4827038000",
            "name": "무안면"
          },
          {
            "code": "4827039000",
            "name": "청도면"
          },
          {
            "code": "4827051000",
            "name": "내일동"
          },
          {
            "code": "4827052000",
            "name": "내이동"
          },
          {
            "code": "4827053000",
            "name": "삼문동"
          },
          {
            "code": "4827054000",
            "name": "가곡동"
          },
          {
            "code": "4827055000",
            "name": "교동"
          }
        ]
      },
      {
        "code": "48310",
        "name": "거제시",
        "sub": [
          {
            "code": "4831031000",
            "name": "일운면"
          },
          {
            "code": "4831032000",
            "name": "동부면"
          },
          {
            "code": "4831033000",
            "name": "남부면"
          },
          {
            "code": "4831034000",
            "name": "거제면"
          },
          {
            "code": "4831035000",
            "name": "둔덕면"
          },
          {
            "code": "4831036000",
            "name": "사등면"
          },
          {
            "code": "4831036600",
            "name": "사등면가조출장소"
          },
          {
            "code": "4831037000",
            "name": "연초면"
          },
          {
            "code": "4831038000",
            "name": "하청면"
          },
          {
            "code": "4831038500",
            "name": "하청면칠천출장소"
          },
          {
            "code": "4831039000",
            "name": "장목면"
          },
          {
            "code": "4831039500",
            "name": "장목면외포출장소"
          },
          {
            "code": "4831051000",
            "name": "장승포동"
          },
          {
            "code": "4831053000",
            "name": "능포동"
          },
          {
            "code": "4831054000",
            "name": "아주동"
          },
          {
            "code": "4831055000",
            "name": "옥포1동"
          },
          {
            "code": "4831056000",
            "name": "옥포2동"
          },
          {
            "code": "4831057000",
            "name": "장평동"
          },
          {
            "code": "4831058000",
            "name": "고현동"
          },
          {
            "code": "4831059000",
            "name": "상문동"
          },
          {
            "code": "4831060000",
            "name": "수양동"
          }
        ]
      },
      {
        "code": "48330",
        "name": "양산시",
        "sub": [
          {
            "code": "4833025300",
            "name": "물금읍"
          },
          {
            "code": "4833031000",
            "name": "동면"
          },
          {
            "code": "4833032000",
            "name": "원동면"
          },
          {
            "code": "4833033000",
            "name": "상북면"
          },
          {
            "code": "4833034000",
            "name": "하북면"
          },
          {
            "code": "4833051000",
            "name": "중앙동"
          },
          {
            "code": "4833051500",
            "name": "양주동"
          },
          {
            "code": "4833052000",
            "name": "삼성동"
          },
          {
            "code": "4833053000",
            "name": "강서동"
          },
          {
            "code": "4833054000",
            "name": "서창동"
          },
          {
            "code": "4833055000",
            "name": "소주동"
          },
          {
            "code": "4833056000",
            "name": "평산동"
          },
          {
            "code": "4833057000",
            "name": "덕계동"
          }
        ]
      },
      {
        "code": "48720",
        "name": "의령군",
        "sub": [
          {
            "code": "4872025000",
            "name": "의령읍"
          },
          {
            "code": "4872031000",
            "name": "가례면"
          },
          {
            "code": "4872032000",
            "name": "칠곡면"
          },
          {
            "code": "4872033000",
            "name": "대의면"
          },
          {
            "code": "4872034000",
            "name": "화정면"
          },
          {
            "code": "4872035000",
            "name": "용덕면"
          },
          {
            "code": "4872036000",
            "name": "정곡면"
          },
          {
            "code": "4872037000",
            "name": "지정면"
          },
          {
            "code": "4872038000",
            "name": "낙서면"
          },
          {
            "code": "4872039000",
            "name": "부림면"
          },
          {
            "code": "4872040000",
            "name": "봉수면"
          },
          {
            "code": "4872041500",
            "name": "궁류면"
          },
          {
            "code": "4872042000",
            "name": "유곡면"
          }
        ]
      },
      {
        "code": "48730",
        "name": "함안군",
        "sub": [
          {
            "code": "4873025000",
            "name": "가야읍"
          },
          {
            "code": "4873025300",
            "name": "칠원읍"
          },
          {
            "code": "4873031000",
            "name": "함안면"
          },
          {
            "code": "4873032000",
            "name": "군북면"
          },
          {
            "code": "4873033000",
            "name": "법수면"
          },
          {
            "code": "4873034000",
            "name": "대산면"
          },
          {
            "code": "4873035000",
            "name": "칠서면"
          },
          {
            "code": "4873036000",
            "name": "칠북면"
          },
          {
            "code": "4873038000",
            "name": "산인면"
          },
          {
            "code": "4873039000",
            "name": "여항면"
          }
        ]
      },
      {
        "code": "48740",
        "name": "창녕군",
        "sub": [
          {
            "code": "4874025000",
            "name": "창녕읍"
          },
          {
            "code": "4874025300",
            "name": "남지읍"
          },
          {
            "code": "4874031000",
            "name": "고암면"
          },
          {
            "code": "4874032000",
            "name": "성산면"
          },
          {
            "code": "4874033000",
            "name": "대합면"
          },
          {
            "code": "4874034000",
            "name": "이방면"
          },
          {
            "code": "4874035000",
            "name": "유어면"
          },
          {
            "code": "4874036000",
            "name": "대지면"
          },
          {
            "code": "4874037000",
            "name": "계성면"
          },
          {
            "code": "4874038000",
            "name": "영산면"
          },
          {
            "code": "4874039000",
            "name": "장마면"
          },
          {
            "code": "4874040000",
            "name": "도천면"
          },
          {
            "code": "4874041000",
            "name": "길곡면"
          },
          {
            "code": "4874042000",
            "name": "부곡면"
          }
        ]
      },
      {
        "code": "48820",
        "name": "고성군",
        "sub": [
          {
            "code": "4882025000",
            "name": "고성읍"
          },
          {
            "code": "4882031000",
            "name": "삼산면"
          },
          {
            "code": "4882032000",
            "name": "하일면"
          },
          {
            "code": "4882033000",
            "name": "하이면"
          },
          {
            "code": "4882034000",
            "name": "상리면"
          },
          {
            "code": "4882035000",
            "name": "대가면"
          },
          {
            "code": "4882036000",
            "name": "영현면"
          },
          {
            "code": "4882037000",
            "name": "영오면"
          },
          {
            "code": "4882038000",
            "name": "개천면"
          },
          {
            "code": "4882039000",
            "name": "구만면"
          },
          {
            "code": "4882040000",
            "name": "회화면"
          },
          {
            "code": "4882041000",
            "name": "마암면"
          },
          {
            "code": "4882042000",
            "name": "동해면"
          },
          {
            "code": "4882043000",
            "name": "거류면"
          }
        ]
      },
      {
        "code": "48840",
        "name": "남해군",
        "sub": [
          {
            "code": "4884025000",
            "name": "남해읍"
          },
          {
            "code": "4884031000",
            "name": "이동면"
          },
          {
            "code": "4884032000",
            "name": "상주면"
          },
          {
            "code": "4884033000",
            "name": "삼동면"
          },
          {
            "code": "4884034000",
            "name": "미조면"
          },
          {
            "code": "4884035000",
            "name": "남면"
          },
          {
            "code": "4884036000",
            "name": "서면"
          },
          {
            "code": "4884037000",
            "name": "고현면"
          },
          {
            "code": "4884038000",
            "name": "설천면"
          },
          {
            "code": "4884039000",
            "name": "창선면"
          }
        ]
      },
      {
        "code": "48850",
        "name": "하동군",
        "sub": [
          {
            "code": "4885025000",
            "name": "하동읍"
          },
          {
            "code": "4885031000",
            "name": "화개면"
          },
          {
            "code": "4885032000",
            "name": "악양면"
          },
          {
            "code": "4885033000",
            "name": "적량면"
          },
          {
            "code": "4885034000",
            "name": "횡천면"
          },
          {
            "code": "4885035000",
            "name": "고전면"
          },
          {
            "code": "4885036000",
            "name": "금남면"
          },
          {
            "code": "4885037000",
            "name": "진교면"
          },
          {
            "code": "4885038000",
            "name": "양보면"
          },
          {
            "code": "4885039000",
            "name": "북천면"
          },
          {
            "code": "4885040000",
            "name": "청암면"
          },
          {
            "code": "4885041000",
            "name": "옥종면"
          },
          {
            "code": "4885042000",
            "name": "금성면"
          }
        ]
      },
      {
        "code": "48860",
        "name": "산청군",
        "sub": [
          {
            "code": "4886025000",
            "name": "산청읍"
          },
          {
            "code": "4886031000",
            "name": "차황면"
          },
          {
            "code": "4886032000",
            "name": "오부면"
          },
          {
            "code": "4886033000",
            "name": "생초면"
          },
          {
            "code": "4886034000",
            "name": "금서면"
          },
          {
            "code": "4886035000",
            "name": "삼장면"
          },
          {
            "code": "4886036000",
            "name": "시천면"
          },
          {
            "code": "4886037000",
            "name": "단성면"
          },
          {
            "code": "4886038000",
            "name": "신안면"
          },
          {
            "code": "4886039000",
            "name": "생비량면"
          },
          {
            "code": "4886040000",
            "name": "신등면"
          }
        ]
      },
      {
        "code": "48870",
        "name": "함양군",
        "sub": [
          {
            "code": "4887025000",
            "name": "함양읍"
          },
          {
            "code": "4887031000",
            "name": "마천면"
          },
          {
            "code": "4887032000",
            "name": "휴천면"
          },
          {
            "code": "4887033000",
            "name": "유림면"
          },
          {
            "code": "4887034000",
            "name": "수동면"
          },
          {
            "code": "4887035000",
            "name": "지곡면"
          },
          {
            "code": "4887036000",
            "name": "안의면"
          },
          {
            "code": "4887037000",
            "name": "서하면"
          },
          {
            "code": "4887038000",
            "name": "서상면"
          },
          {
            "code": "4887039000",
            "name": "백전면"
          },
          {
            "code": "4887040000",
            "name": "병곡면"
          }
        ]
      },
      {
        "code": "48880",
        "name": "거창군",
        "sub": [
          {
            "code": "4888025000",
            "name": "거창읍"
          },
          {
            "code": "4888031000",
            "name": "주상면"
          },
          {
            "code": "4888032000",
            "name": "웅양면"
          },
          {
            "code": "4888033000",
            "name": "고제면"
          },
          {
            "code": "4888034000",
            "name": "북상면"
          },
          {
            "code": "4888035000",
            "name": "위천면"
          },
          {
            "code": "4888036000",
            "name": "마리면"
          },
          {
            "code": "4888037000",
            "name": "남상면"
          },
          {
            "code": "4888038000",
            "name": "남하면"
          },
          {
            "code": "4888039000",
            "name": "신원면"
          },
          {
            "code": "4888040000",
            "name": "가조면"
          },
          {
            "code": "4888041000",
            "name": "가북면"
          }
        ]
      },
      {
        "code": "48890",
        "name": "합천군",
        "sub": [
          {
            "code": "4889025000",
            "name": "합천읍"
          },
          {
            "code": "4889031000",
            "name": "봉산면"
          },
          {
            "code": "4889032000",
            "name": "묘산면"
          },
          {
            "code": "4889033000",
            "name": "가야면"
          },
          {
            "code": "4889034000",
            "name": "야로면"
          },
          {
            "code": "4889035000",
            "name": "율곡면"
          },
          {
            "code": "4889036000",
            "name": "초계면"
          },
          {
            "code": "4889037000",
            "name": "쌍책면"
          },
          {
            "code": "4889038000",
            "name": "덕곡면"
          },
          {
            "code": "4889039000",
            "name": "청덕면"
          },
          {
            "code": "4889040000",
            "name": "적중면"
          },
          {
            "code": "4889041000",
            "name": "대양면"
          },
          {
            "code": "4889042000",
            "name": "쌍백면"
          },
          {
            "code": "4889043000",
            "name": "삼가면"
          },
          {
            "code": "4889044000",
            "name": "가회면"
          },
          {
            "code": "4889045000",
            "name": "대병면"
          },
          {
            "code": "4889046000",
            "name": "용주면"
          }
        ]
      }
    ]
  },
  {
    "code": "50",
    "name": "제주특별자치도",
    "sub": [
      {
        "code": "50110",
        "name": "제주시",
        "sub": [
          {
            "code": "5011025000",
            "name": "한림읍"
          },
          {
            "code": "5011025300",
            "name": "애월읍"
          },
          {
            "code": "5011025600",
            "name": "구좌읍"
          },
          {
            "code": "5011025900",
            "name": "조천읍"
          },
          {
            "code": "5011031000",
            "name": "한경면"
          },
          {
            "code": "5011032000",
            "name": "추자면"
          },
          {
            "code": "5011033000",
            "name": "우도면"
          },
          {
            "code": "5011051000",
            "name": "일도1동"
          },
          {
            "code": "5011052000",
            "name": "일도2동"
          },
          {
            "code": "5011053000",
            "name": "이도1동"
          },
          {
            "code": "5011054000",
            "name": "이도2동"
          },
          {
            "code": "5011055000",
            "name": "삼도1동"
          },
          {
            "code": "5011056000",
            "name": "삼도2동"
          },
          {
            "code": "5011057000",
            "name": "용담1동"
          },
          {
            "code": "5011058000",
            "name": "용담2동"
          },
          {
            "code": "5011059000",
            "name": "건입동"
          },
          {
            "code": "5011060000",
            "name": "화북동"
          },
          {
            "code": "5011061000",
            "name": "삼양동"
          },
          {
            "code": "5011062000",
            "name": "봉개동"
          },
          {
            "code": "5011063000",
            "name": "아라동"
          },
          {
            "code": "5011064000",
            "name": "오라동"
          },
          {
            "code": "5011065000",
            "name": "연동"
          },
          {
            "code": "5011066000",
            "name": "노형동"
          },
          {
            "code": "5011067000",
            "name": "외도동"
          },
          {
            "code": "5011068000",
            "name": "이호동"
          },
          {
            "code": "5011069000",
            "name": "도두동"
          }
        ]
      },
      {
        "code": "50130",
        "name": "서귀포시",
        "sub": [
          {
            "code": "5013025000",
            "name": "대정읍"
          },
          {
            "code": "5013025300",
            "name": "남원읍"
          },
          {
            "code": "5013025900",
            "name": "성산읍"
          },
          {
            "code": "5013031000",
            "name": "안덕면"
          },
          {
            "code": "5013032000",
            "name": "표선면"
          },
          {
            "code": "5013051000",
            "name": "송산동"
          },
          {
            "code": "5013052000",
            "name": "정방동"
          },
          {
            "code": "5013053000",
            "name": "중앙동"
          },
          {
            "code": "5013054000",
            "name": "천지동"
          },
          {
            "code": "5013055000",
            "name": "효돈동"
          },
          {
            "code": "5013056000",
            "name": "영천동"
          },
          {
            "code": "5013057000",
            "name": "동홍동"
          },
          {
            "code": "5013058000",
            "name": "서홍동"
          },
          {
            "code": "5013059000",
            "name": "대륜동"
          },
          {
            "code": "5013060000",
            "name": "대천동"
          },
          {
            "code": "5013061000",
            "name": "중문동"
          },
          {
            "code": "5013062000",
            "name": "예래동"
          }
        ]
      }
    ]
  }
];


